// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/home-show13.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/images/smart20.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/images/home-show4.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/images/home-show5.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/images/arrow.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.wp-block-columns.is-layout-flex) {
  gap: 2em;
}

a {
  color: #007ca1;
}

.uk-h1,
h1 {
  font-size: 37.4px;
  line-height: 1;
  /* font-family: Urbanist; */
  font-weight: 500;
  letter-spacing: 1px;
}
.uk-h2,
h2 {
  font-size: 32.3px;
  line-height: 1;
  /* font-family: Urbanist; */
  font-weight: 500;
  letter-spacing: 1px;
}
.uk-h3,
h3 {
  font-size: 30px;
  line-height: 1;
  /* font-family: Urbanist; */
  font-weight: 500;
}
.uk-h4,
h4 {
  font-size: 26px;
  line-height: 1;
  /* font-family: Urbanist; */
  text-transform: uppercase;
}
.uk-h5,
h5 {
  font-size: 20px;
  line-height: 1;
  /* font-family: Urbanist; */
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.uk-h6,
h6 {
  font-size: 16.5px;
  line-height: 1;
  /* font-family: Urbanist; */
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.uk-hr,
hr {
  overflow: visible;
  text-align: inherit;
  margin: 0 0 30px 0;
  border: 0;
  border-top: 1px solid #e5e5e5;
}
.uk-divider-small::after {
  content: "";
  display: inline-block;
  width: 54px;
  max-width: 100%;
  border-top: 3px solid #007ca1;
  vertical-align: top;
  border-top-color: #007ca1 !important;
}
button,
.button,
.faux-button,
input[type="button"],
input[type="reset"],
input[type="submit"] {
  background-color: #007ca1;
}

body,
.entry-title a {
  color: #000000;
}
figcaption .post-meta,
hr.styled-separator {
  color: #6d6d6d;
}

pre,
fieldset,
input,
textarea,
table,
table *,
hr {
  border-color: #dcd7ca;
}
samp {
  background-color: #dcd7ca;
}

.modal-menu a,
.footer-widgets a {
  color: #007ca1;
}

.nav-drawer {
  width: 448px !important;
}

.header-footer-group,
.menu-modal .toggle {
  color: #000000;
}

.menu-modal .close-drawer {
  background-color: #444;
}
.menu-modal .close-drawer i {
  color: #fff;
  font-size: 26px;
  padding-right: 25px;
}

.widget .post-date,
.widget .rss-date,
.powered-by-wordpress,
.to-the-top {
  color: #6d6d6d;
}
.header-footer-group pre,
.header-footer-group fieldset,
.header-footer-group input,
.header-footer-group textarea,
.header-footer-group table,
.header-footer-group table *,
.menu-modal nav *,
.footer-widgets-outer-wrapper {
  border-color: #dcd7ca;
}
.header-footer-group table caption {
  background-color: #dcd7ca;
}

.primary-menu ul a {
  color: #fff !important;
}

img.wp-smiley,
img.emoji {
  display: inline !important;
  border: none !important;
  box-shadow: none !important;
  height: 1em !important;
  width: 1em !important;
  margin: 0 0.07em !important;
  vertical-align: -0.1em !important;
  background-color: none !important;
  padding: 0 !important;
}

.widget .post-date,
.widget .rss-date,
.powered-by-wordpress,
.to-the-top {
  color: #fff;
}

a:link,
a:visited {
  color: #333;
}

.primary-menu ul a {
  color: #fff !important;
}

html {
  margin-top: 0px !important;
}
#wpadminbar {
  display: none;
}

body {
  font-family: Roboto !important;
  background-color: transparent;
}
.fa,
.fas {
  font-weight: 900;
  line-height: 24px;
  float: left;
  padding-right: 15px;
  clear: left;
}
a:link,
a:visited {
  text-decoration: none;
}
.entry-content {
  font-family: roboto;
  font-size: 0px;
}
.post-inner {
  padding-top: 0rem;
}

.modal-menu a,
.footer-widgets a {
  color: #5e676a;
}

.primary-menu a:hover,
.primary-menu a:focus {
  text-decoration: none;
  color: #58c7f1 !important;
}

.primary-menu a {
  font-size: 12px;
  font-family: Work Sans;
  transition: 0.1s ease-in-out;
  transition-property: color, background-color, border-color, box-shadow;
  position: relative;
  z-index: 1;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.header-navigation-wrapper .primary-menu ul.sub-menu {
  background-color: #17191a;
  background-color: rgba(23, 25, 26, 0.65);
}
.primary-menu > li > .icon {
  color: #cccccc !important;
  top: calc(50% - 0.6rem);
}
.primary-menu .icon::before {
  height: 0.65rem;
  width: 0.2rem;
}
.primary-menu .icon::after {
  height: 0.2rem;
  width: 0.65rem;
}

/*Header Sticky Navigation*/
.header-footer-group,
.menu-modal .toggle {
  color: #575555;
  z-index: 11;
}
#site-header-sticky-wrapper {
  position: absolute;
  width: 100%;
  top: 0px;
}
.is-sticky {
  z-index: 2;
}
.is-sticky #site-header { /* Safari */ /* Safari */
  transition: margin 0.5s ease-in-out;
  z-index: 1 !important;
  position: absolute !important;
}
/* .is-sticky #site-header {
  margin-top: -201px !important;
  background-color: rgba(23, 25, 26, 0.65) !important;
} */
.is-sticky #site-header.topscroll {
  margin-top: 0px !important;
  position: fixed !important;
}
.is-sticky .goingupz-index.topscroll ul li a {
  color: #fff !important;
}
.is-sticky .goingup#site-header.topscroll ul li a:hover {
  color: #58c7f1 !important;
}
.show-modal.active .ancestor-wrapper a {
  color: #444 !important;
  font-size: 16px;
  font-weight: 300;
}
.menu-modal nav * {
  border-color: #dedfdf;
}

.site-logo img {
  max-height: 8rem;
}
#site-header {
  background-color: #fff;
  position: absolute;
  width: 100%;
}

li.menu-item-3288 {
  position: absolute;
  margin-top: -27px;
}
li.menu-item-3288 a {
  display: flex;
  align-items: center;
}
li.menu-item-3288 .fas {
  padding-right: 10px;
  margin-top: 0px;
}

.wp-block-group.homevideo {
  width: 100% !important;
  max-width: 100vw !important;
  height: 100vh;
  margin: 0px !important;
  margin-top: 115px !important;
}
.wp-block-group.homevideo > .wp-block-group__inner-container {
  width: 100vw !important;
  max-width: 100vw !important;
  height: 100vh;
  margin: 0px !important;
  background-color: rgba(0, 0, 0, 0.05);
  position: relative;
}
.about .wp-block-group.homevideo > .wp-block-group__inner-container {
  width: 100% !important;
}
.about .interest .is-layout-flow.wp-block-column p a {
  color: #fff !important;
}
.about .interest .is-layout-flow.wp-block-column p a:hover {
  color: #58c7f1 !important;
}
.contact-us-page .wp-block-group.homevideo > .wp-block-group__inner-container {
  width: auto !important;
}
#video-background {
  position: absolute;
  left: 50%;
  top: 50%;
  min-width: 101%;
  min-height: 100%;
  width: auto !important;
  z-index: -100;
  max-width: none;
  height: auto !important;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.homeintrotop {
  position: absolute;
  left: 0px;
  bottom: 10vh;
  background-color: rgba(23, 25, 26, 0.85);
  margin: 0px !important;
  padding: 45px 40px 45px;
  font-size: 16px;
  font-family: roboto;
}
.home .homeintrotop {
  right: 0px;
  left: inherit;
  bottom: 0px;
}
.homeintrotop p {
  float: left;
  max-width: none !important;
  width: auto !important;
  font-weight: 300;
}
.homeintrotop .fas {
  float: left;
  max-width: none !important;
  width: auto !important;
  color: #007ca1;
}
.homeintrotop h1 {
  width: 100%;
  font-size: 32px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #58c7f1;
  margin: 15px 0px 0px;
}
.minigray {
  color: #666;
  font-size: 16px;
  font-weight: 300;
}

.home .homeintrotop .wp-block-group__inner-container > p {
  font-size: 18px;
}
.homenumber {
  margin-bottom: 45px;
}
.home .homeintrotop.centerintro h1 {
  margin-bottom: 15px;
}

/*SERVICES PAGES TOP */
.wp-block-group.homevideo.servicespages {
  height: 100vh;
}
.wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {
  height: 100vh;
}
.homeintrotop.centerintro {
  bottom: 0px;
  max-width: 100% !important;
  background-color: transparent;
  padding: 45px 30px 0px;
  margin: 0px auto !important;
  left: inherit;
  right: 0px;
}
.homeintrotop.centerintro h1 {
  max-width: 100% !important;
  float: none;
  text-align: center;
  font-weight: 300;
  color: #fff;
  margin-bottom: 45px;
  text-shadow: #747474 0.05em 0.05em 0.1em;
}
.servicessubs {
  width: 100% !important;
  max-width: 100% !important;
  padding: 60px 0px 50px;
  background-color: transparent;
  margin: 0px !important;
  display: block;
  text-align: center;
}
.servicessubs .wp-block-group__inner-container p {
  text-align: center;
  display: inline-block;
  float: none;
}
.servicessubs a {
  display: inline-block;
  border: 1px solid #aaa;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 300;
  color: #fff !important;
  font-size: 14px;
  margin: 0px 15px;
  text-transform: uppercase;
  background-color: #222;
  background-color: rgba(0, 0, 0, 0.35);
}
.servicessubs a:hover {
  background-color: rgba(0, 0, 0, 0.6) !important;
  color: #fff !important;
}

.pointsmade {
  clear: both;
  text-align: left;
  color: #747474;
  font-weight: 300;
  font-size: 16px;
  max-width: 100% !important;
  margin: 0px 0px 15px !important;
}
.pointsmade.homeauto:before {
  font-family: "Font Awesome 5 Free";
  content: "\\f058";
  color: #007ca1;
  font-weight: 300;
  font-style: normal;
  display: inline-block;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  text-decoration: inherit;
  margin-right: 10px;
  display: none;
}
.servicesleader {
  margin: 0px !important;
  padding: 60px 30px 0px !important;
  background-color: #fafafa;
  max-width: 100% !important;
  width: 100% !important;
}
.serviceswhitebackground {
  margin: 0px !important;
  padding: 90px 30px 60px !important;
  background-color: #fafafa;
  background-image: none;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
  position: relative;
}
.serviceswhitebackground p {
  max-width: 900px !important;
  width: 100% !important;
  color: #666;
  font-size: 16px;
  font-weight: 300;
  margin: 0px auto !important;
  padding: 0px 30px 30px !important;
}

.serviceswhitebackground .brandscolumn p.partnername {
  margin-bottom: -1px !important;
  text-align: center;
  font-size: 21px;
  font-weight: 300;
  color: #007ca1;
  line-height: 1;
  margin-top: 10px !important;
  padding-bottom: 0px !important;
}
.serviceswhitebackground .brandscolumn p.partnername::after {
  display: block;
  content: "";
  width: 60px;
  height: 20px;
  border-bottom: 1px solid #007ca1;
  margin: 0px auto 0px;
}
.serviceswhitebackground .brandscolumn p.learnmorebutton {
  text-align: center;
  background-color: #f1f1f1;
  border-radius: 0px 0px 10px 10px;
  padding: 0px !important;
  position: absolute;
  bottom: 0px;
}
.serviceswhitebackground .brandscolumn p.learnmorebutton:hover {
  background-color: #e1e1e1;
}
.serviceswhitebackground .brandscolumn p.learnmorebutton a {
  text-decoration: none;
  font-weight: 300;
  color: #333 !important;
  width: 100%;
  display: block;
  padding: 20px 30px !important;
}

.primary-btn a {
  background-color: #007ca1;
  color: #fff !important;
  padding: 10px 30px !important;
  border-radius: 30px;
  margin-top: 20px !important;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px !important;
  border: 1px solid transparent;
}
.primary-btn a:hover {
  background-color: #fff;
  border: 1px solid #007ca1;
  color: #000 !important;
}

.servicesimages .wp-block-image {
  margin: 0px !important;
  width: 100%;
}
.servicesimages .wp-block-image img {
  width: 100%;
}
.servicesimages.wp-block-column:not(:first-child) {
  margin-left: 1px;
  margin-right: 0px;
}
.servicesimages.wp-block-column {
  margin-left: 0px;
  margin-right: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.servicesdualcontainer {
  margin: 0px !important;
  padding: 0px 0px 2px !important;
  background-color: #fafafa;
}
.servicestextcontainer {
  margin: 0 auto !important;
  max-width: 600px;
  overflow: hidden;
  padding: 0;
}
.servicesdualcontainer h2 {
  width: 100%;
  font-size: 36px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
  margin: 0px 0px 30px !important;
}
.servicesdualcontainer h2::after {
  display: block;
  content: "";
  width: 60px;
  height: 20px;
  border-bottom: 5px solid #007ca1;
}

.servicesdualcontainer .serviceswhitebackground h2 {
  float: none;
  margin: 0px auto 30px !important;
}
.servicesdualcontainer .serviceswhitebackground h2::after {
  margin: 0px auto;
}
.serviceswhitebackground p.pointsmade {
  text-align: center;
}
.serviceswhitebackground p a {
  color: #666 !important;
  text-decoration: underline;
}
.servicesdualcontainer.reversetheflex {
  flex-direction: row-reverse;
}
.servicesimages .wp-block-image.servicebrands {
  float: left;
  margin-right: 40px !important;
  max-width: 150px !important;
  filter: grayscale(100%);
  opacity: 0.3;
}
.servicesimages .wp-block-image.servicebrands:hover {
  margin-right: 40px !important;
  max-width: 150px !important;
  filter: grayscale(0%);
  opacity: 1;
}

/*HOME PAGE SLIDING MIDDLE */
.homedualcontainer {
  margin: 0px !important;
  padding: 60px 0px 60px !important;
  background-color: #fafafa;
  flex-direction: row-reverse;
}
.homedualcontainer.homedualmid {
  padding: 0px 0px 0px !important;
  flex-direction: row;
}
.homedual1 {
  padding: 250px 40px;
  background-color: #17191a;
  margin: 0px !important;
  text-align: left;
  font-size: 16px;
}

.homedual1 p {
  float: left;
}
.homedualcontainer h2 {
  width: 100%;
  font-size: 36px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
  margin: 0px 0px 30px !important;
}
.homedual2 {
  padding: 80px 40px;
  background-color: transparent;
  margin: 0px !important;
  text-align: center;
}
.homedual2.homelighting {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: flow-root;
  position: relative;
  background-size: cover;
}
.homedual2.homeshow3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: flow-root;
  position: relative;
  background-size: inherit;
}
.homedual2.homeshow2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: flow-root;
  position: relative;
  background-size: cover;
}
.homedualcontainer.bottomdual {
  padding-bottom: 60px !important;
}

.homephone {
  margin: 0px !important;
  max-width: 300px !important;
  position: absolute;
  bottom: 5%;
  left: 7.5%;
  width: 17% !important;
}
.homedual2.duallefttext {
  text-align: left;
}
.duallefttext .iconsbox {
  text-align: left;
  padding: 0px !important;
  margin: 0px 0px 20px 0px !important;
  position: relative;
}
.homedualcontainer .duallefttext .fas,
.homedualcontainer .duallefttext .far {
  color: #d4d4d4;
  float: left;
  padding: 7px 15px 0px 0px;
  overflow: hidden;
  line-height: 1;
  font-size: 24px;
  border: none !important;
  width: auto;
}
.iconsbox .wp-block-column:hover .fas,
.iconsbox .wp-block-column:hover .far {
  color: #007ca1;
}
.homedualcontainer .duallefttext p {
  color: #444 !important;
  font-size: 16px;
  text-decoration: none;
  display: inline-block;
}
.iconsbox .wp-block-column:hover p {
  color: #007ca1 !important;
}
.leftsidetextspace {
  margin-bottom: 60px;
}
.homedualcontainer .learnmorebutton a {
  background-color: #007ca1;
  color: #fff !important;
  padding: 10px 30px !important;
  border-radius: 30px;
  margin-top: 20px !important;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px !important;
  border: 1px solid transparent;
}
.homedualcontainer .learnmorebutton a:hover {
  background-color: #fff;
  border: 1px solid #007ca1;
}
.hideonshow {
  opacity: 0;
  transition: 0.5s;
  font-size: 14px !important;
  color: #888 !important;
  width: 100%;
}
.iconsbox .wp-block-column:hover .hideonshow {
  opacity: 1;
  font-size: 14px;
  color: #888 !important;
}
.control4small.homecedialogo a {
  border: none;
  background-color: none !important;
  position: absolute;
  display: block;
  padding: 0px;
  margin: 0px;
  width: 159px;
  height: 159px;
  right: 30px;
  bottom: 60px;
}
.control4small.homecedialogo .alignleft {
  position: inherit !important;
}

.iconsbox {
  text-align: center;
}
.homedualcontainer .fas,
.homedualcontainer .far {
  color: #d4d4d4;
  float: none;
  padding: 30px 0px;
  overflow: hidden;
  line-height: 1;
  font-size: 60px;
  border: none !important;
  width: 100%;
}
.iconsbox .wp-block-column:hover {
  color: #007ca1 !important;
}
.homedualcontainer a {
  color: #444;
  font-size: 16px;
  text-decoration: none;
  padding-bottom: 3px;
}
.homedualcontainer .minigray a {
  color: #007ca1 !important;
}
.homedualcontainer a:hover {
  color: #007ca1 !important;
}
.homedualcontainer .minigray a:hover {
  color: #007ca1 !important;
}
.homedualcontainer a:hover .fas,
.homedualcontainer a:hover .far {
  color: #007ca1 !important;
}
.homedualcontainer a p {
  border-bottom: 1px solid #bbb;
  display: inline-block;
}
.homedualcontainer a:hover p {
  border-bottom: 1px solid #007ca1;
}
.darkenit {
  position: relative;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.darkenit .homedual2 {
  background-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  max-width: 600px;
}

.entry-content > *:not(.alignfull):not(.alignleft):not(.is-style-wide) {
  max-width: 90% !important;
  width: calc(100% - 4rem) !important;
}

.fullimagetop {
  background-position: center;
  max-width: 100%;
  height: 100vh;
  max-width: 100% !important;
  position: relative;
  z-index: -5;
  background-size: cover;
}
.halfimagetop {
  background-position: center;
  max-width: 100%;
  height: 45vh;
  max-width: 100% !important;
  position: relative;
  z-index: -5;
  background-size: cover;
}

/*PORTFOLIO PAGES*/
.servicesimages.sidevideo.wp-block-column {
  position: relative;
  overflow: hidden;
  margin-top: 1px;
}
.servicesimages.sidevideo .wp-block-image img {
  opacity: 0;
}
.servicesimages.sidevideo #video-background {
  z-index: 1;
}
.servicesimages.sidevideoleft.wp-block-column {
  position: relative;
  overflow: hidden;
  margin-top: 1px;
}
.servicesimages.sidevideoleft .wp-block-image img {
  opacity: 0;
}
.servicesimages.sidevideoleft #video-background {
  z-index: 1;
}

.servicestextcontainer p a {
  color: #666 !important;
  text-decoration: underline;
}
.servicesimages.wp-block-column.homeprojectdisplay {
  display: block;
}

/*BRANDS PAGE */
.brandscolumn {
  max-width: 1600px !important;
  margin: 0px auto !important;
  flex-wrap: wrap;
}
.brandscolumn .wp-block-image img {
  margin: 0px auto;
  padding: 0px 30px;
}
.brands .wp-block-group.homevideo.servicespages {
  height: 60vh;
}
.brands
  .wp-block-group.homevideo.servicespages
  > .wp-block-group__inner-container {
  height: 60vh;
}
.brands .fullimagetop {
  height: 60vh;
}
.brandscolumn .wp-block-column {
  background-color: #fff;
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  margin-bottom: 32px;
  width: 25%;
  flex-basis: inherit;
  position: relative;
}
.brandscolumn .wp-block-column:nth-child(3n + 1) {
  margin-left: 0px;
}
.brandscolumn .wp-block-image.brandlogo {
  margin: 0px 30px 85px !important;
}
.brandscolumn .wp-block-image.brandlogo img {
  padding: 0px;
  margin: 0px;
}

.brandscolumn .wp-block-column.compareplan {
  margin-bottom: 60px;
  background-color: transparent !important;
  width: 25px !important;
  flex: auto !important;
}

.wp-block-column.compareplan .downwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-top: 30px solid transparent;
}
.wp-block-column.compareplan .upwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-bottom: 30px solid transparent;
}
.wp-block-column.compareplan .planpricing {
  font-size: 60px;
  background-color: transparent;
  text-align: center;
}
.wp-block-column.compareplan .planpricing.planpricing2 {
  background-color: transparent;
}
.wp-block-column.compareplan .planpricing .planpricinginner {
  display: inline-block;
  position: relative;
}
.brandscolumn .wp-block-column.compareplan li:nth-child(even) {
  background-color: #fff;
}
.brandscolumn .wp-block-column.compareplan li:first-child {
  border-radius: 10px 0px 0px 0px;
}
.brandscolumn .wp-block-column.compareplan li:last-child {
  border-radius: 0px 0px 0px 10px;
}
.brandscolumn .wp-block-column.compareplan li:last-child a {
  border-radius: 0px 0px 0px 10px;
}

.brandscolumn .wp-block-column.silverplan {
  margin-bottom: 60px;
  border-left: 1px solid #fff !important;
}

.wp-block-column.silverplan .downwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-top: 30px solid #c0c0c0;
}
.wp-block-column.silverplan .upwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-bottom: 30px solid #c0c0c0;
}
.wp-block-column.silverplan .planpricing {
  font-size: 60px;
  background-color: linear-gradient(#a6a6a6, #c0c0c0);
  text-align: center;
}
.wp-block-column.silverplan .planpricing.planpricing2 {
  background-color: linear-gradient(#c0c0c0, #a6a6a6);
}
.wp-block-column.silverplan .planpricing .planpricinginner {
  display: inline-block;
  position: relative;
  color: #fff;
}
.wp-block-column.silverplan .planpricing .planpricinginner::before {
  content: "\$";
  display: block;
  position: absolute;
  font-size: 18px;
  left: -11px;
  top: 20px;
}
.wp-block-column.silverplan .planpricing .planpricinginner::after {
  content: "/mo";
  display: block;
  position: absolute;
  font-size: 18px;
  bottom: 15px;
  right: -32px;
}

.brandscolumn .wp-block-column.goldplan {
  border-left: none;
  border-right: none;
  margin-bottom: 60px;
  border-left: 1px solid #fff !important;
}
.wp-block-column.goldplan .downwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-top: 30px solid #fbc901;
}
.wp-block-column.goldplan .upwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-bottom: 30px solid #fbc901;
}
.wp-block-column.goldplan .planpricing {
  font-size: 60px;
  background-color: linear-gradient(#deaf00, #fbc901);
  text-align: center;
  color: #fff;
}
.wp-block-column.goldplan .planpricing.planpricing2 {
  font-size: 60px;
  background-color: linear-gradient(#fbc901, #deaf00);
}
.wp-block-column.goldplan .planpricing .planpricinginner {
  display: inline-block;
  position: relative;
}
.wp-block-column.goldplan .planpricing .planpricinginner::before {
  content: "\$";
  display: block;
  position: absolute;
  font-size: 18px;
  left: -11px;
  top: 20px;
}
.wp-block-column.goldplan .planpricing .planpricinginner::after {
  content: "/mo";
  display: block;
  position: absolute;
  font-size: 18px;
  bottom: 15px;
  right: -32px;
}

.brandscolumn .wp-block-column.platplan {
  margin-bottom: 60px;
  border-left: 1px solid #fff !important;
}
.wp-block-column.platplan .downwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-top: 30px solid #a0b2c6;
}
.wp-block-column.platplan .upwardtriangle {
  display: none;
  width: 0px;
  height: 0px;
  border-left: 198px solid transparent;
  border-right: 198px solid transparent;
  border-bottom: 30px solid #a0b2c6;
}
.wp-block-column.platplan .planpricing {
  font-size: 60px;
  background-color: linear-gradient(#8798ab, #a0b2c6);
  text-align: center;
  color: #fff;
}
.wp-block-column.platplan .planpricing.planpricing2 {
  background-color: linear-gradient(#a0b2c6, #8798ab);
}
.wp-block-column.platplan .planpricing .planpricinginner {
  display: inline-block;
  position: relative;
}
.wp-block-column.platplan .planpricing .planpricinginner::before {
  content: "\$";
  display: block;
  position: absolute;
  font-size: 18px;
  left: -11px;
  top: 20px;
}
.wp-block-column.platplan .planpricing .planpricinginner::after {
  content: "/mo";
  display: block;
  position: absolute;
  font-size: 18px;
  bottom: 15px;
  right: -32px;
}
.brandscolumn .wp-block-column.platplan li:last-child {
  border-radius: 0px 0px 10px 0px;
}
.brandscolumn .wp-block-column.platplan li:last-child a {
  border-radius: 0px 0px 10px 0px;
}

/*PARTNERS PAGE */
.partners .wp-block-group.homevideo.servicespages {
  height: 55vh;
}
.partners
  .wp-block-group.homevideo.servicespages
  > .wp-block-group__inner-container {
  height: 55vh;
}
.partners .fullimagetop {
  height: 55vh;
}
.partners .brandscolumn .wp-block-column {
  width: 21%;
}
.partners .brandscolumn .wp-block-column:nth-child(odd) {
  margin-left: 32px;
}
.partners .brandscolumn .wp-block-column:nth-child(even) {
  margin-left: 32px;
}
.partners .brandscolumn .wp-block-image img {
  width: 100%;
}
.partners .brandscolumn .wp-block-image {
  margin-bottom: 2rem !important;
  margin-top: 3rem !important;
}
.partners .serviceswhitebackground .brandscolumn p.learnmorebutton {
  background-color: transparent;
  position: unset;
  transition: all 0.3s;
}
.partners .serviceswhitebackground .brandscolumn p.learnmorebutton:hover {
  background-color: #f1f1f1;
}
.homeintrotop.centerintro h2 {
  width: 100%;
  font-size: 32px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  max-width: 100% !important;
  float: none;
  text-align: center;
  font-weight: 300;
  color: #fff;
  margin-bottom: 15px;
  text-shadow: #747474 0.05em 0.05em 0.1em;
}
.homenumber.partnerh2 {
  margin-bottom: 45px !important;
}
.partners3column {
  max-width: 1200px !important;
  color: #666;
}
.partners3column h3 {
  font-size: 30px;
  font-weight: 300;
  padding: 0px 30px;
}
.partners3column li {
  font-size: 16px;
  font-weight: 300;
}
.homeintrotop.centerintro.partnercenter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.smallpartnerarea {
  max-width: 100% !important;
  width: 100% !important;
  padding: 0px 30px;
  color: #666;
}
.smallpartnerarea h2 {
  max-width: 100% !important;
  padding-top: 30px;
  font-weight: 300;
  font-size: 42px;
}
.smallpartnerarea p {
  max-width: 700px !important;
  color: #666;
  font-size: 20px;
  font-weight: 300;
}
.smallpartnerarea p a {
  background-color: #007ca1;
  color: #fff !important;
  padding: 10px 20px;
  margin: 30px auto;
  display: block;
  width: 190px;
  border-radius: 15px;
  border: 1px solid transparent;
}
.smallpartnerarea p a:hover {
  background-color: #ffffff;
  color: #007ca1 !important;
  border: 1px solid #007ca1;
}

/*CONTACT US PAGE*/

.contact-us-page
  .wp-block-group.homevideo.servicespages
  > .wp-block-group__inner-container {
  height: 45vh;
}
.contact-us-page .wp-block-group.homevideo.servicespages {
  height: 45vh;
  background-color: rgba(23, 25, 26, 0.2);
}
#map {
  height: 500px; /* The height is 400 pixels */
  width: 100%; /* The width is the width of the web page */
}
.contact-us-page .footer-widgets.column-one {
  display: none;
}
.servicesdualcontainer.mapscontain {
  padding: 0px !important;
  float: left;
  width: 100%;
  height: 500px;
  overflow: hidden;
}
.contact-us-page .pagecolumns {
  max-width: 1200px !important;
  border-bottom: none;
  padding-bottom: 60px;
  margin-bottom: 0px !important;
}
.contact-us-page .pagecolumns .wp-block-column:first-child {
  border-right: 1px solid #e4e4e4;
}
.contactcolumn1 .fas {
  float: none;
  padding: 0px;
  font-size: 48px;
  color: #b4b4b4;
  margin-bottom: 24px;
  margin-top: 20px;
}
.contactcolumn1 {
  text-align: center;
}
.pagewhitebackground .contactcolumn1 p {
  padding-bottom: 45px;
}
.contact-us-page input[type="text"],
.contact-us-page input[type="email"],
.contact-us-page input[type="tel"],
.contact-us-page textarea {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
}
.contact-us-page input[type="submit"] {
  background-color: #007ca1;
  margin-top: 20px;
  border-radius: 10px;
  padding: 15px 30px;
  font-family: roboto;
  font-weight: 500;
}

.pagewhitebackground a {
  color: #007ca1 !important;
  text-decoration: underline;
}
.contact-us-page .pagecolumns .wp-block-column:first-child {
  flex-basis: 400px !important;
}
.contact-us-page .pagecolumns .wp-block-column {
  flex-basis: 100% !important;
}
.wp-block-column.bigoldmap > :last-child {
  height: 500px !important;
  width: 100% !important;
}

/*Start Your Project*/

.start-your-project
  .wp-block-group.homevideo.servicespages
  > .wp-block-group__inner-container {
  height: 45vh;
}
.start-your-project .wp-block-group.homevideo.servicespages {
  height: 45vh;
  background-color: rgba(23, 25, 26, 0.2);
}
.start-your-project .footer-widgets.column-one {
  display: none;
}
.start-your-project .pagecolumns {
  max-width: 1200px !important;
  border-bottom: none;
  padding-bottom: 60px;
  margin-bottom: 0px !important;
}
.start-your-project .pagecolumns .wp-block-column:first-child {
  border-right: 1px solid #e4e4e4;
}
.start-your-project input[type="text"],
.start-your-project input[type="email"],
.start-your-project input[type="tel"],
.start-your-project textarea {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
}
.start-your-project input[type="submit"] {
  background-color: #007ca1;
  margin-top: 20px;
  border-radius: 10px;
  padding: 15px 30px;
  font-family: roboto;
  font-weight: 500;
}
.start-your-project select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  border-radius: 0;
  border-style: solid;
  border-width: 0.1rem;
  box-shadow: none;
  display: block;
  font-size: 1.6rem;
  letter-spacing: -0.015em;
  margin: 0;
  max-width: 100%;
  padding: 1.5rem 1.8rem;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  line-height: 2;
  color: #666;
}
.start-your-project option {
  padding: 0px;
}

.start-your-project .pagecolumns .wp-block-column:first-child {
  flex-basis: 400px !important;
}
.start-your-project .pagecolumns .wp-block-column {
  flex-basis: 100% !important;
}

/*SUB PAGES WHITE BACKGROUND WITH BLACK TEXT BELOW HEADER*/
.pagewhitebackground {
  margin: 0px !important;
  padding: 90px 30px 60px !important;
  background-color: #fff;
  background-image: none;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
  position: relative;
}
.pagewhitebackground h2 {
  text-align: left;
  width: 100% !important;
  font-size: 36px;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
  margin: 0px auto 30px !important;
  max-width: 1200px !important;
}
.pagewhitebackground h2::after {
  display: block;
  content: "";
  width: 60px;
  height: 20px;
  border-bottom: 5px solid #007ca1;
}
.pagewhitebackground p {
  max-width: 900px !important;
  width: 100% !important;
  color: #666;
  font-size: 16px;
  font-weight: 300;
}
.pagecolumns {
  max-width: 1200px !important;
  border-bottom: 2px solid #d4d4d4;
  padding-bottom: 60px;
  margin-bottom: 60px !important;
}
.cediasmall {
  max-width: 165px;
}
.pagecolumns .wp-block-image.control4small {
  max-width: 159px;
  margin-top: 20px !important;
}
.pagecolumns .wp-block-column:first-child {
  border-right: 2px solid #d4d4d4;
  padding-right: 45px;
  margin-right: 30px;
}
.pagecolumns .wp-block-image {
  margin-top: 0px !important;
  margin-bottom: 45px !important;
}
.wp-block-columns.picturetime {
  max-width: 1200px !important;
}
.picturetime figcaption {
  font-family: roboto;
  text-align: center;
}
.picturetime figcaption strong {
  clear: both;
  display: block;
  margin-bottom: 5px;
}
.pickanarea {
  justify-content: center;
  background-color: #111;
  background-color: rgba(23, 25, 26, 0.85);
  color: #fff;
  margin: 0px !important;
  width: 100% !important;
  max-width: 100% !important;
  text-align: center;
  font-size: 14px;
}
.pickanarea .fa,
.pickanarea .fas,
.pickanarea .far {
  font-weight: 900;
  line-height: 84px;
  float: none;
  padding-right: 0px;
  clear: left;
  display: block;
  width: 100%;
  text-align: center;
  font-size: 48px;
}
h2.pickareaheading {
  background-color: #111;
  background-color: rgba(23, 25, 26, 0.85);
  width: 100% !important;
  max-width: 100% !important;
  text-align: center;
  padding: 45px 30px 0px;
  margin: 0px;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #58c7f1;
  font-size: 32px;
}
.pickanarea > .wp-block-column {
  max-width: 600px;
}
.pickanarea a:hover .fa,
.pickanarea a:hover .fas,
.pickanarea a:hover .far {
  color: #58c7f1;
}
.houzztable {
  border: none;
  width: 159px !important;
}
.houzztable td {
  padding: 0px;
  border: none;
}
.houzztable td img {
  width: 158px !important;
  height: 158px !important;
}
a#bbblink {
  width: 158px !important;
}

/*FOOTER MAIN AREA AND CONTACT*/
.footer-widgets-outer-wrapper {
  border: none !important;
}
.header-footer-group {
  border: none !important;
}
.footer-widgets-outer-wrapper {
  width: 50%;
}
.footer-widgets {
  margin-left: 0px;
  width: 100%;
}
.footer-widgets-wrapper {
  width: 100%;
  margin-left: 0px;
  display: block;
}

.contactarea {
  display: flex;
  flex-wrap: nowrap;
}
.contactareabox {
  background-color: rgba(23, 25, 26, 0.85);
  padding: 40px 80px;
  flex-basis: 0;
  flex-grow: 1;
}
.contactareabox h3 {
  width: 100%;
  font-size: 36px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #58c7f1;
  text-align: center;
  margin: 0px 0px 15px;
}
.contactarea p {
  text-align: center;
  font-family: roboto;
  font-size: 16px;
  color: #707070;
}
.contactareabox2 {
  background-color: rgba(23, 25, 26, 0.65);
  padding: 40px;
  flex-basis: 1px;
  flex-grow: 1;
}
.contactareabox2 h3 {
  width: 100%;
  font-size: 36px;
  float: left;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #ffffff;
  text-align: center;
  margin: 0px 0px 60px;
}
.contactarea input[type="text"] {
  text-align: center;
  background-color: rgba(23, 25, 26, 0.85);
  color: #fff;
  font-family: roboto;
  border-radius: 30px;
  font-size: 14px;
}
.contactarea .wpcf7 input[type="email"] {
  text-align: center;
  background-color: rgba(23, 25, 26, 0.85);
  color: #fff;
  font-family: roboto;
  border-radius: 30px;
  font-size: 14px;
}
.contactarea .wpcf7 input[type="tel"] {
  text-align: center;
  background-color: rgba(23, 25, 26, 0.85);
  color: #fff;
  font-family: roboto;
  border-radius: 30px;
  font-size: 14px;
}
.contactarea textarea {
  text-align: center;
  background-color: rgba(23, 25, 26, 0.85);
  color: #fff;
  font-family: roboto;
  border-radius: 30px;
  font-size: 14px;
}
.contactarea .wpcf7-form p {
  margin: 0px 0px 15px;
  line-height: 0px;
}
.contactarea .wpcf7-form {
  margin-top: 35px;
}
.contactarea .wpcf7-submit {
  background-color: #007ca1;
  color: #fff !important;
  padding: 10px 30px !important;
  border-radius: 30px;
  margin-top: 0px !important;
  display: inline-block;
  font-weight: 500;
  font-size: 14px !important;
  border: 1px solid transparent;
  width: 100%;
  font-family: roboto;
  text-transform: none;
}
.contactarea .wpcf7-submit:hover {
  background-color: #fff;
  border: 1px solid #007ca1;
  color: #007ca1 !important;
}
.contactarea input[type="text"]:focus {
  border-color: #888;
}
.contactarea .wpcf7 input[type="email"]:focus {
  border-color: #888;
}
.contactarea .wpcf7 input[type="tel"]:focus {
  border-color: #888;
}
.contactarea textarea:focus {
  border-color: #888;
}
.contactarea .contactareabox2 p {
  color: #fff;
}
.contactarea .contactareabox2 a:hover p {
  color: #58c7f1;
}
.contactarea .contactareabox2 .fa,
.contactarea .contactareabox2 .fas {
  float: none;
  padding: 0px;
  font-size: 36px;
  color: #58c7f1;
}

.footer-widgets-outer-wrapper {
  width: 100%;
  padding: 0px;
}
.footer-inner.section-inner {
  max-width: 100%;
  width: 100%;
}
.footer-widgets.column-one {
  max-width: 100%;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  display: flex;
  position: relative;
  background-size: cover;
  min-height: 90vh;
  align-items: center;
  justify-content: right;
}
.footer-widgets.column-one div:first-child {
  margin-left: auto;
}
.footer-widgets.column-two {
  overflow: hidden;
}
.footerlinks {
  display: flex;
  max-width: 1200px;
  padding: 60px 30px;
  margin: 0px auto;
  font-size: 16px;
}

.footerlinks1 {
  flex-basis: 400px;
  flex-grow: 0;
  color: #666;
}
.footerlinks1 img {
  max-width: 100%;
  margin-bottom: 5px;
}
.footerlinks1 p {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
}
.footerlinks2 {
  flex-basis: 400px;
  flex-grow: 0;
  padding-right: 60px;
}
.footerlinks3 {
  flex-basis: 0;
  flex-grow: 1;
}
.footerlinks3 .review {
  color: #333;
}
.footerlinks3 .review .mySwiper {
  width: 400px;
}
.footerlinks3 .review .mySwiper .swiper-slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.footerlinks3 .review .mySwiper ul {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  margin-bottom: 40px;
}
.footerlinks3 .review .mySwiper ul li {
  font-size: 20px;
  list-style: none;
  margin: 0 !important;
}
.footerlinks3 .review .mySwiper .minigray {
  margin: 0;
  margin-bottom: 10px;
  font-style: italic;
}
.footerlinks3 .review .mySwiper .user p {
  margin: 0;
  text-transform: capitalize;
  margin-top: 10px;
  font-weight: 600;
}
.footermenu a {
  display: block;
  text-transform: uppercase;
  font-size: 14px;
  padding: 7px 0;
}
.footermenu .su-spoiler-style-default > .su-spoiler-title {
  display: block;
  text-transform: uppercase;
  font-size: 14px;
  padding: 7px 0;
  font-weight: 300;
  color: #222;
}
.footermenu .su-spoiler-style-default > .su-spoiler-title:hover {
  color: #58c7f1 !important;
}
.footermenu .su-spoiler-style-default > .su-spoiler-title:focus {
  outline: none;
}
.footermenu.su-accordion .su-spoiler {
  margin-bottom: 0px !important;
}
.footermenu .su-spoiler-style-default > .su-spoiler-title > .su-spoiler-icon {
  left: inherit;
  right: 0;
}
.footermenu a:hover {
  color: #58c7f1 !important;
}

.header-footer-group {
  background-color: #fff;
}

/* josh ai page  */
.josh-ai-page .josh-ai-hero-content {
  padding-top: 300px;
  width: 400px !important;
  margin-left: 60% !important;
  position: absolute;
}

.josh-ai-page .overlay2 {
  background-color: rgba(8, 8, 8, 0);
  background-image: linear-gradient(
    264deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background-clip: padding-box;
}

.josh-ai-hero-content h2 {
  color: #fff;
  font-weight: 400;
  margin-top: 0px;
  position: relative;
  padding-top: 15px;
}
.josh-ai-hero-content h2::before {
  content: "";
  width: 70px;
  height: 3px;
  background-color: #007ca1;
  position: absolute;
  top: 0;
  left: 0;
}
.josh-ai-hero-content p {
  color: #ffffffb3;
  font-size: 20px;
  font-weight: 300;
}

.josh-ai-page .josh-ai-h2 {
  position: relative;
  padding-top: 15px;
  margin-top: 0;
  font-weight: 300;
  color: #007ca1;
  font-size: 36px;
  text-transform: uppercase;
}

.josh-new-content {
  display: none;
}

.josh-ai-page .josh-ai-h2::before {
  content: "";
  width: 60px;
  height: 3px;
  background-color: #007ca1;
  position: absolute;
  top: 0;
  left: 0;
}

/* .commercial-automantion */
.csca {
  margin-top: 135px;
  width: 100%;
  height: 580px;
  position: relative;
}
.csca video,
.csca .image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.csca .image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.csca .csca-content {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 50%;
  transform: translate(-50%);
  background-color: rgba(31, 31, 31, 0.6);
  width: 100%;
  bottom: 0;
}
.csca .csca-content-area {
  max-width: 750px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0 40px 30px 40px;
}
.csca .csca-icon {
  width: 120px;
}
.csca .csca-icon .outline {
  fill: #00000000;
  stroke: #fff;
}
.csca .csca-content h1 {
  font-size: 44px;
  font-weight: 400;
  color: #fff;
  margin: 0;
  margin-bottom: 10px;
}
.csca .csca-content h6 {
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  margin: 0;
}
.csca-nav {
  background-color: #fafafa;
}
.csca-nav .control4-nav .control4-nav-area .nav-area a {
  background-color: transparent !important;
  border: 1px solid #007ca1 !important;
  color: #007ca1 !important;
  text-transform: capitalize !important;
  font-size: 16px !important;
}
.csca-nav .control4-nav .control4-nav-area .nav-area a:hover {
  background-color: #007ca1 !important;
}
.csca-nav .control4-nav-area {
  justify-content: center !important;
}
.extra-padding {
  padding: 70px 0;
}
.carears-hero {
  margin-top: 120px;
}
.carears-hero .uk-divider-small::after {
  border-top: 3px solid #007ca1;
  border-color: #007ca1 !important;
  width: 54px;
}
.carears-hero h2 {
  font-weight: 400;
  font-size: 44px;
  margin: 0;
  margin-bottom: 30px;
}
.carears-hero p {
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: -0.6px;
}
.commercial-technology-hero {
  margin-top: 135px;
}
.commercial-technology-hero .uk-heading-bullet::before {
  border-left-color: #007ca1 !important;
}
.commercial-technology-hero p {
  font-size: 16px;
  font-weight: 300;
}
.commercial-technology-hero .indoor-content h1.uk-h6,
.commercial-technology-hero .indoor-content h2,
.commercial-technology-hero .indoor-content p {
  color: #302b28;
  font-weight: 100;
}
.golf-simulators-hero {
  margin-top: 135px;
}
.golf-simulators-hero p {
  /* font-family: "Lucida Grande","Lucida Sans Unicode",Verdana,sans-serif; */
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
}
.golf-simulators-hero .button__primary {
  background-color: #fafafa;
  color: #333 !important;
}
.golf-simulators-hero h1 {
  margin: 0;
  margin-bottom: 30px;
}
.golf-simulators-hero .button__primary:hover {
  background-color: #58c7f1;
}
.contro4_hero h3,
.contro4_hero .uk-margin-small {
  font-weight: 300;
}
.contro4_hero .button__primary {
  margin-top: 0 !important;
}
.contro4_hero h3 {
  text-transform: uppercase;
}

.preloader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.icon-1-1 a i,
.icon-1-2 a i {
  color: #007ca1;
}
.icon-1-1 a,
.icon-1-2 a {
  height: 40px;
  width: 40px;
  opacity: 1;
  box-shadow: 0px 0px 0px 0;
  padding: 0px;
  border: 2px solid #007ca1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.to-the-top span {
  color: #fff;
}
.vce {
  margin-bottom: 30px;
}

.su-spoiler.su-spoiler-closed > .su-spoiler-content {
  height: 0;
  margin: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  border: none;
  opacity: 0;
  pointer-events: none;
}

#site-content .post-inner {
  padding-top: 0;
}
.design-build-partners .wp-block-group.homevideo.servicespages {
  height: 65vh;
}
.design-build-partners
  .wp-block-group.homevideo.servicespages
  > .wp-block-group__inner-container {
  height: 65vh;
}

a#scroll-to-top {
  background-color: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat
    center center;
  width: 35px;
  height: 35px;
  position: fixed;
  right: 30px;
  bottom: 30px;
  text-indent: -9999px;
  font-size: 0;
  cursor: pointer;
  outline: 0;
  opacity: 0;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.24);
}
.overlay2 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.596);
}

.indoor-living-feature h3 {
  font-size: 20px;
  margin: 0 !important;
  margin-bottom: 10px !important;
  color: #007ca1;
}

.is-layout-flex.wp-container-13.wp-block-columns.alignfull.homedualcontainer
  .indoor-living-about {
  margin: 0 auto;
  max-width: 1460px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.indoor-living-about .indoor-living-feature {
  width: 60%;
  /* padding-top: 0px; */
}
.indoor-living-about .indoor-living-about-box {
  width: 40%;
  background-color: #fff;
  padding: 70px;
  border-top: 3px solid #007ca1;
}
.indoor-living-about .indoor-living-about-box h3 {
  color: #007ca1 !important;
}

.indoor-living-image-section img {
  width: 100% !important;
}

.indoor-living-image-section.alignfull {
  margin: 0 !important;
}

.indoor-living-image-section .title-section {
  padding: 70px 0;
}
.indoor-living-image-section .title-section .title-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  color: #747474;
}
.indoor-living-image-section .title-section .title-inner p {
  margin: 0;
}
.indoor-living-image-section .title-section .title-inner .section-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}
.title-inner .section-grid [class*="grid-item-"] {
  padding-left: 25px;
}
.title-inner .section-grid [class*="grid-item-"] h6 {
  margin: 0;
  margin-bottom: 20px;
  color: #007ca1;
}
.title-inner .section-grid .grid-item-1 {
  width: 50%;
}
.title-inner .section-grid .grid-item-1 h4 {
  margin: 0;
  margin-bottom: 20px;
  color: #007ca1;
}
.title-inner .section-grid .grid-item-1 p {
  font-size: 15px;
}
.title-inner .section-grid .grid-item-2 {
  width: 25%;
}
.title-inner .section-grid .grid-item-2 p {
  font-size: 14px;
}
.title-inner .section-grid .grid-item-3 {
  width: 25%;
}
.title-inner .section-grid .grid-item-3 h6 {
  text-align: center;
}
.section-grid .grid-item-3 .icon-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.grid-item-3 .icon-grid i {
  font-size: 30px;
  color: #747474;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* connected home */
.connected-living-title-section {
  margin-top: 136px;
  padding: 70px 0;
  background-color: #fafafa;
}

.connected-living-title-section h2 {
  margin: 0px;
  margin-bottom: 20px;
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
}
.connected-living-title-section p {
  margin: 0px !important;
  color: #666;
}
.connected-living-title-section .title-inner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 0 20px;
}
.connected-living-title-section.bottom-title-section {
  margin: 0 !important;
}

.a-day-life .a-day-life-hero h1 {
  margin-bottom: 20px !important;
}
.a-day-life .a-day-life-hero h5 {
  margin: 0;
  font-weight: 500;
  margin-bottom: 10px;
  color: #fff;
}
.a-day-life .a-day-life-hero p {
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.a-day-life-section {
  display: flow-root;
  box-sizing: border-box;
  padding-top: 40px;
  padding-bottom: 40px;
}

.a-day-life-container-large {
  max-width: 1360px;
}
.a-day-life-section > :last-child {
  margin-bottom: 0;
}
.a-day-life-container {
  display: flow-root;
  box-sizing: content-box;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.a-day-life-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-left: -30px;
}

.a-day-life-grid > * {
  margin: 0;
}
.a-day-life-grid > * > :last-child {
  margin-bottom: 0;
}
* + .a-day-life-grid-margin,
.a-day-life-grid + .a-day-life-grid,
.a-day-life-grid > .a-day-life-grid-margin {
  margin-top: 30px;
}

.a-day-life-container-large {
  max-width: 1360px;
}
.a-day-life-text-center {
  text-align: center !important;
}

.a-day-life-nav {
  display: flex;
  flex-wrap: wrap;
}
.a-day-life-nav .nav-item {
  width: 16.66%;
}
.a-day-life-nav .nav-item a {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.a-day-life-nav .nav-item i {
  color: #999;
}
.a-day-life-nav .nav-item a h3 {
  margin: 20px 0 0 0;
  font-size: 28px;
  font-weight: 300;
  color: #007ca1;
}
.a-day-life-nav .nav-item a p {
  margin-top: 20px !important;
  margin: 0;
  font-size: 14px;
}
.tm-grid-expand > * {
  flex-grow: 1;
}
.tm-grid-expand > .a-day-life-width-expand {
  flex-grow: 999;
}
.a-day-life-text-meta {
  font-size: 14px;
  line-height: 1.4;
  color: #999;
  font-family: Mukta;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  margin-top: 20px;
}
.a-day-life-padding-remove-bottom {
  padding-bottom: 0 !important;
}
.a-day-life-heading-bullet {
  font-size: 50px;
  font-weight: 300;
  margin: 0 0 20px 0;
  color: #fff;
}

.a-day-life-heading-bullet::before {
  content: "";
  display: inline-block;
  position: relative;
  top: calc(-0.095 * 1em);
  vertical-align: middle;
  height: calc(4px + 0.74em);
  margin-right: calc(5px + 0.2em);
  border-left: calc(1.5px + 0.15em) solid #fafafa;
}

.a-day-life-section-secondary {
  background-color: #007ca1;
  background-position-x: 50%;
  background-repeat: repeat-y;
}

.container > :last-child,
.a-day-life-container > :last-child {
  margin-bottom: 0;
}
.uk-section-xlarge {
  padding-top: 140px;
  padding-bottom: 140px;
}
.a-day-life-video-section {
  position: relative;
}
.a-day-life-video-section video {
  width: 100%;
  height: 750px;
  object-fit: cover;
}
.a-day-life-video-section .video-content {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  color: #444;
  width: 350px;
  background-color: #fafafa;
  padding: 70px 40px;
}
.a-day-life-video-section .video-content.right-text {
  position: absolute;
  right: 15%;
  left: auto;
}

.a-day-life-video-section .video-content h4 {
  color: #007ca1;
  margin: 0;
  margin-bottom: 20px;
  position: relative;
}
.a-day-life-video-section .video-content h4::before {
  content: "";
  display: inline-block;
  position: relative;
  top: calc(-0.095 * 1em);
  vertical-align: middle;
  height: calc(4px + 0.74em);
  margin-right: calc(5px + 0.2em);
  border-left: calc(1.5px + 0.15em) solid #007ba179;
}

.a-day-life-video-section .video-content p {
  padding: 0;
  margin: 0;
}

.csh-wrapper {
  position: relative;
}
.csh-marker {
  position: absolute !important;
  background-color: #007ca1;
  color: #fff;
  transition: 0.1s ease-in-out;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  width: 31px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.csh-marker i {
  color: #fff;
  font-size: 16px;
}
.uk-drop {
  display: none;
  position: absolute;
  z-index: 1020;
  --uk-position-offset: 20px;
  --uk-position-viewport-offset: 15px;
  box-sizing: border-box;
}
.uk-drop.uk-open {
  display: block;
}
.csh-card {
  background-color: #007ca1;
  color: #fff;
}
.csh-card .csh-card-content {
  padding: 30px 30px;
}
.csh-card .csh-card-content .csh-card-content-title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 22px;
  line-height: 1.4;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #fff;
}
.csh-card .csh-card-content .csh-card-content-desc {
  margin-top: 20px;
}
.csh-card .csh-card-content .csh-card-content-desc p {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 14px;
}
.our-process video {
  width: 100%;
  height: 400px;
  object-fit: cover;
}
.our-process .our-process-hero {
  position: relative;
}
.our-process .our-process-hero .our-process-video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(23, 25, 26, 0.65);
}
.our-process .our-process-hero .our-process-hero-content {
  bottom: 0px;
  max-width: 100% !important;
  background-color: transparent;
  padding: 45px 30px 0px;
  margin: 0px auto !important;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.our-process .our-process-hero .our-process-hero-content .content-wrapper {
  width: 600px;
  max-width: 100% !important;
  padding: 60px 0px 50px;
  background-color: transparent;
  margin: 0px !important;
  display: block;
  text-align: center;
}
.our-process
  .our-process-hero
  .our-process-hero-content
  .content-wrapper
  .content-title {
  text-align: center;
  font-weight: 300;
  color: #fff;
  margin-bottom: 25px;
  text-shadow: #747474 0.05em 0.05em 0.1em;
  margin-top: 0;
}
.our-process
  .our-process-hero
  .our-process-hero-content
  .content-wrapper
  .content-description {
  color: #fff;
}
.our-process
  .our-process-hero
  .our-process-hero-content
  .content-wrapper
  .content-description
  a {
  color: #58c7f1 !important;
}
.our-process-desc {
  max-width: 1200px;
  padding: 80px 20px;
  margin: 0 auto;
  display: flex;
  gap: 30px;
}
.our-process-desc .our-process-desc-left {
  width: 30%;
}
.our-process-desc .our-process-desc-left .title {
  font-size: 24px;
  line-height: 1.4;
  font-weight: 300;
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 20px;
}
.our-process-desc .our-process-desc-left .subtitle {
  margin: 20px 0;
}
.our-process-desc .our-process-desc-left .card {
  margin-top: 20px;
  padding: 40px;
  background-color: #fafafa;
}
.our-process-desc .our-process-desc-left .card .card-title {
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-style: italic;
}
.our-process-desc .our-process-desc-left .card .card-description {
  margin-top: 20px;
}

.our-process-desc .our-process-desc-right {
  width: 70%;
}
.our-process-desc .our-process-desc-right .card-item {
  background-color: #fafafa;
  padding: 40px;
  border-top: 2px solid #007ca1;
}
.our-process-desc .our-process-desc-right .card-item:not(:first-child) {
  margin-top: 40px;
}
.our-process-desc .our-process-desc-right .card-item .card-item-title {
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 4px;
  font-style: italic;
  margin: 0;
}
.our-process-desc .our-process-desc-right .card-item .card-item-desc {
  margin: 0;
  padding: 0;
  margin-top: 20px;
}

.blog {
  padding-top: 120px;
  background-color: #fafafa;
}
.blog-area {
  max-width: 1200px;
  padding: 80px 20px;
  margin: 0 auto;
}
.blog-area .blog-area-title {
  margin: 0;
  margin-bottom: 25px;
  font-size: 35px;
}
.blog-wrapper {
  display: flex;
  gap: 30px;
}
.blog-wrapper .blog-content {
  width: 70%;
}
.blog-wrapper .blog-content .blog-content-top {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
}
.blog-wrapper .blog-content .blog-content-top .image {
  background-size: cover;
  width: 100%;
  height: 320px;
  background-repeat: no-repeat;
}
.blog-wrapper .blog-content .blog-content-top h2 {
  color: #444;
  font-weight: 300;
  margin: 0;
  margin-bottom: 10px;
  font-size: 24px;
}
.blog-wrapper .blog-content .blog-content-top .links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.blog-wrapper .blog-content .blog-content-top .links a {
  border: 1px solid #000;
  padding: 3px 8px;
  font-size: 15px;
  position: relative;
  z-index: 2;
}
.blog-wrapper .blog-content .blog-content-top .links a:first-child {
  background-color: #000;
  color: #fff !important;
}
.blog-wrapper .blog-content .blog-content-top .read-more {
  padding: 15px;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  margin: 0;
}
.blog-wrapper .blog-content .blog-content-top .user {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #e1e1e1;
  margin-top: 8px;
  padding: 18px;
  font-size: 14px;
}
.blog-wrapper .blog-content .blog-content-top .user i {
  font-size: 18px;
}
.blog-wrapper .blog-content .blog-content-top .details-link {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.blog-wrapper .blog-sidebar {
  width: 30%;
}
.blog-wrapper .blog-sidebar .item {
  border: 1px solid #e0e0e0;
  padding: 2rem;
  background-color: #fff;
}

.blog-wrapper .blog-sidebar .item .date-select hr {
  margin: 20px auto;
}
.blog-wrapper .blog-sidebar .item .date-select ul {
  list-style: none;
  margin: 0;
}
.blog-wrapper .blog-sidebar .item .date-select ul li {
  margin: 0;
}
.blog-wrapper .blog-sidebar .item .date-select ul li:not(:last-child) {
  margin-bottom: 10px;
}
.blog-wrapper .blog-sidebar .item:not(:last-child) {
  margin-bottom: 16px;
}
.blog-wrapper .blog-sidebar .item h2 {
  font-size: 24px;
  font-weight: 300;
  margin: 0;
  margin-bottom: 24px;
  text-align: center;
}
.blog-wrapper .blog-sidebar .item p {
  margin: 0;
}
.blog-wrapper .blog-sidebar .item .item-element {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}
.blog-wrapper .blog-sidebar .item .item-element .error {
  color: #f00000;
}
.blog-wrapper .blog-sidebar .item .item-element a {
  padding: 3px 8px;
  font-size: 16px;
  border: 1px solid #000;
}
.blog-wrapper .blog-sidebar .item .item-element.category a {
  background-color: #000;
  color: #fff !important;
}
.blog-wrapper .blog-sidebar .item button {
  margin-top: 24px;
  padding: 0;
  background-color: inherit;
  color: #000;
}
.blog-wrapper .blog-sidebar .item button:hover {
  text-decoration: none;
}
.single-blog {
  padding-top: 134px;
  background-color: #fafafa;
}
.single-blog-spinner {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -120px;
}
.single-blog-spinner .react-loading-skeleton {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
.single-blog .icon i {
  font-size: 20px;
  color: #000;
}
.blog-content-bottom {
  margin-top: 20px;
}
.blog-content-bottom:not(:first-child) {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.blog-details {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
}
.blog-details .blog-wrapper {
  display: flex;
  gap: 30px;
}
.blog-details .top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.blog-details .area {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  padding: 24px;
  width: 70%;
}
.blog-details .area-title {
  width: 100%;
  font-size: 36px;
  font-family: roboto;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
  margin: 0px 0px 30px !important;
}
.blog-details .area-user {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.blog-details .area-social {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  margin-bottom: 16px;
}
.blog-details .area-social li {
  margin: 0;
}
.blog-details .area-social i {
  display: flex;
  align-items: center;
  width: 35px;
  height: 35px;
  justify-content: center;
  color: #007ca1;
  border-radius: 50%;
  border: 2px solid #007ca1;
}

.blog-details .area-links {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
.blog-details .area-links a {
  border: 1px solid #000;
  padding: 3px 8px;
  font-size: 15px;
}
.blog-details .area-links a:first-child {
  background-color: #000;
  color: #fff !important;
}
.blog-details .area-main-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 16px;
}
.blog-details .area-image {
  margin-bottom: 16px;
}
.blog-details .area-content h2,
.blog-details .area-content h3 {
  font-size: 32px;
  margin: 0;
  margin-bottom: 16px;
}
.blog-details .area-content a {
  color: #007ca1 !important;
}
.blog-details .blog-wrapper .related-post {
  width: 30%;
}
.blog-details .blog-wrapper .related-post .item {
  border: 1px solid #e0e0e0;
  padding: 2rem;
  background-color: #fff;
}

.blog-details .blog-wrapper .related-post:not(:last-child) {
  margin-bottom: 16px;
}
.blog-details .blog-wrapper .related-post h2 {
  font-size: 24px;
  font-weight: 300;
  margin: 0;
  margin-bottom: 24px;
  text-align: center;
}
.blog-details .blog-wrapper .related-post p {
  margin: 0;
}
.blog-details .blog-wrapper .related-post button {
  margin-top: 24px;
  padding: 0;
  background-color: inherit;
  color: #000;
}
.blog-details .blog-wrapper .related-post button:hover {
  text-decoration: none;
}
.blog-wrapper .related-post .item-element .content {
  display: flex;
  gap: 8px;
}
.blog-wrapper .related-post .item-element a {
  border: none !important;
}
.blog-wrapper .related-post .item-element a:not(:last-child) {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border: none;
  border-bottom: 1px solid #444 !important;
  display: inline-block;
}
.blog-wrapper .related-post .item-element .content .image {
  max-width: 80px;
}
.blog-wrapper .related-post .item-element .content .image img {
  width: 100%;
  height: 100%;
}
.blog-wrapper .related-post .item-element .content .details p {
  margin: 0;
}

/* commercial automation  */
.commercial-page .solutions-svg {
  max-width: 10%;
  margin-left: auto;
  margin-right: auto;
  stroke-width: 2;
}
.commercial-page .outline {
  fill: #00000000;
  stroke: #fff;
}
.commercial-page .commercial-automantion-video {
  height: 85vh;
}

.commercial-page .pointsmade {
  text-transform: uppercase;
}
.commercial-page .wp-block-group__inner-container h1 {
  margin-bottom: 20px !important;
}
.commercial-page .wp-block-group__inner-container .minigray {
  margin-bottom: 30px;
  color: #fff;
  text-shadow: #575555 0.05em 0.05em 0.1em;
  text-transform: uppercase;
}
.commercial-page .commercial-automation-ul {
  font-size: 16px;
  font-weight: 300;
  color: #666;
  list-style: none;
}
.commercial-page .commercial-automation-ul li {
  margin: 0;
  padding-left: 25px;
  position: relative;
  margin-bottom: 7px;
}
.commercial-page .commercial-automation-ul li::before {
  content: "\\f00c";
  font-family: "FontAwesome";
  position: absolute;
  top: 0;
  left: 0;
}

.commercial-page .commercial-automation-bottom {
  text-align: center;
  padding: 80px 0;
}
.commercial-page .commercial-automation-bottom a {
  font-size: 25px;
}
.commercial-page .commercial-automation-bottom .button {
  background-color: #007ca1;
  color: #fff !important;
  padding: 10px 30px !important;
  border-radius: 30px;
  margin-top: 20px !important;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px !important;
  border: 1px solid transparent;
}

.commercial-page .commercial-automation-bottom h2 {
  font-size: 36px;
  font-family: roboto;
  text-transform: capitalize;
  font-weight: 300;
  color: #007ca1;
  margin: 30px 0 !important;
}

/* commercial-technology */
.commercial-technology .title-inner .section-grid .grid-item-1 {
  width: 66.67%;
}
.commercial-technology .title-inner .section-grid .grid-item-2 {
  width: 33.33%;
}

.footer-middle {
  margin-top: 70px;
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
  border-bottom: 1px solid #444;
}
.footer-middle .footer-middle-wrapper {
  margin: 20px auto;
  max-width: 750px;
}
.footer-middle .footer-middle-area {
  display: grid;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 15px;
}
.footer-middle .footer-middle-area .footer-middle-image img {
  width: 100%;
  height: 100%;
}
.footer-bottom {
  margin: 35px 0;
}
.footer-bottom .toTop {
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
}
.footer-bottom .section-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.footer-bottom .section-inner .right-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin: 0;
  list-style: none;
}
.footer-bottom .middle-footer p {
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  color: #666;
  font-size: 12px;
}
.footer-bottom .left-footer p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0;
  color: #666;
  font-size: 12px;
}
.footer-bottom .left-footer p a:hover {
  color: #007ca1 !important;
}
.footer-bottom .left-footer .license-number {
  text-align: end;
  display: inherit;
  padding-top: 3px;
}

/* control4 */
.home-standard {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}
.home-standard::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.home-standard .home-standard-area {
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
}
.home-standard .home-standard-area .content {
  width: 450px;
  position: relative;
}
.home-standard .home-standard-area .content .top {
  padding: 40px;
  background-color: #fafafa;
}
.home-standard .home-standard-area .content .top h3 {
  font-size: 36px;
  font-weight: 300;
  line-height: 1.2;
  text-transform: uppercase;
  margin: 0;
  color: #007ca1;
}
.home-standard .home-standard-area .content .top p {
  margin: 0;
  margin-top: 20px;
}
.home-standard .home-standard-area .content .image {
  display: none;
}
.home-standard .home-standard-area .content .bottom {
  margin-top: 40px;
  padding-bottom: 70px;
}
.home-standard .home-standard-area .content .bottom h4 {
  font-weight: 300;
  text-transform: uppercase;
  font-size: 24px;
  line-height: 1;
  letter-spacing: 0.02em;
  margin: 0;
  margin-bottom: 5px;
  color: #fff;
}
.home-standard .home-standard-area .content .bottom h6 {
  font-size: 16px;
  line-height: 1.1;
  letter-spacing: 0.03em;
  font-weight: 300;
  margin: 0;
  color: #fff;
}
.home-standard .home-standard-area .content .bottom a {
  margin: 20px 0;
  padding: 0 25px;
  background-color: transparent;
  color: #fff !important;
  border: 1px solid #fff !important;
  line-height: 42px;
  text-align: center;
  border-radius: 30px;
  display: inline-block;
  font-size: 18px;
}
.home-standard .home-standard-area .content .bottom a:hover {
  background-color: #fff;
  color: #000 !important;
}

.control4-nav {
  max-width: 1600px;
  padding: 65px 30px;
  margin: 0 auto;
}
.control4-nav.indoor-living-mobile-nav {
  display: none;
}
.control4-nav .control4-nav-area {
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: space-between;
}

.control4-nav .control4-nav-area .nav-area {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  justify-content: center;
}
.control4-nav .control4-nav-area .nav-area a {
  display: inline-block;
  border: 1px solid #007ca1 !important;
  color: #007ca1 !important;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 300;
  font-size: 14px;
  text-transform: uppercase;
  background-color: transparent;
  display: flex;
  align-items: center;
}
.control4-nav .control4-nav-area .nav-area a:hover {
  background-color: #007ca1 !important;
  color: #fff !important;
}

.control4 {
  width: 100%;
}
.control4 .control4-hero {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.control4 .control4-hero::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.control4 .control4-hero video {
  position: absolute;
  left: 50%;
  top: 50%;
  width: auto !important;
  z-index: -100;
  height: auto;
  min-height: 100vh;
  transform: translate(-50%, -50%);
  object-fit: cover;
}
.control4 .control4-hero img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}
.control4 .control4-hero .control4-content {
  position: absolute;
  bottom: 0;
  max-width: 1300px;
  left: 50%;
  transform: translateX(-50%);
}
.control4 .control4-hero .control4-content h1 {
  font-size: 32px;
  font-weight: 300;
  color: #fff;
  margin: 0;
  margin-bottom: 45px;
  text-shadow: #747474 0.05em 0.05em 0.1em;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.control4 .control4-hero .control4-content p {
  color: #fff;
  text-shadow: #747474 0.05em 0.05em 0.1em;
  text-align: center;
}
.control4 .control4-hero .control4-content a {
  display: inline-block;
  border: 1px solid #aaa;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 300;
  color: #fff;
  font-size: 14px;
  margin: 0px 15px;
  text-transform: uppercase;
  background-color: rgba(0, 0, 0, 0.35);
}
.control4 .control4-hero .control4-content a:hover {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}
.control4-feature .feature-area {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.control4-feature .feature-area .feature-item {
  position: relative;
}
.control4-feature .feature-area .feature-item::before {
  position: absolute;
  content: "";
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.5s;
}
.control4-feature .feature-area .feature-item:hover::before {
  opacity: 1;
}
.control4-feature .feature-area .feature-item .content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.5s;
  width: 90%;
}
.control4-feature .feature-area .feature-item:hover .content {
  opacity: 1;
}
.control4-feature .feature-area .feature-item .content h5 {
  color: #fff;
}
.control4-feature .feature-area .feature-item .content p {
  color: #fff;
}
.control4-empty {
  padding: 60px 0;
}

.swiper-wrapper {
  margin-bottom: 50px;
}
.swiper-pagination-clickable .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #58c7f1;
}
.control4-featureV2 .control4-featureV2-top {
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 30px 0;
}

.control4-featureV2 .control4-featureV2-top .item .title {
  margin: 0 auto;
  font-size: 24px;
  line-height: 1;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  overflow: hidden;
  text-align: center;
}
.control4-featureV2 .control4-featureV2-top .item .title > * {
  display: inline-block;
  position: relative;
}
.control4-featureV2 .control4-featureV2-top .item .title > ::after,
.control4-featureV2 .control4-featureV2-top .item .title > ::before {
  content: "";
  position: absolute;
  top: calc(50% - (calc(2px + 0.02em) / 2));
  width: 2000px;
  border-bottom: calc(2px + 0.02em) solid #e7e7e7;
}
.control4-featureV2 .control4-featureV2-top .item .title > ::before {
  right: 100%;
  margin-right: calc(5px + 0.3em);
}
.control4-featureV2 .control4-featureV2-top .item .title > ::after {
  left: 100%;
  margin-left: calc(5px + 0.3em);
}
.control4-featureV2 .control4-featureV2-top .item .item-content .item-image {
  margin-top: 10px;
}
.control4-featureV2 .control4-featureV2-top .item .item-content {
  position: relative;
}
.control4-featureV2 .control4-featureV2-top .item .item-content p {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  padding: 30px;
  color: #fff;
  opacity: 0;
  transition: all 0.5s;
}
.control4-featureV2 .control4-featureV2-top .item .item-content::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #007ca1;
  opacity: 0;
  transition: all 0.5s;
}
.control4-featureV2 .control4-featureV2-top .item .item-content:hover::before {
  opacity: 1;
}
.control4-featureV2 .control4-featureV2-top .item .item-content:hover p {
  opacity: 1;
}
.control4-brands {
  max-width: 1200px;
  padding: 65px 30px;
  margin: 0 auto;
}
.control4-brands .control4-brands-area {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  justify-content: space-between;
}
.control4-brands .control4-brands-area .top h3 {
  font-size: 36px;
  line-height: 1.2;
  font-weight: 300;
  text-transform: uppercase;
  margin: 0;
  color: #007ca1;
}
.control4-brands .control4-brands-area .top h5 {
  font-size: 20px;
  line-height: 1.1;
  font-weight: 300;
  margin: 0 0 20px 0;
  color: #222;
  text-transform: uppercase;
}
.control4-brands .control4-brands-area .nav-area {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}
.peace-of-mind .peace-of-mind-left h3 {
  font-size: 36px;
  line-height: 1.2;
  margin: 0;
  font-weight: 300;
  text-transform: uppercase;
  color: #007ca1;
}
.peace-of-mind .peace-of-mind-left h5 {
  font-size: 20px;
  line-height: 1.1;
  font-weight: 300;
  margin: 0 0 20px 0;
  color: #222;
  text-transform: uppercase;
}
.peace-of-mind .peace-of-mind-left p {
  margin: 10px 0;
}
.peace-of-mind .peace-of-mind-right h3 {
  font-size: 36px;
  line-height: 1.2;
  margin: 0;
  font-weight: 300;
  text-transform: uppercase;
}
.peace-of-mind .peace-of-mind-right a {
  font-size: 14px;
}
.uk-overlay-default {
  background-color: linear-gradient(
    0deg,
    rgba(8, 8, 9, 0.8) 11%,
    rgba(0, 0, 0, 0) 100%
  );
}
.el-slidenav svg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.12);
  border: 1px solid #fff;
  color: #fff;
  padding: 5px;
  display: flex;
}
.uk-dotnav a {
  width: 12px;
  height: 12px;
}
.uk-dotnav .uk-active a {
  background-color: #007ca1;
}
.uk-position-absolute.icon i {
  background-color: #007ca1;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.golf-simulators-left h4 {
  font-size: 26px;
  line-height: 1.4;
  letter-spacing: 0.25px;
  text-align: center;
  margin: 0;
  margin-bottom: 20px;
  color: #007ca1;
  font-weight: 500;
  text-transform: capitalize;
}
.golf-simulators-left i {
  text-align: center;
  display: inherit;
  font-size: 35px;
  color: #007ca1;
  margin-bottom: 20px;
}
.golf-simulators-title {
  font-size: 38px;
  margin: 0;
  margin-bottom: 30px;
  font-weight: 400;
  line-height: 1.3;
  color: #007ca1;
}
.golf-simulators-left p {
  font-style: italic;
}
.golf-simulators .uk-margin {
  margin-top: 50px !important;
}
.golf-simulators-left .content {
  background-color: #fafafa;
}
.golf-simulators ul {
  position: inherit;
}
.golf-simulators ul li {
  margin: 0;
  padding: 0;
}
#page\\#0 {
  padding-left: 30px;
  padding-right: 0px;
}
.golf-simulators ul li h3 {
  font-size: 36px;
  font-weight: 400;
}
.golf-simulators ul li a {
  font-size: 14px;
  padding: 0;
  margin-left: 20px;
  border-bottom: 2px solid transparent;
}
.golf-simulators-video {
  overflow: hidden;
  position: relative;
  padding: 70px 0;
}
.golf-simulators-video video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.golf-simulators-video .video-container {
  max-width: 1200px;
  margin: 0px auto;
  position: relative;
  z-index: 99;
}
.golf-simulators-video .video-content {
  width: 450px;
  padding: 25px;
  margin-left: auto;
}
.golf-simulators-video .video-content.left {
  margin-right: auto;
  margin-left: 0;
}
.golf-simulators-video .video-content h1 {
  margin: 0;
  padding: 40px 0 20px;
  font-size: 44px;
  color: #fff;
  font-weight: 500;
  position: relative;
}
.golf-simulators-video .video-content h1::before {
  position: absolute;
  content: "";
  left: 0;
  border-top: 3px solid #007ca1;
  width: 54px;
  top: 0;
}
.golf-simulators-video .video-content p {
  margin: 30px 0;
  color: #fff;
}
.request-quote h5 {
  margin: 0;
  margin-bottom: 20px;
  color: #007ca1;
  font-weight: 300;
}
.request-quote .message-icon {
  text-align: center;
  color: #007ca1;
}
.careers-team .careers-team-title {
  font-size: 44px;
  line-height: 1.2;
  font-weight: 300;
  letter-spacing: -1.5px;
  margin: 0;
  margin-bottom: 30px;
  color: #007ca1;
}
.careers-team h3 {
  font-size: 30px !important;
  line-height: 1.2;
  font-weight: 300;
  letter-spacing: -0.75px;
  margin-top: 40px;
  margin-bottom: 30px;
  color: #333;
}
.careers-team ul {
  margin: 0;
  padding: 0;
}
.careers-team ul li {
  margin: 0;
  padding: 0;
}
.careers-team ul li p {
  font-size: 16px;
  color: #007ca1;
}

.convertforms .cf-control-group {
  padding: 9px;
  max-width: 100%;
  width: 100%;
  min-width: 120px;
  flex-grow: 1;
}
.apply-now h3 {
  font-size: 44px;
  margin: 0;
  margin-bottom: 40px;
  font-weight: 300;
  color: #007ca1;
}
.apply-now form label {
  padding: 10px;
}
.apply-now form input,
.apply-now form textarea {
  margin-top: 15px;
  border: 1px solid #444;
}
.apply-now form input:focus,
.apply-now form textarea:focus {
  outline: none;
  border: 1px solid #444;
}

.about-us h1 {
  font-size: 44px;
  margin: 0;
  margin-bottom: 40px;
  font-weight: 300;
}

/* commercial automation  */
.commercial-page .commercial-automantion-video {
  height: 85vh;
}
.commercial-page .pointsmade {
  text-transform: uppercase;
}
.commercial-page .wp-block-group__inner-container h1 {
  margin-bottom: 20px !important;
}
.commercial-page .wp-block-group__inner-container .minigray {
  margin-bottom: 30px;
  color: #fff;
  text-shadow: #575555 0.05em 0.05em 0.1em;
  text-transform: uppercase;
}
.commercial-page .commercial-automation-ul {
  font-size: 16px;
  font-weight: 300;
  color: #666;
  list-style: none;
}
.commercial-page .commercial-automation-ul li {
  margin: 0;
  padding-left: 25px;
  position: relative;
  margin-bottom: 7px;
}
.commercial-page .commercial-automation-ul li::before {
  content: "\\f00c";
  font-family: "FontAwesome";
  position: absolute;
  top: 0;
  left: 0;
}

.commercial-page .commercial-automation-bottom {
  text-align: center;
  padding: 80px 0;
}
.commercial-page .commercial-automation-bottom a {
  font-size: 25px;
}

.commercial-page .commercial-automation-bottom h2 {
  font-size: 36px;
  font-family: roboto;
  text-transform: capitalize;
  font-weight: 300;
  color: #007ca1;
  margin: 30px 0 !important;
}

/* commercial-technology */
.commercial-technology .title-inner .section-grid .grid-item-1 {
  width: 66.67%;
}
.commercial-technology .title-inner .section-grid .grid-item-2 {
  width: 33.33%;
}

.wp-block-group.homevideo.servicespages.commercial-automantion-video {
  height: 85vh;
}

/* portfolio page  */

.portfolio-page .Portfolio-navigation {
  background-color: #fff;
  margin: 70px 0;
  display: flex;
  justify-content: center;
}
.portfolio-page .Portfolio-navigation .Portfolio-navigation-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 10px;
}
.portfolio-page .Portfolio-navigation .Portfolio-navigation-container a {
  display: inline-block;
  border: 1px solid #007ca1 !important;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 300;
  color: #007ca1 !important;
  font-size: 14px;
  margin: 0px 15px;
  text-transform: uppercase;
  background-color: transparent;
}
.portfolio-page .Portfolio-navigation .Portfolio-navigation-container a:hover {
  background-color: #007ca1 !important;
  color: #fff !important;
}

.portfolio-page .portfolio-content {
  background-color: #fafafa;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 30px;
}
.portfolio-page .portfolio-content .connected-living-title-section {
  margin-top: 0px;
}
.portfolio-page
  .portfolio-content
  .connected-living-title-section
  .title-inner {
  max-width: 600px;
}
.portfolio-page .portfolio-content .portfolio-content-grid {
  max-width: 1600px;
  padding: 0 20px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 15px;
}

.portfolio-content a {
  color: #007ca1;
}
.portfolio-content a:hover {
  color: #289abd !important;
}
.portfolio-page
  .portfolio-content
  .portfolio-content-grid
  .portfolio-content-grid-item {
  width: 100%;
  height: 250px;
}
.portfolio-page
  .portfolio-content
  .portfolio-content-grid
  .portfolio-content-grid-item
  a {
  width: 100%;
  height: 100%;
  position: relative;
}
.portfolio-page
  .portfolio-content
  .portfolio-content-grid
  .portfolio-content-grid-item
  a::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition: all 0.3s;
  background-color: #007ca1;
  z-index: 1;
}
.portfolio-page
  .portfolio-content
  .portfolio-content-grid
  .portfolio-content-grid-item
  a:hover::before {
  opacity: 0.7;
}
.portfolio-page
  .portfolio-content
  .portfolio-content-grid
  .portfolio-content-grid-item
  img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.uk-lightbox-button {
  color: #fff !important;
  background-color: transparent;
  border-radius: 50%;
  border: 1px solid #fafafa;
}

.portfolio-page .portfolio-wrapper .minigray {
  font-size: 16px;
}
.portfolio-page .portfolio-wrapper .button__primary {
  margin-top: 0 !important;
}

/* josh ai */
.josh-ai-page .josh-ai-navigation {
  background-color: #fafafa;
  margin: 0;
  padding: 60px 0;
}
.josh-ai-page .josh-ai-navigation .josh-ai-navigation-grid {
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  max-width: 1400px;
  padding: 0 20px;
}

.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 10px;
}
.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container a {
  display: inline-block;
  border: 1px solid #007ca1;
  padding: 8px 20px;
  border-radius: 30px;
  font-weight: 300;
  color: #007ca1 !important;
  font-size: 14px;
  margin: 0px 15px;
  text-transform: uppercase;
  background-color: transparent;
}
.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container a:hover {
  background-color: #007ca1 !important;
  color: #fff !important;
}

.josh-ai-page .text-32 {
  color: #666;
  font-size: 16px;
  font-weight: 300;
}

.josh-ai-page .josh-ai-privacy h3 {
  font-size: 36px;
  font-family: roboto;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
}
.josh-ai-page .josh-ai-privacy h4 {
  font-size: 36px;
  font-family: roboto;
  text-transform: capitalize;
  font-weight: 300;
  color: #007ca1;
}
.josh-ai-page .josh-ai-tab a {
  font-size: 14px;
}
.uk-tile-secondary,
.uk-section-secondary {
  background-color: #007ca1 !important;
}
.josh-ai-page .josh-ai-bottom h5 {
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #007ca1;
}
.max-width-hero {
  max-width: 1200px !important;
}

.privacy-policy {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  padding-top: 135px;
}
.privacy-policy h3,
h4,
h5,
h6 {
  margin-top: 0px;
}
.privacy-policy h6 {
  letter-spacing: 0;
  text-transform: capitalize;
  margin-bottom: 10px;
}
.privacy-policy a {
  color: blue;
  text-decoration: underline;
}
.hero video {
  background-color: #007ca1;
}
.commercial-security .commercial-security-icon {
  width: 120px;
}
.commercial-security .commercial-security-content-main {
  background-color: rgba(31, 31, 31, 0.6);
  justify-content: center;
}
.commercial-security .commercial-security-area {
  max-width: 750px;
  max-width: 750px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.commercial-security .commercial-security-area h1 {
  margin-bottom: 10px;
}
.commercial-security .commercial-security-area h1,
.commercial-security .commercial-security-area h6 {
  color: #fff;
}
.commercial-security .commercial-security-icon .outline {
  fill: #00000000;
  stroke: #fff;
}

.math-question {
  display: inline-flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  padding: 15px;
}
.math-question > label {
  width: 140px;
  margin: 0;
  font-weight: 700;
}
.math-question > input {
  width: 150px;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  margin: 0 !important;
}

.contactarea .wpcf7-form .math-question {
  padding-bottom: 12px;
  padding-top: 12px;
  border-radius: 30px;
  margin-bottom: 10px;
}
.contactarea .wpcf7-form .math-question > label {
  color: #fff;
}
.contactarea .wpcf7-form .math-question > input {
  background-color: rgba(23, 25, 26, 0.85);
  border-radius: 30px;
  color: #fff;
}

input[type="submit"]:disabled {
  background-color: #b4b4b4;
  cursor: not-allowed;
  color: white;
}
input[type="submit"]:disabled:hover {
  background-color: #b4b4b4;
  cursor: not-allowed;
  color: white;
}
button[type="submit"]:disabled {
  background-color: #b4b4b4;
  cursor: not-allowed;
  color: white;
}
button[type="submit"]:disabled:hover {
  background-color: #b4b4b4;
  cursor: not-allowed;
  color: white;
}

.contactarea .wpcf7-submit:disabled:hover {
  border: transparent;
  color: #fff !important;
}

.button__primary.display-block {
  display: block;
}

/*** Media Querry  ***/

@media only screen and (min-width: 1600px) {
  .tm-grid-expand > .a-day-life-width-expand\\@xl {
    flex-grow: 999;
  }
}
@media only screen and (max-width: 1400px) {
  .golf-simulators ul li a {
    padding: 5px;
  }
}
@media only screen and (min-width: 1200px) {
  #video-background.high4kres {
    position: absolute;
    left: 50%;
    top: 50%;
    min-width: auto;
    z-index: -100;
    max-width: none;
    height: auto !important;
    transform: translate(-50%, -50%);
    width: 100vw !important;
  }
  #video-background.fulltextvid {
    position: absolute;
    left: 0px;
    top: 0px;
    min-width: auto;
    min-height: auto;
    width: 101% !important;
    z-index: -100;
    max-width: none;
    height: auto !important;
    transform: none;
  }
  #video-background.customsized {
    width: 100% !important;
    min-width: 100%;
  }
  .tm-grid-expand > .a-day-life-width-expand\\@l {
    flex-grow: 999;
  }
  .a-day-life-grid {
    margin-left: -40px;
  }
  * + .a-day-life-grid-margin,
  .a-day-life-grid + .a-day-life-grid,
  .a-day-life-grid > .a-day-life-grid-margin {
    margin-top: 40px;
  }
  .csh-card .csh-card-content {
    padding: 40px 40px;
  }
  .our-process
    .our-process-hero
    .our-process-hero-content
    .content-wrapper
    .content-title {
    margin-bottom: 45px;
  }
  .our-process video {
    height: 700px;
  }
}
@media only screen and (max-width: 1200px) {
  .a-day-life-video-section video {
    height: 600px;
  }
  .a-day-life-video-section .video-content {
    position: inherit;
    width: auto;
    transform: inherit;
    left: 0;
  }
  .a-day-life-video-section .video-content.right-text {
    right: 0;
    left: 0;
    position: inherit;
  }
  .a-day-life-nav .nav-item {
    width: 33.33%;
    margin-top: 20px;
  }
  .josh-ai-page .josh-ai-hero-content {
    display: none;
  }
  .josh-new-content {
    display: block;
  }
  .wp-block-group.homevideo.servicespages {
    height: inherit;
  }
  .wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {
    height: inherit;
  }
  .servicesdualcontainer {
    display: block;
    padding: 0px !important;
  }
  .servicesimages.wp-block-column {
    margin: 0px !important;
    padding: 1px 2px;
  }
  .servicestextcontainer {
    padding: 90px 30px 60px !important;
    max-width: inherit;
  }
  .servicesimages.sidevideo.wp-block-column {
    margin: 1px 2px !important;
  }
  .servicesimages.sidevideoleft.wp-block-column {
    margin: 1px 2px !important;
  }

  .nav-toggle .toggle-inner {
    margin-top: -30px;
  }
  .nav-toggle .toggle-text {
    color: #fff !important;
    font-weight: 300;
    text-transform: uppercase;
  }
  .site-logo img {
    max-height: 4rem;
  }
  .servicessubs {
    padding: 0px;
  }
  .servicessubs .wp-block-group__inner-container p {
    display: none;
  }
  #video-background {
    position: relative;
    left: inherit;
    top: inherit;
    min-width: inherit;
    width: 100% !important;
    z-index: -100;
    max-width: none;
    height: auto !important;
    transform: inherit;
    object-fit: cover;
  }
  .footer-widgets.column-two {
    margin-top: 0px;
  }
  .servicesimages.sidevideo #video-background {
    position: absolute;
    left: 50%;
    top: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto !important;
    z-index: 1;
    max-width: none;
    height: 100% !important;
    transform: translate(-50%, -50%);
  }
  .footerlinks {
    display: block;
    overflow: hidden;
  }
  .footerlinks1 {
    width: 50%;
    float: left;
  }
  .footerlinks2 {
    float: left;
    width: 50%;
  }
  .footerlinks1 img {
    max-width: 200px;
  }
  .wp-block-group.homevideo {
    height: inherit;
  }
  .wp-block-group.homevideo > .wp-block-group__inner-container {
    height: inherit;
  }
  .pagecolumns .wp-block-column {
    flex-basis: 250px !important;
  }
  .pagecolumns .wp-block-column:first-child {
    flex-basis: 100% !important;
  }
  .picturetime figcaption {
    font-weight: 300;
  }
  .picturetime figcaption strong {
    font-weight: 500;
  }
  .pickanarea {
    flex-direction: column;
    padding-bottom: 45px;
  }
  .pickanarea > .wp-block-column {
    max-width: 100%;
    margin-left: 0px;
  }
  .pickanarea > .wp-block-column > .wp-block-columns {
    margin: 2rem 0px;
  }
  h2.pickareaheading {
    padding: 45px 30px 45px;
  }
  .footer-widgets.column-one div:first-child {
    width: 100%;
  }
  .footer-widgets.column-one {
    align-items: stretch;
    min-height: inherit;
  }
  .fullimagetop {
    height: 65vh !important;
  }
  .homedualcontainer {
    display: block;
    overflow: hidden;
    padding: 60px 0px 0px !important;
  }
  .homedual2.homelighting,
  .homedual2.homeshow2,
  .homedual2.homeshow3 {
    height: 600px;
    background-position: left center !important;
  }
  .iconsbox {
    text-align: center;
    padding: 0px !important;
    float: left;
    width: 50%;
  }
  .homedual2 {
    overflow: hidden;
  }
  .homedual2.duallefttext {
    text-align: center;
  }
  .hideonshow {
    opacity: 1;
  }
  .duallefttext .iconsbox {
    flex-direction: column;
  }
  .homedualcontainer .duallefttext p {
    display: block;
  }
  .duallefttext .iconsbox .wp-block-column {
    margin: 0px 0px 30px 0px !important;
  }
  .portfolio-page .portfolio-content .portfolio-content-grid {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  .commercial-technology .wp-block-group.homevideo.servicespages {
    height: 70vh !important;
  }
  .wp-block-group.homevideo.servicespages.commercial-automantion-video {
    height: 70vh;
  }
  .josh-ai-page .josh-ai-navigation .josh-ai-navigation-grid {
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
  .portfolio-page .portfolio-wrapper .career-background {
    padding: 20px 20px !important;
  }
}
@media only screen and (max-width: 1080px) {
  .homephone {
    display: none !important;
  }
  .brandscolumn .wp-block-column {
    width: 40%;
  }
  .brandscolumn .wp-block-column:nth-child(3n + 1) {
    margin-left: 32px;
  }
  .brandscolumn .wp-block-column:nth-child(2n + 1) {
    margin-left: 0px;
  }
  .duallefttext .iconsbox {
    display: block;
    width: 100%;
  }
  .homedualcontainer .duallefttext .fas,
  .homedualcontainer .duallefttext .far {
    color: #d4d4d4;
    float: left;
    padding: 7px 0px 10px 0px;
    overflow: hidden;
    line-height: 1;
    font-size: 24px;
    border: none !important;
    width: auto;
    float: none;
  }
  .duallefttext .iconsbox .wp-block-column {
    text-align: center;
  }
  .iconsbox {
    width: 100%;
    margin: 0px !important;
  }
  .homedualcontainer h2 {
    font-size: 18px !important;
    margin-bottom: 10px !important;
  }
  .homedual2 {
    padding: 60px 30px;
  }
  .homedualcontainer {
    padding: 0px !important;
  }
  .homedualcontainer.bottomdual {
    padding: 0px !important;
  }
  .control4small.homecedialogo a {
    left: 50%;
    right: 50%;
    width: 120px;
    height: 120px;
    transform: translate(-50%, -50%);
  }
  .commercial-technology .title-inner .section-grid .grid-item-1 {
    width: 100%;
  }
  .commercial-technology .title-inner .section-grid .grid-item-2 {
    width: 100%;
  }
}
@media only screen and (max-width: 1000px) {
  .commercial-page .wp-block-group__inner-container h1 {
    display: none;
  }
  li.menu-item-3288 {
    position: relative;
    margin-top: 0px;
  }
  .wp-block-group.homevideo {
    margin-top: 100px !important;
  }
  .control4-empty {
    padding: 40px;
  }
  .serviceswhitebackground p {
    padding: 0 20px 20px !important;
  }
  .control4 .control4-hero {
    height: 75vh;
  }
  .control4-nav .control4-nav-area {
    flex-direction: column;
  }
  .golf-simulators-video {
    padding: 50px 0;
  }
  .control4 .control4-hero video {
    height: 75vh;
  }
  .control4 .control4-hero .control4-content {
    width: 100%;
    padding: 0 30px;
  }
  .control4-featureV2 .control4-featureV2-top {
    flex-direction: column;
  }
  .control4-featureV2 .control4-featureV2-top .item {
    width: 100%;
  }
  .our-process-desc {
    flex-wrap: wrap;
  }
  .our-process-desc .our-process-desc-left {
    width: 100%;
  }
  .our-process-desc .our-process-desc-right {
    width: 100%;
  }
  .our-process-desc .our-process-desc-left .card {
    padding: 20px;
  }
  .our-process-desc .our-process-desc-right .card-item {
    padding: 30px;
  }
  .blog-wrapper {
    flex-wrap: wrap;
  }
  .blog-wrapper .blog-content {
    width: 100%;
  }
  .blog-wrapper .blog-sidebar {
    width: 100%;
  }
  .blog-details .blog-wrapper {
    flex-wrap: wrap;
  }
  .blog-details .blog-wrapper .area {
    width: 100%;
  }
  .blog-details .blog-wrapper .related-post {
    width: 100%;
  }
  .commercial-technology .title-inner .section-grid .grid-item-1 {
    width: 100%;
  }
  .commercial-technology .title-inner .section-grid .grid-item-2 {
    width: 100%;
  }
  .footer-middle .footer-middle-area {
    grid-template-columns: 1fr 1fr;
    justify-content: center;
  }
  .footer-middle {
    margin-top: 40px;
  }
  .footer-bottom {
    margin-top: 30px;
  }
  .footer-bottom .section-inner {
    flex-wrap: wrap;
  }
  .footer-bottom .section-inner .right-footer {
    margin: 0 auto;
  }
  .footer-bottom .section-inner .middle-footer {
    text-align: center;
  }
  .footer-bottom .section-inner .left-footer {
    margin: 0 auto;
  }
  .home-standard .home-standard-area .content {
    width: 100%;
  }
  .home-standard .home-standard-area .content .bottom {
    margin-top: 30px;
  }
  .golf-simulators-video {
    padding: 50px 0;
  }
  .golf-simulators-video .video-content {
    width: 100%;
    padding: 30px;
  }
  .request-quote img {
    margin: 0 auto;
  }

  .portfolio-page .portfolio-content .portfolio-content-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media only screen and (max-width: 960px) {
  .josh-ai-big-feature {
    margin-top: 400px;
  }
  .josh-ai-big-image img {
    width: 400px;
    height: 400px;
  }
  .indoor-living-about .indoor-living-about-box {
    width: 100%;
  }
  .indoor-living-about .indoor-living-feature {
    width: 100%;
  }
  .title-inner .section-grid .grid-item-1 {
    width: 100%;
    margin-bottom: 40px;
  }
  .title-inner .section-grid .grid-item-2,
  .title-inner .section-grid .grid-item-3 {
    width: 50%;
  }
  .csca .csca-content-area {
    padding: 0 30px 30px 30px;
  }
  .extra-padding {
    padding: 35px 0;
  }
  .commercial-security-wrapper {
    height: 100vh;
    background-position: right;
    background-size: cover;
  }
}
@media only screen and (min-width: 960px) {
  .tm-grid-expand > .a-day-life-width-expand\\@m {
    flex-grow: 999;
  }
  .uk-h1,
  h1 {
    font-size: 44px;
  }
  .uk-h2,
  h2 {
    font-size: 38px;
  }
}
@media only screen and (min-width: 900px) {
  .a-day-life-section {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .a-day-life-container {
    padding-left: 40px;
    padding-right: 40px;
  }
  .uk-section-xlarge {
    padding-top: 210px;
    padding-bottom: 210px;
  }
}
@media only screen and (max-width: 768px) {
  .footer-bottom {
    margin-top: 0px;
  }
  .footerlinks {
    padding-bottom: 0;
  }
  .footer-middle {
    display: none;
  }
  .footer-bottom .section-inner {
    flex-direction: column;
  }
  .footer-bottom .section-inner .left-footer .license-number {
    text-align: center;
  }
}
@media only screen and (max-width: 728px) {
  .homedual2.homelighting,
  .homedual2.homeshow2,
  .homedual2.homeshow3 {
    height: 300px;
    background-size: cover;
  }
  .wp-block-group.homevideo.servicespages {
    height: inherit !important;
  }
  .wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {
    height: inherit !important;
  }
  .homeintrotop h1 {
    font-size: 30px;
    font-weight: 300;
  }
  .pagewhitebackground h2 {
    font-size: 24px;
  }
  .pagecolumns .wp-block-column:first-child {
    border-right: none;
    padding-right: 0px;
    margin-right: 0px;
  }
  .pagewhitebackground {
    padding: 45px 30px 30px !important;
  }
  .servicestextcontainer {
    padding: 45px 30px 45px !important;
  }
  .homeintrotop.centerintro {
    padding: 45px 15px 0px;
  }
  .serviceswhitebackground {
    padding: 45px 30px 45px !important;
  }
  .servicesdualcontainer h2 {
    font-size: 24px;
  }
  .footerlinks1 {
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .footerlinks2 {
    width: 100%;
    padding-right: 30px;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #2c2f30;
  }
  .footerlinks1 i {
    max-width: 150px;
    margin: 0px auto;
  }
  .contactarea {
    display: block;
  }
  .pickanarea > .wp-block-column > .wp-block-columns .wp-block-column {
    flex-basis: 50% !important;
  }
  .pickanarea > .wp-block-column {
    margin-bottom: 0px;
  }
  .pickanarea > .wp-block-column > .wp-block-columns {
    margin: 0px;
  }
  .picturetime .wp-block-column {
    flex-basis: 50% !important;
    padding: 0px 10px;
    margin-bottom: 0px !important;
  }
  .contactareabox {
    padding: 40px 20px;
  }
  .contactareabox2 h3 {
    font-size: 24px;
  }
  .start-your-project .pagecolumns .wp-block-column:first-child {
    flex-basis: 100% !important;
    border: none !important;
  }

  .fullimagetop {
    height: 400px !important;
  }
  .halfimagetop {
    height: 400px;
  }
  .brandscolumn .wp-block-column {
    width: 100% !important;
    margin: 0px 0px 32px 0px !important;
  }
  .brandscolumn {
    display: block;
  }
  .wp-block-group.homevideo.servicespages.commercial-automantion-video {
    height: 40vh !important;
  }

  .commercial-technology .wp-block-group.homevideo.servicespages {
    height: 40vh !important;
  }

  .portfolio-page .portfolio-content .portfolio-content-grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (min-width: 700px) {
  .josh-ai-page .josh-ai-bottom h5 {
    margin: 0;
  }
}
@media only screen and (min-width: 640px) {
  .a-day-life-container {
    padding-left: 30px;
    padding-right: 30px;
  }
  .tm-grid-expand > .a-day-life-width-expand\\@s {
    flex-grow: 999;
  }
}
@media only screen and (max-width: 640px) {
  .a-day-life-video-section video {
    height: 400px;
  }
  .title-inner .section-grid .grid-item-1,
  .title-inner .section-grid .grid-item-2 {
    width: 100%;
    margin-bottom: 40px;
    padding: 0 25px;
  }
  .title-inner .section-grid .grid-item-3 {
    width: 100%;
    padding: 0 25px;
  }
  .grid-item-3 .icon-grid i {
    font-size: 50px;
  }
  .csca video,
  .csca .image {
    height: 260px;
  }
  .csca .csca-content {
    background-color: #fff;
  }
  .csca .csca-icon {
    width: 150px;
  }
  .csca .csca-icon .outline {
    fill: #00000000;
    stroke: #007ca1;
  }
  .csca .csca-content h1 {
    color: #333;
  }
  .csca .csca-content h6 {
    color: #333;
  }
}
@media only screen and (min-width: 600px) {
  .our-process video {
    height: 550px;
  }
  .our-process
    .our-process-hero
    .our-process-hero-content
    .content-wrapper
    .content-title {
    margin-bottom: 35px;
  }
}
@media only screen and (max-width: 600px) {
  .control4small.homecedialogo a {
    display: none;
  }
  .nav-drawer {
    width: 80% !important;
  }
  .control4 .control4-hero {
    height: 450px;
  }
  .control4 .control4-hero video {
    height: 450px;
  }
  .blog-content-bottom {
    grid-template-columns: 1fr;
  }
  .home-standard {
    background-image: none !important;
  }
  .home-standard .home-standard-area {
    padding: 0;
  }
  .home-standard .home-standard-area .content .image {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .home-standard::before {
    position: inherit;
  }
  .home-standard .home-standard-area .content .top {
    padding: 30px;
  }
  .home-standard .home-standard-area .content .bottom {
    padding: 0 30px;
  }
  .home-standard .home-standard-area .content .bottom h4 {
    color: #000;
  }
  .home-standard .home-standard-area .content .bottom h6 {
    color: #000;
  }
  .home-standard .home-standard-area .content .bottom a,
  .home-standard .home-standard-area .content .bottom a:hover {
    background-color: #000;
  }
}
@media only screen and (max-width: 550px) {
  .site-logo img {
    width: 140px;
  }
  #video-background.fulltextvid {
    height: auto !important;
    width: 100% !important;
  }
  .fullimagetop {
    height: 300px !important;
  }
  .halfimagetop {
    height: 300px;
  }
  .csca .csca-icon {
    width: 100px;
  }
}
@media only screen and (max-width: 500px) {
  .portfolio-page .portfolio-content .portfolio-content-grid {
    grid-template-columns: 1fr;
  }
  .footerlinks3 .review .mySwiper {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/custom.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;;;;;;;EAOE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;AACA;;;;;;;;EAQE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;EACjC,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,sEAAsE;EACtE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;;EAEE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;AACA;EACE,UAAU;AACZ;AACA,0BAC4C,WAAW,EACR,WAAW;EACxD,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;;;GAGG;AACH;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,yDAAuE;EACvE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yDAAmE;EACnE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,yDAAsE;EACtE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA;;EAEE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,UAAU;EAKV,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,UAAU;EACV,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mDAAmD;EACnD,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mDAAmD;EACnD,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mDAAmD;AACrD;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,YAAY;AACd;AACA;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,aAAa,EAAE,6BAA6B;EAC5C,WAAW,EAAE,2CAA2C;AAC1D;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,qBAAqB;;AAErB;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;EACxC,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,yDAAsE;EACtE,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;;;;GAIC;EACD,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,uCAAuC;EACvC,WAAW;EACX,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2EAA2E;EAC3E,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;;;EAGE,YAAY;AACd;;AAEA;EACE;iBACe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;;;;;EAKE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;AACA;;;;;EAKE,WAAW;AACb;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE;;;;GAIC;AACH;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,MAAM;AACR;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;EAGhB,YAAY;AACd;AACA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;;AAEpB;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;;EAIE,WAAW;EACX,aAAa;AACf;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;AACZ;AACA;;;;;EAKE,YAAY;AACd;AACA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gCAAgC;IAChC,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;;;IAGE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;;;;;IAKE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,OAAO;EACT;EACA;IACE,QAAQ;IACR,OAAO;IACP,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,gCAAgC;EAClC;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,gCAAgC;EAClC;EACA;;;IAGE,aAAa;IACb,2CAA2C;EAC7C;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;;IAEE,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,gCAAgC;EAClC;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,+BAA+B;EACjC;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;;;IAGE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,mCAAmC;EACrC;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;;;;;IAKE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iCAAiC;EACnC;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;IAEE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[":where(.wp-block-columns.is-layout-flex) {\n  gap: 2em;\n}\n\na {\n  color: #007ca1;\n}\n\n.uk-h1,\nh1 {\n  font-size: 37.4px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  font-weight: 500;\n  letter-spacing: 1px;\n}\n.uk-h2,\nh2 {\n  font-size: 32.3px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  font-weight: 500;\n  letter-spacing: 1px;\n}\n.uk-h3,\nh3 {\n  font-size: 30px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  font-weight: 500;\n}\n.uk-h4,\nh4 {\n  font-size: 26px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  text-transform: uppercase;\n}\n.uk-h5,\nh5 {\n  font-size: 20px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.uk-h6,\nh6 {\n  font-size: 16.5px;\n  line-height: 1;\n  /* font-family: Urbanist; */\n  font-weight: 400;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.uk-hr,\nhr {\n  overflow: visible;\n  text-align: inherit;\n  margin: 0 0 30px 0;\n  border: 0;\n  border-top: 1px solid #e5e5e5;\n}\n.uk-divider-small::after {\n  content: \"\";\n  display: inline-block;\n  width: 54px;\n  max-width: 100%;\n  border-top: 3px solid #007ca1;\n  vertical-align: top;\n  border-top-color: #007ca1 !important;\n}\nbutton,\n.button,\n.faux-button,\ninput[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  background-color: #007ca1;\n}\n\nbody,\n.entry-title a {\n  color: #000000;\n}\nfigcaption .post-meta,\nhr.styled-separator {\n  color: #6d6d6d;\n}\n\npre,\nfieldset,\ninput,\ntextarea,\ntable,\ntable *,\nhr {\n  border-color: #dcd7ca;\n}\nsamp {\n  background-color: #dcd7ca;\n}\n\n.modal-menu a,\n.footer-widgets a {\n  color: #007ca1;\n}\n\n.nav-drawer {\n  width: 448px !important;\n}\n\n.header-footer-group,\n.menu-modal .toggle {\n  color: #000000;\n}\n\n.menu-modal .close-drawer {\n  background-color: #444;\n}\n.menu-modal .close-drawer i {\n  color: #fff;\n  font-size: 26px;\n  padding-right: 25px;\n}\n\n.widget .post-date,\n.widget .rss-date,\n.powered-by-wordpress,\n.to-the-top {\n  color: #6d6d6d;\n}\n.header-footer-group pre,\n.header-footer-group fieldset,\n.header-footer-group input,\n.header-footer-group textarea,\n.header-footer-group table,\n.header-footer-group table *,\n.menu-modal nav *,\n.footer-widgets-outer-wrapper {\n  border-color: #dcd7ca;\n}\n.header-footer-group table caption {\n  background-color: #dcd7ca;\n}\n\n.primary-menu ul a {\n  color: #fff !important;\n}\n\nimg.wp-smiley,\nimg.emoji {\n  display: inline !important;\n  border: none !important;\n  box-shadow: none !important;\n  height: 1em !important;\n  width: 1em !important;\n  margin: 0 0.07em !important;\n  vertical-align: -0.1em !important;\n  background-color: none !important;\n  padding: 0 !important;\n}\n\n.widget .post-date,\n.widget .rss-date,\n.powered-by-wordpress,\n.to-the-top {\n  color: #fff;\n}\n\na:link,\na:visited {\n  color: #333;\n}\n\n.primary-menu ul a {\n  color: #fff !important;\n}\n\nhtml {\n  margin-top: 0px !important;\n}\n#wpadminbar {\n  display: none;\n}\n\nbody {\n  font-family: Roboto !important;\n  background-color: transparent;\n}\n.fa,\n.fas {\n  font-weight: 900;\n  line-height: 24px;\n  float: left;\n  padding-right: 15px;\n  clear: left;\n}\na:link,\na:visited {\n  text-decoration: none;\n}\n.entry-content {\n  font-family: roboto;\n  font-size: 0px;\n}\n.post-inner {\n  padding-top: 0rem;\n}\n\n.modal-menu a,\n.footer-widgets a {\n  color: #5e676a;\n}\n\n.primary-menu a:hover,\n.primary-menu a:focus {\n  text-decoration: none;\n  color: #58c7f1 !important;\n}\n\n.primary-menu a {\n  font-size: 12px;\n  font-family: Work Sans;\n  transition: 0.1s ease-in-out;\n  transition-property: color, background-color, border-color, box-shadow;\n  position: relative;\n  z-index: 1;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n.header-navigation-wrapper .primary-menu ul.sub-menu {\n  background-color: #17191a;\n  background-color: rgba(23, 25, 26, 0.65);\n}\n.primary-menu > li > .icon {\n  color: #cccccc !important;\n  top: calc(50% - 0.6rem);\n}\n.primary-menu .icon::before {\n  height: 0.65rem;\n  width: 0.2rem;\n}\n.primary-menu .icon::after {\n  height: 0.2rem;\n  width: 0.65rem;\n}\n\n/*Header Sticky Navigation*/\n.header-footer-group,\n.menu-modal .toggle {\n  color: #575555;\n  z-index: 11;\n}\n#site-header-sticky-wrapper {\n  position: absolute;\n  width: 100%;\n  top: 0px;\n}\n.is-sticky {\n  z-index: 2;\n}\n.is-sticky #site-header {\n  -moz-transition: margin 0.5s ease-in-out; /* Safari */\n  -webkit-transition: margin 0.5s ease-in-out; /* Safari */\n  transition: margin 0.5s ease-in-out;\n  z-index: 1 !important;\n  position: absolute !important;\n}\n/* .is-sticky #site-header {\n  margin-top: -201px !important;\n  background-color: rgba(23, 25, 26, 0.65) !important;\n} */\n.is-sticky #site-header.topscroll {\n  margin-top: 0px !important;\n  position: fixed !important;\n}\n.is-sticky .goingupz-index.topscroll ul li a {\n  color: #fff !important;\n}\n.is-sticky .goingup#site-header.topscroll ul li a:hover {\n  color: #58c7f1 !important;\n}\n.show-modal.active .ancestor-wrapper a {\n  color: #444 !important;\n  font-size: 16px;\n  font-weight: 300;\n}\n.menu-modal nav * {\n  border-color: #dedfdf;\n}\n\n.site-logo img {\n  max-height: 8rem;\n}\n#site-header {\n  background-color: #fff;\n  position: absolute;\n  width: 100%;\n}\n\nli.menu-item-3288 {\n  position: absolute;\n  margin-top: -27px;\n}\nli.menu-item-3288 a {\n  display: flex;\n  align-items: center;\n}\nli.menu-item-3288 .fas {\n  padding-right: 10px;\n  margin-top: 0px;\n}\n\n.wp-block-group.homevideo {\n  width: 100% !important;\n  max-width: 100vw !important;\n  height: 100vh;\n  margin: 0px !important;\n  margin-top: 115px !important;\n}\n.wp-block-group.homevideo > .wp-block-group__inner-container {\n  width: 100vw !important;\n  max-width: 100vw !important;\n  height: 100vh;\n  margin: 0px !important;\n  background-color: rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n.about .wp-block-group.homevideo > .wp-block-group__inner-container {\n  width: 100% !important;\n}\n.about .interest .is-layout-flow.wp-block-column p a {\n  color: #fff !important;\n}\n.about .interest .is-layout-flow.wp-block-column p a:hover {\n  color: #58c7f1 !important;\n}\n.contact-us-page .wp-block-group.homevideo > .wp-block-group__inner-container {\n  width: auto !important;\n}\n#video-background {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  min-width: 101%;\n  min-height: 100%;\n  width: auto !important;\n  z-index: -100;\n  max-width: none;\n  height: auto !important;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n.homeintrotop {\n  position: absolute;\n  left: 0px;\n  bottom: 10vh;\n  background-color: rgba(23, 25, 26, 0.85);\n  margin: 0px !important;\n  padding: 45px 40px 45px;\n  font-size: 16px;\n  font-family: roboto;\n}\n.home .homeintrotop {\n  right: 0px;\n  left: inherit;\n  bottom: 0px;\n}\n.homeintrotop p {\n  float: left;\n  max-width: none !important;\n  width: auto !important;\n  font-weight: 300;\n}\n.homeintrotop .fas {\n  float: left;\n  max-width: none !important;\n  width: auto !important;\n  color: #007ca1;\n}\n.homeintrotop h1 {\n  width: 100%;\n  font-size: 32px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #58c7f1;\n  margin: 15px 0px 0px;\n}\n.minigray {\n  color: #666;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.home .homeintrotop .wp-block-group__inner-container > p {\n  font-size: 18px;\n}\n.homenumber {\n  margin-bottom: 45px;\n}\n.home .homeintrotop.centerintro h1 {\n  margin-bottom: 15px;\n}\n\n/*SERVICES PAGES TOP */\n.wp-block-group.homevideo.servicespages {\n  height: 100vh;\n}\n.wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {\n  height: 100vh;\n}\n.homeintrotop.centerintro {\n  bottom: 0px;\n  max-width: 100% !important;\n  background-color: transparent;\n  padding: 45px 30px 0px;\n  margin: 0px auto !important;\n  left: inherit;\n  right: 0px;\n}\n.homeintrotop.centerintro h1 {\n  max-width: 100% !important;\n  float: none;\n  text-align: center;\n  font-weight: 300;\n  color: #fff;\n  margin-bottom: 45px;\n  text-shadow: #747474 0.05em 0.05em 0.1em;\n}\n.servicessubs {\n  width: 100% !important;\n  max-width: 100% !important;\n  padding: 60px 0px 50px;\n  background-color: transparent;\n  margin: 0px !important;\n  display: block;\n  text-align: center;\n}\n.servicessubs .wp-block-group__inner-container p {\n  text-align: center;\n  display: inline-block;\n  float: none;\n}\n.servicessubs a {\n  display: inline-block;\n  border: 1px solid #aaa;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-weight: 300;\n  color: #fff !important;\n  font-size: 14px;\n  margin: 0px 15px;\n  text-transform: uppercase;\n  background-color: #222;\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.servicessubs a:hover {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n  color: #fff !important;\n}\n\n.pointsmade {\n  clear: both;\n  text-align: left;\n  color: #747474;\n  font-weight: 300;\n  font-size: 16px;\n  max-width: 100% !important;\n  margin: 0px 0px 15px !important;\n}\n.pointsmade.homeauto:before {\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f058\";\n  color: #007ca1;\n  font-weight: 300;\n  font-style: normal;\n  display: inline-block;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1;\n  text-decoration: inherit;\n  margin-right: 10px;\n  display: none;\n}\n.servicesleader {\n  margin: 0px !important;\n  padding: 60px 30px 0px !important;\n  background-color: #fafafa;\n  max-width: 100% !important;\n  width: 100% !important;\n}\n.serviceswhitebackground {\n  margin: 0px !important;\n  padding: 90px 30px 60px !important;\n  background-color: #fafafa;\n  background-image: none;\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow: hidden;\n  position: relative;\n}\n.serviceswhitebackground p {\n  max-width: 900px !important;\n  width: 100% !important;\n  color: #666;\n  font-size: 16px;\n  font-weight: 300;\n  margin: 0px auto !important;\n  padding: 0px 30px 30px !important;\n}\n\n.serviceswhitebackground .brandscolumn p.partnername {\n  margin-bottom: -1px !important;\n  text-align: center;\n  font-size: 21px;\n  font-weight: 300;\n  color: #007ca1;\n  line-height: 1;\n  margin-top: 10px !important;\n  padding-bottom: 0px !important;\n}\n.serviceswhitebackground .brandscolumn p.partnername::after {\n  display: block;\n  content: \"\";\n  width: 60px;\n  height: 20px;\n  border-bottom: 1px solid #007ca1;\n  margin: 0px auto 0px;\n}\n.serviceswhitebackground .brandscolumn p.learnmorebutton {\n  text-align: center;\n  background-color: #f1f1f1;\n  border-radius: 0px 0px 10px 10px;\n  padding: 0px !important;\n  position: absolute;\n  bottom: 0px;\n}\n.serviceswhitebackground .brandscolumn p.learnmorebutton:hover {\n  background-color: #e1e1e1;\n}\n.serviceswhitebackground .brandscolumn p.learnmorebutton a {\n  text-decoration: none;\n  font-weight: 300;\n  color: #333 !important;\n  width: 100%;\n  display: block;\n  padding: 20px 30px !important;\n}\n\n.primary-btn a {\n  background-color: #007ca1;\n  color: #fff !important;\n  padding: 10px 30px !important;\n  border-radius: 30px;\n  margin-top: 20px !important;\n  display: inline-block;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 14px !important;\n  border: 1px solid transparent;\n}\n.primary-btn a:hover {\n  background-color: #fff;\n  border: 1px solid #007ca1;\n  color: #000 !important;\n}\n\n.servicesimages .wp-block-image {\n  margin: 0px !important;\n  width: 100%;\n}\n.servicesimages .wp-block-image img {\n  width: 100%;\n}\n.servicesimages.wp-block-column:not(:first-child) {\n  margin-left: 1px;\n  margin-right: 0px;\n}\n.servicesimages.wp-block-column {\n  margin-left: 0px;\n  margin-right: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.servicesdualcontainer {\n  margin: 0px !important;\n  padding: 0px 0px 2px !important;\n  background-color: #fafafa;\n}\n.servicestextcontainer {\n  margin: 0 auto !important;\n  max-width: 600px;\n  overflow: hidden;\n  padding: 0;\n}\n.servicesdualcontainer h2 {\n  width: 100%;\n  font-size: 36px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n  margin: 0px 0px 30px !important;\n}\n.servicesdualcontainer h2::after {\n  display: block;\n  content: \"\";\n  width: 60px;\n  height: 20px;\n  border-bottom: 5px solid #007ca1;\n}\n\n.servicesdualcontainer .serviceswhitebackground h2 {\n  float: none;\n  margin: 0px auto 30px !important;\n}\n.servicesdualcontainer .serviceswhitebackground h2::after {\n  margin: 0px auto;\n}\n.serviceswhitebackground p.pointsmade {\n  text-align: center;\n}\n.serviceswhitebackground p a {\n  color: #666 !important;\n  text-decoration: underline;\n}\n.servicesdualcontainer.reversetheflex {\n  flex-direction: row-reverse;\n}\n.servicesimages .wp-block-image.servicebrands {\n  float: left;\n  margin-right: 40px !important;\n  max-width: 150px !important;\n  filter: grayscale(100%);\n  opacity: 0.3;\n}\n.servicesimages .wp-block-image.servicebrands:hover {\n  margin-right: 40px !important;\n  max-width: 150px !important;\n  filter: grayscale(0%);\n  opacity: 1;\n}\n\n/*HOME PAGE SLIDING MIDDLE */\n.homedualcontainer {\n  margin: 0px !important;\n  padding: 60px 0px 60px !important;\n  background-color: #fafafa;\n  flex-direction: row-reverse;\n}\n.homedualcontainer.homedualmid {\n  padding: 0px 0px 0px !important;\n  flex-direction: row;\n}\n.homedual1 {\n  padding: 250px 40px;\n  background-color: #17191a;\n  margin: 0px !important;\n  text-align: left;\n  font-size: 16px;\n}\n\n.homedual1 p {\n  float: left;\n}\n.homedualcontainer h2 {\n  width: 100%;\n  font-size: 36px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n  margin: 0px 0px 30px !important;\n}\n.homedual2 {\n  padding: 80px 40px;\n  background-color: transparent;\n  margin: 0px !important;\n  text-align: center;\n}\n.homedual2.homelighting {\n  background-image: url(\"../../../public/assets/images/home-show13.webp\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  display: flow-root;\n  position: relative;\n  background-size: cover;\n}\n.homedual2.homeshow3 {\n  background-image: url(\"../../../public/assets/images/smart20.webp\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  display: flow-root;\n  position: relative;\n  background-size: inherit;\n}\n.homedual2.homeshow2 {\n  background-image: url(\"../../../public/assets/images/home-show4.webp\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  display: flow-root;\n  position: relative;\n  background-size: cover;\n}\n.homedualcontainer.bottomdual {\n  padding-bottom: 60px !important;\n}\n\n.homephone {\n  margin: 0px !important;\n  max-width: 300px !important;\n  position: absolute;\n  bottom: 5%;\n  left: 7.5%;\n  width: 17% !important;\n}\n.homedual2.duallefttext {\n  text-align: left;\n}\n.duallefttext .iconsbox {\n  text-align: left;\n  padding: 0px !important;\n  margin: 0px 0px 20px 0px !important;\n  position: relative;\n}\n.homedualcontainer .duallefttext .fas,\n.homedualcontainer .duallefttext .far {\n  color: #d4d4d4;\n  float: left;\n  padding: 7px 15px 0px 0px;\n  overflow: hidden;\n  line-height: 1;\n  font-size: 24px;\n  border: none !important;\n  width: auto;\n}\n.iconsbox .wp-block-column:hover .fas,\n.iconsbox .wp-block-column:hover .far {\n  color: #007ca1;\n}\n.homedualcontainer .duallefttext p {\n  color: #444 !important;\n  font-size: 16px;\n  text-decoration: none;\n  display: inline-block;\n}\n.iconsbox .wp-block-column:hover p {\n  color: #007ca1 !important;\n}\n.leftsidetextspace {\n  margin-bottom: 60px;\n}\n.homedualcontainer .learnmorebutton a {\n  background-color: #007ca1;\n  color: #fff !important;\n  padding: 10px 30px !important;\n  border-radius: 30px;\n  margin-top: 20px !important;\n  display: inline-block;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 14px !important;\n  border: 1px solid transparent;\n}\n.homedualcontainer .learnmorebutton a:hover {\n  background-color: #fff;\n  border: 1px solid #007ca1;\n}\n.hideonshow {\n  opacity: 0;\n  -webkit-transition: 0.5s;\n  -moz-transition: 0.5s;\n  -o-transition: 0.5s;\n  -ms-transition: 0.5s;\n  transition: 0.5s;\n  font-size: 14px !important;\n  color: #888 !important;\n  width: 100%;\n}\n.iconsbox .wp-block-column:hover .hideonshow {\n  opacity: 1;\n  font-size: 14px;\n  color: #888 !important;\n}\n.control4small.homecedialogo a {\n  border: none;\n  background-color: none !important;\n  position: absolute;\n  display: block;\n  padding: 0px;\n  margin: 0px;\n  width: 159px;\n  height: 159px;\n  right: 30px;\n  bottom: 60px;\n}\n.control4small.homecedialogo .alignleft {\n  position: inherit !important;\n}\n\n.iconsbox {\n  text-align: center;\n}\n.homedualcontainer .fas,\n.homedualcontainer .far {\n  color: #d4d4d4;\n  float: none;\n  padding: 30px 0px;\n  overflow: hidden;\n  line-height: 1;\n  font-size: 60px;\n  border: none !important;\n  width: 100%;\n}\n.iconsbox .wp-block-column:hover {\n  color: #007ca1 !important;\n}\n.homedualcontainer a {\n  color: #444;\n  font-size: 16px;\n  text-decoration: none;\n  padding-bottom: 3px;\n}\n.homedualcontainer .minigray a {\n  color: #007ca1 !important;\n}\n.homedualcontainer a:hover {\n  color: #007ca1 !important;\n}\n.homedualcontainer .minigray a:hover {\n  color: #007ca1 !important;\n}\n.homedualcontainer a:hover .fas,\n.homedualcontainer a:hover .far {\n  color: #007ca1 !important;\n}\n.homedualcontainer a p {\n  border-bottom: 1px solid #bbb;\n  display: inline-block;\n}\n.homedualcontainer a:hover p {\n  border-bottom: 1px solid #007ca1;\n}\n.darkenit {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  left: 0px;\n  top: 0px;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.darkenit .homedual2 {\n  background-color: rgba(0, 0, 0, 0.25);\n  width: 100%;\n  max-width: 600px;\n}\n\n.entry-content > *:not(.alignfull):not(.alignleft):not(.is-style-wide) {\n  max-width: 90% !important;\n  width: calc(100% - 4rem) !important;\n}\n\n.fullimagetop {\n  background-position: center;\n  max-width: 100%;\n  height: 100vh;\n  max-width: 100% !important;\n  position: relative;\n  z-index: -5;\n  background-size: cover;\n}\n.halfimagetop {\n  background-position: center;\n  max-width: 100%;\n  height: 45vh;\n  max-width: 100% !important;\n  position: relative;\n  z-index: -5;\n  background-size: cover;\n}\n\n/*PORTFOLIO PAGES*/\n.servicesimages.sidevideo.wp-block-column {\n  position: relative;\n  overflow: hidden;\n  margin-top: 1px;\n}\n.servicesimages.sidevideo .wp-block-image img {\n  opacity: 0;\n}\n.servicesimages.sidevideo #video-background {\n  z-index: 1;\n}\n.servicesimages.sidevideoleft.wp-block-column {\n  position: relative;\n  overflow: hidden;\n  margin-top: 1px;\n}\n.servicesimages.sidevideoleft .wp-block-image img {\n  opacity: 0;\n}\n.servicesimages.sidevideoleft #video-background {\n  z-index: 1;\n}\n\n.servicestextcontainer p a {\n  color: #666 !important;\n  text-decoration: underline;\n}\n.servicesimages.wp-block-column.homeprojectdisplay {\n  display: block;\n}\n\n/*BRANDS PAGE */\n.brandscolumn {\n  max-width: 1600px !important;\n  margin: 0px auto !important;\n  flex-wrap: wrap;\n}\n.brandscolumn .wp-block-image img {\n  margin: 0px auto;\n  padding: 0px 30px;\n}\n.brands .wp-block-group.homevideo.servicespages {\n  height: 60vh;\n}\n.brands\n  .wp-block-group.homevideo.servicespages\n  > .wp-block-group__inner-container {\n  height: 60vh;\n}\n.brands .fullimagetop {\n  height: 60vh;\n}\n.brandscolumn .wp-block-column {\n  background-color: #fff;\n  border: 1px solid #e9e9e9;\n  border-radius: 10px;\n  margin-bottom: 32px;\n  width: 25%;\n  flex-basis: inherit;\n  position: relative;\n}\n.brandscolumn .wp-block-column:nth-child(3n + 1) {\n  margin-left: 0px;\n}\n.brandscolumn .wp-block-image.brandlogo {\n  margin: 0px 30px 85px !important;\n}\n.brandscolumn .wp-block-image.brandlogo img {\n  padding: 0px;\n  margin: 0px;\n}\n\n.brandscolumn .wp-block-column.compareplan {\n  margin-bottom: 60px;\n  background-color: transparent !important;\n  width: 25px !important;\n  flex: auto !important;\n}\n\n.wp-block-column.compareplan .downwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-top: 30px solid transparent;\n}\n.wp-block-column.compareplan .upwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-bottom: 30px solid transparent;\n}\n.wp-block-column.compareplan .planpricing {\n  font-size: 60px;\n  background-color: transparent;\n  text-align: center;\n}\n.wp-block-column.compareplan .planpricing.planpricing2 {\n  background-color: transparent;\n}\n.wp-block-column.compareplan .planpricing .planpricinginner {\n  display: inline-block;\n  position: relative;\n}\n.brandscolumn .wp-block-column.compareplan li:nth-child(even) {\n  background-color: #fff;\n}\n.brandscolumn .wp-block-column.compareplan li:first-child {\n  border-radius: 10px 0px 0px 0px;\n}\n.brandscolumn .wp-block-column.compareplan li:last-child {\n  border-radius: 0px 0px 0px 10px;\n}\n.brandscolumn .wp-block-column.compareplan li:last-child a {\n  border-radius: 0px 0px 0px 10px;\n}\n\n.brandscolumn .wp-block-column.silverplan {\n  margin-bottom: 60px;\n  border-left: 1px solid #fff !important;\n}\n\n.wp-block-column.silverplan .downwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-top: 30px solid #c0c0c0;\n}\n.wp-block-column.silverplan .upwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-bottom: 30px solid #c0c0c0;\n}\n.wp-block-column.silverplan .planpricing {\n  font-size: 60px;\n  background-color: linear-gradient(#a6a6a6, #c0c0c0);\n  text-align: center;\n}\n.wp-block-column.silverplan .planpricing.planpricing2 {\n  background-color: linear-gradient(#c0c0c0, #a6a6a6);\n}\n.wp-block-column.silverplan .planpricing .planpricinginner {\n  display: inline-block;\n  position: relative;\n  color: #fff;\n}\n.wp-block-column.silverplan .planpricing .planpricinginner::before {\n  content: \"$\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  left: -11px;\n  top: 20px;\n}\n.wp-block-column.silverplan .planpricing .planpricinginner::after {\n  content: \"/mo\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  bottom: 15px;\n  right: -32px;\n}\n\n.brandscolumn .wp-block-column.goldplan {\n  border-left: none;\n  border-right: none;\n  margin-bottom: 60px;\n  border-left: 1px solid #fff !important;\n}\n.wp-block-column.goldplan .downwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-top: 30px solid #fbc901;\n}\n.wp-block-column.goldplan .upwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-bottom: 30px solid #fbc901;\n}\n.wp-block-column.goldplan .planpricing {\n  font-size: 60px;\n  background-color: linear-gradient(#deaf00, #fbc901);\n  text-align: center;\n  color: #fff;\n}\n.wp-block-column.goldplan .planpricing.planpricing2 {\n  font-size: 60px;\n  background-color: linear-gradient(#fbc901, #deaf00);\n}\n.wp-block-column.goldplan .planpricing .planpricinginner {\n  display: inline-block;\n  position: relative;\n}\n.wp-block-column.goldplan .planpricing .planpricinginner::before {\n  content: \"$\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  left: -11px;\n  top: 20px;\n}\n.wp-block-column.goldplan .planpricing .planpricinginner::after {\n  content: \"/mo\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  bottom: 15px;\n  right: -32px;\n}\n\n.brandscolumn .wp-block-column.platplan {\n  margin-bottom: 60px;\n  border-left: 1px solid #fff !important;\n}\n.wp-block-column.platplan .downwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-top: 30px solid #a0b2c6;\n}\n.wp-block-column.platplan .upwardtriangle {\n  display: none;\n  width: 0px;\n  height: 0px;\n  border-left: 198px solid transparent;\n  border-right: 198px solid transparent;\n  border-bottom: 30px solid #a0b2c6;\n}\n.wp-block-column.platplan .planpricing {\n  font-size: 60px;\n  background-color: linear-gradient(#8798ab, #a0b2c6);\n  text-align: center;\n  color: #fff;\n}\n.wp-block-column.platplan .planpricing.planpricing2 {\n  background-color: linear-gradient(#a0b2c6, #8798ab);\n}\n.wp-block-column.platplan .planpricing .planpricinginner {\n  display: inline-block;\n  position: relative;\n}\n.wp-block-column.platplan .planpricing .planpricinginner::before {\n  content: \"$\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  left: -11px;\n  top: 20px;\n}\n.wp-block-column.platplan .planpricing .planpricinginner::after {\n  content: \"/mo\";\n  display: block;\n  position: absolute;\n  font-size: 18px;\n  bottom: 15px;\n  right: -32px;\n}\n.brandscolumn .wp-block-column.platplan li:last-child {\n  border-radius: 0px 0px 10px 0px;\n}\n.brandscolumn .wp-block-column.platplan li:last-child a {\n  border-radius: 0px 0px 10px 0px;\n}\n\n/*PARTNERS PAGE */\n.partners .wp-block-group.homevideo.servicespages {\n  height: 55vh;\n}\n.partners\n  .wp-block-group.homevideo.servicespages\n  > .wp-block-group__inner-container {\n  height: 55vh;\n}\n.partners .fullimagetop {\n  height: 55vh;\n}\n.partners .brandscolumn .wp-block-column {\n  width: 21%;\n}\n.partners .brandscolumn .wp-block-column:nth-child(odd) {\n  margin-left: 32px;\n}\n.partners .brandscolumn .wp-block-column:nth-child(even) {\n  margin-left: 32px;\n}\n.partners .brandscolumn .wp-block-image img {\n  width: 100%;\n}\n.partners .brandscolumn .wp-block-image {\n  margin-bottom: 2rem !important;\n  margin-top: 3rem !important;\n}\n.partners .serviceswhitebackground .brandscolumn p.learnmorebutton {\n  background-color: transparent;\n  position: unset;\n  transition: all 0.3s;\n}\n.partners .serviceswhitebackground .brandscolumn p.learnmorebutton:hover {\n  background-color: #f1f1f1;\n}\n.homeintrotop.centerintro h2 {\n  width: 100%;\n  font-size: 32px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  max-width: 100% !important;\n  float: none;\n  text-align: center;\n  font-weight: 300;\n  color: #fff;\n  margin-bottom: 15px;\n  text-shadow: #747474 0.05em 0.05em 0.1em;\n}\n.homenumber.partnerh2 {\n  margin-bottom: 45px !important;\n}\n.partners3column {\n  max-width: 1200px !important;\n  color: #666;\n}\n.partners3column h3 {\n  font-size: 30px;\n  font-weight: 300;\n  padding: 0px 30px;\n}\n.partners3column li {\n  font-size: 16px;\n  font-weight: 300;\n}\n.homeintrotop.centerintro.partnercenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.smallpartnerarea {\n  max-width: 100% !important;\n  width: 100% !important;\n  padding: 0px 30px;\n  color: #666;\n}\n.smallpartnerarea h2 {\n  max-width: 100% !important;\n  padding-top: 30px;\n  font-weight: 300;\n  font-size: 42px;\n}\n.smallpartnerarea p {\n  max-width: 700px !important;\n  color: #666;\n  font-size: 20px;\n  font-weight: 300;\n}\n.smallpartnerarea p a {\n  background-color: #007ca1;\n  color: #fff !important;\n  padding: 10px 20px;\n  margin: 30px auto;\n  display: block;\n  width: 190px;\n  border-radius: 15px;\n  border: 1px solid transparent;\n}\n.smallpartnerarea p a:hover {\n  background-color: #ffffff;\n  color: #007ca1 !important;\n  border: 1px solid #007ca1;\n}\n\n/*CONTACT US PAGE*/\n\n.contact-us-page\n  .wp-block-group.homevideo.servicespages\n  > .wp-block-group__inner-container {\n  height: 45vh;\n}\n.contact-us-page .wp-block-group.homevideo.servicespages {\n  height: 45vh;\n  background-color: rgba(23, 25, 26, 0.2);\n}\n#map {\n  height: 500px; /* The height is 400 pixels */\n  width: 100%; /* The width is the width of the web page */\n}\n.contact-us-page .footer-widgets.column-one {\n  display: none;\n}\n.servicesdualcontainer.mapscontain {\n  padding: 0px !important;\n  float: left;\n  width: 100%;\n  height: 500px;\n  overflow: hidden;\n}\n.contact-us-page .pagecolumns {\n  max-width: 1200px !important;\n  border-bottom: none;\n  padding-bottom: 60px;\n  margin-bottom: 0px !important;\n}\n.contact-us-page .pagecolumns .wp-block-column:first-child {\n  border-right: 1px solid #e4e4e4;\n}\n.contactcolumn1 .fas {\n  float: none;\n  padding: 0px;\n  font-size: 48px;\n  color: #b4b4b4;\n  margin-bottom: 24px;\n  margin-top: 20px;\n}\n.contactcolumn1 {\n  text-align: center;\n}\n.pagewhitebackground .contactcolumn1 p {\n  padding-bottom: 45px;\n}\n.contact-us-page input[type=\"text\"],\n.contact-us-page input[type=\"email\"],\n.contact-us-page input[type=\"tel\"],\n.contact-us-page textarea {\n  border-radius: 10px;\n  border: 1px solid #e4e4e4;\n}\n.contact-us-page input[type=\"submit\"] {\n  background-color: #007ca1;\n  margin-top: 20px;\n  border-radius: 10px;\n  padding: 15px 30px;\n  font-family: roboto;\n  font-weight: 500;\n}\n\n.pagewhitebackground a {\n  color: #007ca1 !important;\n  text-decoration: underline;\n}\n.contact-us-page .pagecolumns .wp-block-column:first-child {\n  flex-basis: 400px !important;\n}\n.contact-us-page .pagecolumns .wp-block-column {\n  flex-basis: 100% !important;\n}\n.wp-block-column.bigoldmap > :last-child {\n  height: 500px !important;\n  width: 100% !important;\n}\n\n/*Start Your Project*/\n\n.start-your-project\n  .wp-block-group.homevideo.servicespages\n  > .wp-block-group__inner-container {\n  height: 45vh;\n}\n.start-your-project .wp-block-group.homevideo.servicespages {\n  height: 45vh;\n  background-color: rgba(23, 25, 26, 0.2);\n}\n.start-your-project .footer-widgets.column-one {\n  display: none;\n}\n.start-your-project .pagecolumns {\n  max-width: 1200px !important;\n  border-bottom: none;\n  padding-bottom: 60px;\n  margin-bottom: 0px !important;\n}\n.start-your-project .pagecolumns .wp-block-column:first-child {\n  border-right: 1px solid #e4e4e4;\n}\n.start-your-project input[type=\"text\"],\n.start-your-project input[type=\"email\"],\n.start-your-project input[type=\"tel\"],\n.start-your-project textarea {\n  border-radius: 10px;\n  border: 1px solid #e4e4e4;\n}\n.start-your-project input[type=\"submit\"] {\n  background-color: #007ca1;\n  margin-top: 20px;\n  border-radius: 10px;\n  padding: 15px 30px;\n  font-family: roboto;\n  font-weight: 500;\n}\n.start-your-project select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: #fff;\n  border-radius: 0;\n  border-style: solid;\n  border-width: 0.1rem;\n  box-shadow: none;\n  display: block;\n  font-size: 1.6rem;\n  letter-spacing: -0.015em;\n  margin: 0;\n  max-width: 100%;\n  padding: 1.5rem 1.8rem;\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid #e4e4e4;\n  line-height: 2;\n  color: #666;\n}\n.start-your-project option {\n  padding: 0px;\n}\n\n.start-your-project .pagecolumns .wp-block-column:first-child {\n  flex-basis: 400px !important;\n}\n.start-your-project .pagecolumns .wp-block-column {\n  flex-basis: 100% !important;\n}\n\n/*SUB PAGES WHITE BACKGROUND WITH BLACK TEXT BELOW HEADER*/\n.pagewhitebackground {\n  margin: 0px !important;\n  padding: 90px 30px 60px !important;\n  background-color: #fff;\n  background-image: none;\n  width: 100% !important;\n  max-width: 100% !important;\n  overflow: hidden;\n  position: relative;\n}\n.pagewhitebackground h2 {\n  text-align: left;\n  width: 100% !important;\n  font-size: 36px;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n  margin: 0px auto 30px !important;\n  max-width: 1200px !important;\n}\n.pagewhitebackground h2::after {\n  display: block;\n  content: \"\";\n  width: 60px;\n  height: 20px;\n  border-bottom: 5px solid #007ca1;\n}\n.pagewhitebackground p {\n  max-width: 900px !important;\n  width: 100% !important;\n  color: #666;\n  font-size: 16px;\n  font-weight: 300;\n}\n.pagecolumns {\n  max-width: 1200px !important;\n  border-bottom: 2px solid #d4d4d4;\n  padding-bottom: 60px;\n  margin-bottom: 60px !important;\n}\n.cediasmall {\n  max-width: 165px;\n}\n.pagecolumns .wp-block-image.control4small {\n  max-width: 159px;\n  margin-top: 20px !important;\n}\n.pagecolumns .wp-block-column:first-child {\n  border-right: 2px solid #d4d4d4;\n  padding-right: 45px;\n  margin-right: 30px;\n}\n.pagecolumns .wp-block-image {\n  margin-top: 0px !important;\n  margin-bottom: 45px !important;\n}\n.wp-block-columns.picturetime {\n  max-width: 1200px !important;\n}\n.picturetime figcaption {\n  font-family: roboto;\n  text-align: center;\n}\n.picturetime figcaption strong {\n  clear: both;\n  display: block;\n  margin-bottom: 5px;\n}\n.pickanarea {\n  justify-content: center;\n  background-color: #111;\n  background-color: rgba(23, 25, 26, 0.85);\n  color: #fff;\n  margin: 0px !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  text-align: center;\n  font-size: 14px;\n}\n.pickanarea .fa,\n.pickanarea .fas,\n.pickanarea .far {\n  font-weight: 900;\n  line-height: 84px;\n  float: none;\n  padding-right: 0px;\n  clear: left;\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-size: 48px;\n}\nh2.pickareaheading {\n  background-color: #111;\n  background-color: rgba(23, 25, 26, 0.85);\n  width: 100% !important;\n  max-width: 100% !important;\n  text-align: center;\n  padding: 45px 30px 0px;\n  margin: 0px;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #58c7f1;\n  font-size: 32px;\n}\n.pickanarea > .wp-block-column {\n  max-width: 600px;\n}\n.pickanarea a:hover .fa,\n.pickanarea a:hover .fas,\n.pickanarea a:hover .far {\n  color: #58c7f1;\n}\n.houzztable {\n  border: none;\n  width: 159px !important;\n}\n.houzztable td {\n  padding: 0px;\n  border: none;\n}\n.houzztable td img {\n  width: 158px !important;\n  height: 158px !important;\n}\na#bbblink {\n  width: 158px !important;\n}\n\n/*FOOTER MAIN AREA AND CONTACT*/\n.footer-widgets-outer-wrapper {\n  border: none !important;\n}\n.header-footer-group {\n  border: none !important;\n}\n.footer-widgets-outer-wrapper {\n  width: 50%;\n}\n.footer-widgets {\n  margin-left: 0px;\n  width: 100%;\n}\n.footer-widgets-wrapper {\n  width: 100%;\n  margin-left: 0px;\n  display: block;\n}\n\n.contactarea {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.contactareabox {\n  background-color: rgba(23, 25, 26, 0.85);\n  padding: 40px 80px;\n  flex-basis: 0;\n  flex-grow: 1;\n}\n.contactareabox h3 {\n  width: 100%;\n  font-size: 36px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #58c7f1;\n  text-align: center;\n  margin: 0px 0px 15px;\n}\n.contactarea p {\n  text-align: center;\n  font-family: roboto;\n  font-size: 16px;\n  color: #707070;\n}\n.contactareabox2 {\n  background-color: rgba(23, 25, 26, 0.65);\n  padding: 40px;\n  flex-basis: 1px;\n  flex-grow: 1;\n}\n.contactareabox2 h3 {\n  width: 100%;\n  font-size: 36px;\n  float: left;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #ffffff;\n  text-align: center;\n  margin: 0px 0px 60px;\n}\n.contactarea input[type=\"text\"] {\n  text-align: center;\n  background-color: rgba(23, 25, 26, 0.85);\n  color: #fff;\n  font-family: roboto;\n  border-radius: 30px;\n  font-size: 14px;\n}\n.contactarea .wpcf7 input[type=\"email\"] {\n  text-align: center;\n  background-color: rgba(23, 25, 26, 0.85);\n  color: #fff;\n  font-family: roboto;\n  border-radius: 30px;\n  font-size: 14px;\n}\n.contactarea .wpcf7 input[type=\"tel\"] {\n  text-align: center;\n  background-color: rgba(23, 25, 26, 0.85);\n  color: #fff;\n  font-family: roboto;\n  border-radius: 30px;\n  font-size: 14px;\n}\n.contactarea textarea {\n  text-align: center;\n  background-color: rgba(23, 25, 26, 0.85);\n  color: #fff;\n  font-family: roboto;\n  border-radius: 30px;\n  font-size: 14px;\n}\n.contactarea .wpcf7-form p {\n  margin: 0px 0px 15px;\n  line-height: 0px;\n}\n.contactarea .wpcf7-form {\n  margin-top: 35px;\n}\n.contactarea .wpcf7-submit {\n  background-color: #007ca1;\n  color: #fff !important;\n  padding: 10px 30px !important;\n  border-radius: 30px;\n  margin-top: 0px !important;\n  display: inline-block;\n  font-weight: 500;\n  font-size: 14px !important;\n  border: 1px solid transparent;\n  width: 100%;\n  font-family: roboto;\n  text-transform: none;\n}\n.contactarea .wpcf7-submit:hover {\n  background-color: #fff;\n  border: 1px solid #007ca1;\n  color: #007ca1 !important;\n}\n.contactarea input[type=\"text\"]:focus {\n  border-color: #888;\n}\n.contactarea .wpcf7 input[type=\"email\"]:focus {\n  border-color: #888;\n}\n.contactarea .wpcf7 input[type=\"tel\"]:focus {\n  border-color: #888;\n}\n.contactarea textarea:focus {\n  border-color: #888;\n}\n.contactarea .contactareabox2 p {\n  color: #fff;\n}\n.contactarea .contactareabox2 a:hover p {\n  color: #58c7f1;\n}\n.contactarea .contactareabox2 .fa,\n.contactarea .contactareabox2 .fas {\n  float: none;\n  padding: 0px;\n  font-size: 36px;\n  color: #58c7f1;\n}\n\n.footer-widgets-outer-wrapper {\n  width: 100%;\n  padding: 0px;\n}\n.footer-inner.section-inner {\n  max-width: 100%;\n  width: 100%;\n}\n.footer-widgets.column-one {\n  max-width: 100%;\n  width: 100%;\n  background-image: url(\"../../../public/assets/images/home-show5.webp\");\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  display: flex;\n  position: relative;\n  background-size: cover;\n  min-height: 90vh;\n  align-items: center;\n  justify-content: right;\n}\n.footer-widgets.column-one div:first-child {\n  margin-left: auto;\n}\n.footer-widgets.column-two {\n  overflow: hidden;\n}\n.footerlinks {\n  display: flex;\n  max-width: 1200px;\n  padding: 60px 30px;\n  margin: 0px auto;\n  font-size: 16px;\n}\n\n.footerlinks1 {\n  flex-basis: 400px;\n  flex-grow: 0;\n  color: #666;\n}\n.footerlinks1 img {\n  max-width: 100%;\n  margin-bottom: 5px;\n}\n.footerlinks1 p {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n.footerlinks2 {\n  flex-basis: 400px;\n  flex-grow: 0;\n  padding-right: 60px;\n}\n.footerlinks3 {\n  flex-basis: 0;\n  flex-grow: 1;\n}\n.footerlinks3 .review {\n  color: #333;\n}\n.footerlinks3 .review .mySwiper {\n  width: 400px;\n}\n.footerlinks3 .review .mySwiper .swiper-slide {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n}\n.footerlinks3 .review .mySwiper ul {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  margin-bottom: 40px;\n}\n.footerlinks3 .review .mySwiper ul li {\n  font-size: 20px;\n  list-style: none;\n  margin: 0 !important;\n}\n.footerlinks3 .review .mySwiper .minigray {\n  margin: 0;\n  margin-bottom: 10px;\n  font-style: italic;\n}\n.footerlinks3 .review .mySwiper .user p {\n  margin: 0;\n  text-transform: capitalize;\n  margin-top: 10px;\n  font-weight: 600;\n}\n.footermenu a {\n  display: block;\n  text-transform: uppercase;\n  font-size: 14px;\n  padding: 7px 0;\n}\n.footermenu .su-spoiler-style-default > .su-spoiler-title {\n  display: block;\n  text-transform: uppercase;\n  font-size: 14px;\n  padding: 7px 0;\n  font-weight: 300;\n  color: #222;\n}\n.footermenu .su-spoiler-style-default > .su-spoiler-title:hover {\n  color: #58c7f1 !important;\n}\n.footermenu .su-spoiler-style-default > .su-spoiler-title:focus {\n  outline: none;\n}\n.footermenu.su-accordion .su-spoiler {\n  margin-bottom: 0px !important;\n}\n.footermenu .su-spoiler-style-default > .su-spoiler-title > .su-spoiler-icon {\n  left: inherit;\n  right: 0;\n}\n.footermenu a:hover {\n  color: #58c7f1 !important;\n}\n\n.header-footer-group {\n  background-color: #fff;\n}\n\n/* josh ai page  */\n.josh-ai-page .josh-ai-hero-content {\n  padding-top: 300px;\n  width: 400px !important;\n  margin-left: 60% !important;\n  position: absolute;\n}\n\n.josh-ai-page .overlay2 {\n  background-color: rgba(8, 8, 8, 0);\n  background-image: linear-gradient(\n    264deg,\n    rgba(0, 0, 0, 1) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n  background-clip: padding-box;\n}\n\n.josh-ai-hero-content h2 {\n  color: #fff;\n  font-weight: 400;\n  margin-top: 0px;\n  position: relative;\n  padding-top: 15px;\n}\n.josh-ai-hero-content h2::before {\n  content: \"\";\n  width: 70px;\n  height: 3px;\n  background-color: #007ca1;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.josh-ai-hero-content p {\n  color: #ffffffb3;\n  font-size: 20px;\n  font-weight: 300;\n}\n\n.josh-ai-page .josh-ai-h2 {\n  position: relative;\n  padding-top: 15px;\n  margin-top: 0;\n  font-weight: 300;\n  color: #007ca1;\n  font-size: 36px;\n  text-transform: uppercase;\n}\n\n.josh-new-content {\n  display: none;\n}\n\n.josh-ai-page .josh-ai-h2::before {\n  content: \"\";\n  width: 60px;\n  height: 3px;\n  background-color: #007ca1;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* .commercial-automantion */\n.csca {\n  margin-top: 135px;\n  width: 100%;\n  height: 580px;\n  position: relative;\n}\n.csca video,\n.csca .image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.csca .image img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n.csca .csca-content {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  left: 50%;\n  transform: translate(-50%);\n  background-color: rgba(31, 31, 31, 0.6);\n  width: 100%;\n  bottom: 0;\n}\n.csca .csca-content-area {\n  max-width: 750px;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  text-align: center;\n  padding: 0 40px 30px 40px;\n}\n.csca .csca-icon {\n  width: 120px;\n}\n.csca .csca-icon .outline {\n  fill: #00000000;\n  stroke: #fff;\n}\n.csca .csca-content h1 {\n  font-size: 44px;\n  font-weight: 400;\n  color: #fff;\n  margin: 0;\n  margin-bottom: 10px;\n}\n.csca .csca-content h6 {\n  color: #fff;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0;\n}\n.csca-nav {\n  background-color: #fafafa;\n}\n.csca-nav .control4-nav .control4-nav-area .nav-area a {\n  background-color: transparent !important;\n  border: 1px solid #007ca1 !important;\n  color: #007ca1 !important;\n  text-transform: capitalize !important;\n  font-size: 16px !important;\n}\n.csca-nav .control4-nav .control4-nav-area .nav-area a:hover {\n  background-color: #007ca1 !important;\n}\n.csca-nav .control4-nav-area {\n  justify-content: center !important;\n}\n.extra-padding {\n  padding: 70px 0;\n}\n.carears-hero {\n  margin-top: 120px;\n}\n.carears-hero .uk-divider-small::after {\n  border-top: 3px solid #007ca1;\n  border-color: #007ca1 !important;\n  width: 54px;\n}\n.carears-hero h2 {\n  font-weight: 400;\n  font-size: 44px;\n  margin: 0;\n  margin-bottom: 30px;\n}\n.carears-hero p {\n  font-size: 20px;\n  line-height: 1.5;\n  letter-spacing: -0.6px;\n}\n.commercial-technology-hero {\n  margin-top: 135px;\n}\n.commercial-technology-hero .uk-heading-bullet::before {\n  border-left-color: #007ca1 !important;\n}\n.commercial-technology-hero p {\n  font-size: 16px;\n  font-weight: 300;\n}\n.commercial-technology-hero .indoor-content h1.uk-h6,\n.commercial-technology-hero .indoor-content h2,\n.commercial-technology-hero .indoor-content p {\n  color: #302b28;\n  font-weight: 100;\n}\n.golf-simulators-hero {\n  margin-top: 135px;\n}\n.golf-simulators-hero p {\n  /* font-family: \"Lucida Grande\",\"Lucida Sans Unicode\",Verdana,sans-serif; */\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.7;\n}\n.golf-simulators-hero .button__primary {\n  background-color: #fafafa;\n  color: #333 !important;\n}\n.golf-simulators-hero h1 {\n  margin: 0;\n  margin-bottom: 30px;\n}\n.golf-simulators-hero .button__primary:hover {\n  background-color: #58c7f1;\n}\n.contro4_hero h3,\n.contro4_hero .uk-margin-small {\n  font-weight: 300;\n}\n.contro4_hero .button__primary {\n  margin-top: 0 !important;\n}\n.contro4_hero h3 {\n  text-transform: uppercase;\n}\n\n.preloader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n.icon-1-1 a i,\n.icon-1-2 a i {\n  color: #007ca1;\n}\n.icon-1-1 a,\n.icon-1-2 a {\n  height: 40px;\n  width: 40px;\n  opacity: 1;\n  box-shadow: 0px 0px 0px 0;\n  padding: 0px;\n  border: 2px solid #007ca1;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n.to-the-top span {\n  color: #fff;\n}\n.vce {\n  margin-bottom: 30px;\n}\n\n.su-spoiler.su-spoiler-closed > .su-spoiler-content {\n  height: 0;\n  margin: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  overflow: hidden;\n  border: none;\n  opacity: 0;\n  pointer-events: none;\n}\n\n#site-content .post-inner {\n  padding-top: 0;\n}\n.design-build-partners .wp-block-group.homevideo.servicespages {\n  height: 65vh;\n}\n.design-build-partners\n  .wp-block-group.homevideo.servicespages\n  > .wp-block-group__inner-container {\n  height: 65vh;\n}\n\na#scroll-to-top {\n  background-color: url(../../../public/assets/images/arrow.webp) no-repeat\n    center center;\n  width: 35px;\n  height: 35px;\n  position: fixed;\n  right: 30px;\n  bottom: 30px;\n  text-indent: -9999px;\n  font-size: 0;\n  cursor: pointer;\n  outline: 0;\n  opacity: 0;\n}\n\n.overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.24);\n}\n.overlay2 {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.596);\n}\n\n.indoor-living-feature h3 {\n  font-size: 20px;\n  margin: 0 !important;\n  margin-bottom: 10px !important;\n  color: #007ca1;\n}\n\n.is-layout-flex.wp-container-13.wp-block-columns.alignfull.homedualcontainer\n  .indoor-living-about {\n  margin: 0 auto;\n  max-width: 1460px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.indoor-living-about .indoor-living-feature {\n  width: 60%;\n  /* padding-top: 0px; */\n}\n.indoor-living-about .indoor-living-about-box {\n  width: 40%;\n  background-color: #fff;\n  padding: 70px;\n  border-top: 3px solid #007ca1;\n}\n.indoor-living-about .indoor-living-about-box h3 {\n  color: #007ca1 !important;\n}\n\n.indoor-living-image-section img {\n  width: 100% !important;\n}\n\n.indoor-living-image-section.alignfull {\n  margin: 0 !important;\n}\n\n.indoor-living-image-section .title-section {\n  padding: 70px 0;\n}\n.indoor-living-image-section .title-section .title-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  color: #747474;\n}\n.indoor-living-image-section .title-section .title-inner p {\n  margin: 0;\n}\n.indoor-living-image-section .title-section .title-inner .section-grid {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.title-inner .section-grid [class*=\"grid-item-\"] {\n  padding-left: 25px;\n}\n.title-inner .section-grid [class*=\"grid-item-\"] h6 {\n  margin: 0;\n  margin-bottom: 20px;\n  color: #007ca1;\n}\n.title-inner .section-grid .grid-item-1 {\n  width: 50%;\n}\n.title-inner .section-grid .grid-item-1 h4 {\n  margin: 0;\n  margin-bottom: 20px;\n  color: #007ca1;\n}\n.title-inner .section-grid .grid-item-1 p {\n  font-size: 15px;\n}\n.title-inner .section-grid .grid-item-2 {\n  width: 25%;\n}\n.title-inner .section-grid .grid-item-2 p {\n  font-size: 14px;\n}\n.title-inner .section-grid .grid-item-3 {\n  width: 25%;\n}\n.title-inner .section-grid .grid-item-3 h6 {\n  text-align: center;\n}\n.section-grid .grid-item-3 .icon-grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-around;\n}\n.grid-item-3 .icon-grid i {\n  font-size: 30px;\n  color: #747474;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* connected home */\n.connected-living-title-section {\n  margin-top: 136px;\n  padding: 70px 0;\n  background-color: #fafafa;\n}\n\n.connected-living-title-section h2 {\n  margin: 0px;\n  margin-bottom: 20px;\n  font-size: 36px;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n}\n.connected-living-title-section p {\n  margin: 0px !important;\n  color: #666;\n}\n.connected-living-title-section .title-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  text-align: center;\n  padding: 0 20px;\n}\n.connected-living-title-section.bottom-title-section {\n  margin: 0 !important;\n}\n\n.a-day-life .a-day-life-hero h1 {\n  margin-bottom: 20px !important;\n}\n.a-day-life .a-day-life-hero h5 {\n  margin: 0;\n  font-weight: 500;\n  margin-bottom: 10px;\n  color: #fff;\n}\n.a-day-life .a-day-life-hero p {\n  color: #fff;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n}\n\n.a-day-life-section {\n  display: flow-root;\n  box-sizing: border-box;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.a-day-life-container-large {\n  max-width: 1360px;\n}\n.a-day-life-section > :last-child {\n  margin-bottom: 0;\n}\n.a-day-life-container {\n  display: flow-root;\n  box-sizing: content-box;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.a-day-life-grid {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  margin-left: -30px;\n}\n\n.a-day-life-grid > * {\n  margin: 0;\n}\n.a-day-life-grid > * > :last-child {\n  margin-bottom: 0;\n}\n* + .a-day-life-grid-margin,\n.a-day-life-grid + .a-day-life-grid,\n.a-day-life-grid > .a-day-life-grid-margin {\n  margin-top: 30px;\n}\n\n.a-day-life-container-large {\n  max-width: 1360px;\n}\n.a-day-life-text-center {\n  text-align: center !important;\n}\n\n.a-day-life-nav {\n  display: flex;\n  flex-wrap: wrap;\n}\n.a-day-life-nav .nav-item {\n  width: 16.66%;\n}\n.a-day-life-nav .nav-item a {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.a-day-life-nav .nav-item i {\n  color: #999;\n}\n.a-day-life-nav .nav-item a h3 {\n  margin: 20px 0 0 0;\n  font-size: 28px;\n  font-weight: 300;\n  color: #007ca1;\n}\n.a-day-life-nav .nav-item a p {\n  margin-top: 20px !important;\n  margin: 0;\n  font-size: 14px;\n}\n.tm-grid-expand > * {\n  flex-grow: 1;\n}\n.tm-grid-expand > .a-day-life-width-expand {\n  flex-grow: 999;\n}\n.a-day-life-text-meta {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #999;\n  font-family: Mukta;\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 20px;\n}\n.a-day-life-padding-remove-bottom {\n  padding-bottom: 0 !important;\n}\n.a-day-life-heading-bullet {\n  font-size: 50px;\n  font-weight: 300;\n  margin: 0 0 20px 0;\n  color: #fff;\n}\n\n.a-day-life-heading-bullet::before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: calc(-0.095 * 1em);\n  vertical-align: middle;\n  height: calc(4px + 0.74em);\n  margin-right: calc(5px + 0.2em);\n  border-left: calc(1.5px + 0.15em) solid #fafafa;\n}\n\n.a-day-life-section-secondary {\n  background-color: #007ca1;\n  background-position-x: 50%;\n  background-repeat: repeat-y;\n}\n\n.container > :last-child,\n.a-day-life-container > :last-child {\n  margin-bottom: 0;\n}\n.uk-section-xlarge {\n  padding-top: 140px;\n  padding-bottom: 140px;\n}\n.a-day-life-video-section {\n  position: relative;\n}\n.a-day-life-video-section video {\n  width: 100%;\n  height: 750px;\n  object-fit: cover;\n}\n.a-day-life-video-section .video-content {\n  position: absolute;\n  top: 50%;\n  left: 15%;\n  transform: translateY(-50%);\n  color: #444;\n  width: 350px;\n  background-color: #fafafa;\n  padding: 70px 40px;\n}\n.a-day-life-video-section .video-content.right-text {\n  position: absolute;\n  right: 15%;\n  left: auto;\n}\n\n.a-day-life-video-section .video-content h4 {\n  color: #007ca1;\n  margin: 0;\n  margin-bottom: 20px;\n  position: relative;\n}\n.a-day-life-video-section .video-content h4::before {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: calc(-0.095 * 1em);\n  vertical-align: middle;\n  height: calc(4px + 0.74em);\n  margin-right: calc(5px + 0.2em);\n  border-left: calc(1.5px + 0.15em) solid #007ba179;\n}\n\n.a-day-life-video-section .video-content p {\n  padding: 0;\n  margin: 0;\n}\n\n.csh-wrapper {\n  position: relative;\n}\n.csh-marker {\n  position: absolute !important;\n  background-color: #007ca1;\n  color: #fff;\n  transition: 0.1s ease-in-out;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  width: 31px;\n  height: 31px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.csh-marker i {\n  color: #fff;\n  font-size: 16px;\n}\n.uk-drop {\n  display: none;\n  position: absolute;\n  z-index: 1020;\n  --uk-position-offset: 20px;\n  --uk-position-viewport-offset: 15px;\n  box-sizing: border-box;\n}\n.uk-drop.uk-open {\n  display: block;\n}\n.csh-card {\n  background-color: #007ca1;\n  color: #fff;\n}\n.csh-card .csh-card-content {\n  padding: 30px 30px;\n}\n.csh-card .csh-card-content .csh-card-content-title {\n  margin: 0 !important;\n  padding: 0 !important;\n  font-size: 22px;\n  line-height: 1.4;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #fff;\n}\n.csh-card .csh-card-content .csh-card-content-desc {\n  margin-top: 20px;\n}\n.csh-card .csh-card-content .csh-card-content-desc p {\n  margin: 0 !important;\n  padding: 0 !important;\n  font-size: 14px;\n}\n.our-process video {\n  width: 100%;\n  height: 400px;\n  object-fit: cover;\n}\n.our-process .our-process-hero {\n  position: relative;\n}\n.our-process .our-process-hero .our-process-video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(23, 25, 26, 0.65);\n}\n.our-process .our-process-hero .our-process-hero-content {\n  bottom: 0px;\n  max-width: 100% !important;\n  background-color: transparent;\n  padding: 45px 30px 0px;\n  margin: 0px auto !important;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.our-process .our-process-hero .our-process-hero-content .content-wrapper {\n  width: 600px;\n  max-width: 100% !important;\n  padding: 60px 0px 50px;\n  background-color: transparent;\n  margin: 0px !important;\n  display: block;\n  text-align: center;\n}\n.our-process\n  .our-process-hero\n  .our-process-hero-content\n  .content-wrapper\n  .content-title {\n  text-align: center;\n  font-weight: 300;\n  color: #fff;\n  margin-bottom: 25px;\n  text-shadow: #747474 0.05em 0.05em 0.1em;\n  margin-top: 0;\n}\n.our-process\n  .our-process-hero\n  .our-process-hero-content\n  .content-wrapper\n  .content-description {\n  color: #fff;\n}\n.our-process\n  .our-process-hero\n  .our-process-hero-content\n  .content-wrapper\n  .content-description\n  a {\n  color: #58c7f1 !important;\n}\n.our-process-desc {\n  max-width: 1200px;\n  padding: 80px 20px;\n  margin: 0 auto;\n  display: flex;\n  gap: 30px;\n}\n.our-process-desc .our-process-desc-left {\n  width: 30%;\n}\n.our-process-desc .our-process-desc-left .title {\n  font-size: 24px;\n  line-height: 1.4;\n  font-weight: 300;\n  text-transform: uppercase;\n  margin: 0;\n  margin-bottom: 20px;\n}\n.our-process-desc .our-process-desc-left .subtitle {\n  margin: 20px 0;\n}\n.our-process-desc .our-process-desc-left .card {\n  margin-top: 20px;\n  padding: 40px;\n  background-color: #fafafa;\n}\n.our-process-desc .our-process-desc-left .card .card-title {\n  font-size: 18px;\n  line-height: 1.4;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 4px;\n  font-style: italic;\n}\n.our-process-desc .our-process-desc-left .card .card-description {\n  margin-top: 20px;\n}\n\n.our-process-desc .our-process-desc-right {\n  width: 70%;\n}\n.our-process-desc .our-process-desc-right .card-item {\n  background-color: #fafafa;\n  padding: 40px;\n  border-top: 2px solid #007ca1;\n}\n.our-process-desc .our-process-desc-right .card-item:not(:first-child) {\n  margin-top: 40px;\n}\n.our-process-desc .our-process-desc-right .card-item .card-item-title {\n  font-size: 18px;\n  line-height: 1.4;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 4px;\n  font-style: italic;\n  margin: 0;\n}\n.our-process-desc .our-process-desc-right .card-item .card-item-desc {\n  margin: 0;\n  padding: 0;\n  margin-top: 20px;\n}\n\n.blog {\n  padding-top: 120px;\n  background-color: #fafafa;\n}\n.blog-area {\n  max-width: 1200px;\n  padding: 80px 20px;\n  margin: 0 auto;\n}\n.blog-area .blog-area-title {\n  margin: 0;\n  margin-bottom: 25px;\n  font-size: 35px;\n}\n.blog-wrapper {\n  display: flex;\n  gap: 30px;\n}\n.blog-wrapper .blog-content {\n  width: 70%;\n}\n.blog-wrapper .blog-content .blog-content-top {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.blog-wrapper .blog-content .blog-content-top .image {\n  background-size: cover;\n  width: 100%;\n  height: 320px;\n  background-repeat: no-repeat;\n}\n.blog-wrapper .blog-content .blog-content-top h2 {\n  color: #444;\n  font-weight: 300;\n  margin: 0;\n  margin-bottom: 10px;\n  font-size: 24px;\n}\n.blog-wrapper .blog-content .blog-content-top .links {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.blog-wrapper .blog-content .blog-content-top .links a {\n  border: 1px solid #000;\n  padding: 3px 8px;\n  font-size: 15px;\n  position: relative;\n  z-index: 2;\n}\n.blog-wrapper .blog-content .blog-content-top .links a:first-child {\n  background-color: #000;\n  color: #fff !important;\n}\n.blog-wrapper .blog-content .blog-content-top .read-more {\n  padding: 15px;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n  margin: 0;\n}\n.blog-wrapper .blog-content .blog-content-top .user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #e1e1e1;\n  margin-top: 8px;\n  padding: 18px;\n  font-size: 14px;\n}\n.blog-wrapper .blog-content .blog-content-top .user i {\n  font-size: 18px;\n}\n.blog-wrapper .blog-content .blog-content-top .details-link {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.blog-wrapper .blog-sidebar {\n  width: 30%;\n}\n.blog-wrapper .blog-sidebar .item {\n  border: 1px solid #e0e0e0;\n  padding: 2rem;\n  background-color: #fff;\n}\n\n.blog-wrapper .blog-sidebar .item .date-select hr {\n  margin: 20px auto;\n}\n.blog-wrapper .blog-sidebar .item .date-select ul {\n  list-style: none;\n  margin: 0;\n}\n.blog-wrapper .blog-sidebar .item .date-select ul li {\n  margin: 0;\n}\n.blog-wrapper .blog-sidebar .item .date-select ul li:not(:last-child) {\n  margin-bottom: 10px;\n}\n.blog-wrapper .blog-sidebar .item:not(:last-child) {\n  margin-bottom: 16px;\n}\n.blog-wrapper .blog-sidebar .item h2 {\n  font-size: 24px;\n  font-weight: 300;\n  margin: 0;\n  margin-bottom: 24px;\n  text-align: center;\n}\n.blog-wrapper .blog-sidebar .item p {\n  margin: 0;\n}\n.blog-wrapper .blog-sidebar .item .item-element {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.blog-wrapper .blog-sidebar .item .item-element .error {\n  color: #f00000;\n}\n.blog-wrapper .blog-sidebar .item .item-element a {\n  padding: 3px 8px;\n  font-size: 16px;\n  border: 1px solid #000;\n}\n.blog-wrapper .blog-sidebar .item .item-element.category a {\n  background-color: #000;\n  color: #fff !important;\n}\n.blog-wrapper .blog-sidebar .item button {\n  margin-top: 24px;\n  padding: 0;\n  background-color: inherit;\n  color: #000;\n}\n.blog-wrapper .blog-sidebar .item button:hover {\n  text-decoration: none;\n}\n.single-blog {\n  padding-top: 134px;\n  background-color: #fafafa;\n}\n.single-blog-spinner {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -120px;\n}\n.single-blog-spinner .react-loading-skeleton {\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n}\n.single-blog .icon i {\n  font-size: 20px;\n  color: #000;\n}\n.blog-content-bottom {\n  margin-top: 20px;\n}\n.blog-content-bottom:not(:first-child) {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 20px;\n}\n\n.blog-details {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 80px 20px;\n}\n.blog-details .blog-wrapper {\n  display: flex;\n  gap: 30px;\n}\n.blog-details .top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n.blog-details .area {\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  padding: 24px;\n  width: 70%;\n}\n.blog-details .area-title {\n  width: 100%;\n  font-size: 36px;\n  font-family: roboto;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n  margin: 0px 0px 30px !important;\n}\n.blog-details .area-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.blog-details .area-social {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  margin-bottom: 16px;\n}\n.blog-details .area-social li {\n  margin: 0;\n}\n.blog-details .area-social i {\n  display: flex;\n  align-items: center;\n  width: 35px;\n  height: 35px;\n  justify-content: center;\n  color: #007ca1;\n  border-radius: 50%;\n  border: 2px solid #007ca1;\n}\n\n.blog-details .area-links {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.blog-details .area-links a {\n  border: 1px solid #000;\n  padding: 3px 8px;\n  font-size: 15px;\n}\n.blog-details .area-links a:first-child {\n  background-color: #000;\n  color: #fff !important;\n}\n.blog-details .area-main-title {\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0;\n  margin-bottom: 16px;\n}\n.blog-details .area-image {\n  margin-bottom: 16px;\n}\n.blog-details .area-content h2,\n.blog-details .area-content h3 {\n  font-size: 32px;\n  margin: 0;\n  margin-bottom: 16px;\n}\n.blog-details .area-content a {\n  color: #007ca1 !important;\n}\n.blog-details .blog-wrapper .related-post {\n  width: 30%;\n}\n.blog-details .blog-wrapper .related-post .item {\n  border: 1px solid #e0e0e0;\n  padding: 2rem;\n  background-color: #fff;\n}\n\n.blog-details .blog-wrapper .related-post:not(:last-child) {\n  margin-bottom: 16px;\n}\n.blog-details .blog-wrapper .related-post h2 {\n  font-size: 24px;\n  font-weight: 300;\n  margin: 0;\n  margin-bottom: 24px;\n  text-align: center;\n}\n.blog-details .blog-wrapper .related-post p {\n  margin: 0;\n}\n.blog-details .blog-wrapper .related-post button {\n  margin-top: 24px;\n  padding: 0;\n  background-color: inherit;\n  color: #000;\n}\n.blog-details .blog-wrapper .related-post button:hover {\n  text-decoration: none;\n}\n.blog-wrapper .related-post .item-element .content {\n  display: flex;\n  gap: 8px;\n}\n.blog-wrapper .related-post .item-element a {\n  border: none !important;\n}\n.blog-wrapper .related-post .item-element a:not(:last-child) {\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border: none;\n  border-bottom: 1px solid #444 !important;\n  display: inline-block;\n}\n.blog-wrapper .related-post .item-element .content .image {\n  max-width: 80px;\n}\n.blog-wrapper .related-post .item-element .content .image img {\n  width: 100%;\n  height: 100%;\n}\n.blog-wrapper .related-post .item-element .content .details p {\n  margin: 0;\n}\n\n/* commercial automation  */\n.commercial-page .solutions-svg {\n  max-width: 10%;\n  margin-left: auto;\n  margin-right: auto;\n  stroke-width: 2;\n}\n.commercial-page .outline {\n  fill: #00000000;\n  stroke: #fff;\n}\n.commercial-page .commercial-automantion-video {\n  height: 85vh;\n}\n\n.commercial-page .pointsmade {\n  text-transform: uppercase;\n}\n.commercial-page .wp-block-group__inner-container h1 {\n  margin-bottom: 20px !important;\n}\n.commercial-page .wp-block-group__inner-container .minigray {\n  margin-bottom: 30px;\n  color: #fff;\n  text-shadow: #575555 0.05em 0.05em 0.1em;\n  text-transform: uppercase;\n}\n.commercial-page .commercial-automation-ul {\n  font-size: 16px;\n  font-weight: 300;\n  color: #666;\n  list-style: none;\n}\n.commercial-page .commercial-automation-ul li {\n  margin: 0;\n  padding-left: 25px;\n  position: relative;\n  margin-bottom: 7px;\n}\n.commercial-page .commercial-automation-ul li::before {\n  content: \"\\f00c\";\n  font-family: \"FontAwesome\";\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.commercial-page .commercial-automation-bottom {\n  text-align: center;\n  padding: 80px 0;\n}\n.commercial-page .commercial-automation-bottom a {\n  font-size: 25px;\n}\n.commercial-page .commercial-automation-bottom .button {\n  background-color: #007ca1;\n  color: #fff !important;\n  padding: 10px 30px !important;\n  border-radius: 30px;\n  margin-top: 20px !important;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 14px !important;\n  border: 1px solid transparent;\n}\n\n.commercial-page .commercial-automation-bottom h2 {\n  font-size: 36px;\n  font-family: roboto;\n  text-transform: capitalize;\n  font-weight: 300;\n  color: #007ca1;\n  margin: 30px 0 !important;\n}\n\n/* commercial-technology */\n.commercial-technology .title-inner .section-grid .grid-item-1 {\n  width: 66.67%;\n}\n.commercial-technology .title-inner .section-grid .grid-item-2 {\n  width: 33.33%;\n}\n\n.footer-middle {\n  margin-top: 70px;\n  max-width: 1200px;\n  padding: 0 30px;\n  margin: 0 auto;\n  border-bottom: 1px solid #444;\n}\n.footer-middle .footer-middle-wrapper {\n  margin: 20px auto;\n  max-width: 750px;\n}\n.footer-middle .footer-middle-area {\n  display: grid;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  grid-gap: 15px;\n}\n.footer-middle .footer-middle-area .footer-middle-image img {\n  width: 100%;\n  height: 100%;\n}\n.footer-bottom {\n  margin: 35px 0;\n}\n.footer-bottom .toTop {\n  display: flex;\n  justify-content: center;\n  padding-bottom: 10px;\n}\n.footer-bottom .section-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n}\n.footer-bottom .section-inner .right-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  margin: 0;\n  list-style: none;\n}\n.footer-bottom .middle-footer p {\n  font-weight: 600;\n  text-transform: uppercase;\n  margin: 0;\n  color: #666;\n  font-size: 12px;\n}\n.footer-bottom .left-footer p {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0;\n  color: #666;\n  font-size: 12px;\n}\n.footer-bottom .left-footer p a:hover {\n  color: #007ca1 !important;\n}\n.footer-bottom .left-footer .license-number {\n  text-align: end;\n  display: inherit;\n  padding-top: 3px;\n}\n\n/* control4 */\n.home-standard {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n}\n.home-standard::before {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.home-standard .home-standard-area {\n  max-width: 1200px;\n  padding: 0 30px;\n  margin: 0 auto;\n}\n.home-standard .home-standard-area .content {\n  width: 450px;\n  position: relative;\n}\n.home-standard .home-standard-area .content .top {\n  padding: 40px;\n  background-color: #fafafa;\n}\n.home-standard .home-standard-area .content .top h3 {\n  font-size: 36px;\n  font-weight: 300;\n  line-height: 1.2;\n  text-transform: uppercase;\n  margin: 0;\n  color: #007ca1;\n}\n.home-standard .home-standard-area .content .top p {\n  margin: 0;\n  margin-top: 20px;\n}\n.home-standard .home-standard-area .content .image {\n  display: none;\n}\n.home-standard .home-standard-area .content .bottom {\n  margin-top: 40px;\n  padding-bottom: 70px;\n}\n.home-standard .home-standard-area .content .bottom h4 {\n  font-weight: 300;\n  text-transform: uppercase;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  margin: 0;\n  margin-bottom: 5px;\n  color: #fff;\n}\n.home-standard .home-standard-area .content .bottom h6 {\n  font-size: 16px;\n  line-height: 1.1;\n  letter-spacing: 0.03em;\n  font-weight: 300;\n  margin: 0;\n  color: #fff;\n}\n.home-standard .home-standard-area .content .bottom a {\n  margin: 20px 0;\n  padding: 0 25px;\n  background-color: transparent;\n  color: #fff !important;\n  border: 1px solid #fff !important;\n  line-height: 42px;\n  text-align: center;\n  border-radius: 30px;\n  display: inline-block;\n  font-size: 18px;\n}\n.home-standard .home-standard-area .content .bottom a:hover {\n  background-color: #fff;\n  color: #000 !important;\n}\n\n.control4-nav {\n  max-width: 1600px;\n  padding: 65px 30px;\n  margin: 0 auto;\n}\n.control4-nav.indoor-living-mobile-nav {\n  display: none;\n}\n.control4-nav .control4-nav-area {\n  display: flex;\n  gap: 30px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.control4-nav .control4-nav-area .nav-area {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 15px;\n  justify-content: center;\n}\n.control4-nav .control4-nav-area .nav-area a {\n  display: inline-block;\n  border: 1px solid #007ca1 !important;\n  color: #007ca1 !important;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-weight: 300;\n  font-size: 14px;\n  text-transform: uppercase;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n}\n.control4-nav .control4-nav-area .nav-area a:hover {\n  background-color: #007ca1 !important;\n  color: #fff !important;\n}\n\n.control4 {\n  width: 100%;\n}\n.control4 .control4-hero {\n  position: relative;\n  height: 100vh;\n  overflow: hidden;\n}\n.control4 .control4-hero::before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.control4 .control4-hero video {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: auto !important;\n  z-index: -100;\n  height: auto;\n  min-height: 100vh;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n.control4 .control4-hero img {\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n}\n.control4 .control4-hero .control4-content {\n  position: absolute;\n  bottom: 0;\n  max-width: 1300px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.control4 .control4-hero .control4-content h1 {\n  font-size: 32px;\n  font-weight: 300;\n  color: #fff;\n  margin: 0;\n  margin-bottom: 45px;\n  text-shadow: #747474 0.05em 0.05em 0.1em;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n.control4 .control4-hero .control4-content p {\n  color: #fff;\n  text-shadow: #747474 0.05em 0.05em 0.1em;\n  text-align: center;\n}\n.control4 .control4-hero .control4-content a {\n  display: inline-block;\n  border: 1px solid #aaa;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-weight: 300;\n  color: #fff;\n  font-size: 14px;\n  margin: 0px 15px;\n  text-transform: uppercase;\n  background-color: rgba(0, 0, 0, 0.35);\n}\n.control4 .control4-hero .control4-content a:hover {\n  background-color: rgba(0, 0, 0, 0.6);\n  color: #fff;\n}\n.control4-feature .feature-area {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n.control4-feature .feature-area .feature-item {\n  position: relative;\n}\n.control4-feature .feature-area .feature-item::before {\n  position: absolute;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0.6);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: all 0.5s;\n}\n.control4-feature .feature-area .feature-item:hover::before {\n  opacity: 1;\n}\n.control4-feature .feature-area .feature-item .content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: all 0.5s;\n  width: 90%;\n}\n.control4-feature .feature-area .feature-item:hover .content {\n  opacity: 1;\n}\n.control4-feature .feature-area .feature-item .content h5 {\n  color: #fff;\n}\n.control4-feature .feature-area .feature-item .content p {\n  color: #fff;\n}\n.control4-empty {\n  padding: 60px 0;\n}\n\n.swiper-wrapper {\n  margin-bottom: 50px;\n}\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: #58c7f1;\n}\n.control4-featureV2 .control4-featureV2-top {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  padding: 30px 0;\n}\n\n.control4-featureV2 .control4-featureV2-top .item .title {\n  margin: 0 auto;\n  font-size: 24px;\n  line-height: 1;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  overflow: hidden;\n  text-align: center;\n}\n.control4-featureV2 .control4-featureV2-top .item .title > * {\n  display: inline-block;\n  position: relative;\n}\n.control4-featureV2 .control4-featureV2-top .item .title > ::after,\n.control4-featureV2 .control4-featureV2-top .item .title > ::before {\n  content: \"\";\n  position: absolute;\n  top: calc(50% - (calc(2px + 0.02em) / 2));\n  width: 2000px;\n  border-bottom: calc(2px + 0.02em) solid #e7e7e7;\n}\n.control4-featureV2 .control4-featureV2-top .item .title > ::before {\n  right: 100%;\n  margin-right: calc(5px + 0.3em);\n}\n.control4-featureV2 .control4-featureV2-top .item .title > ::after {\n  left: 100%;\n  margin-left: calc(5px + 0.3em);\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content .item-image {\n  margin-top: 10px;\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content {\n  position: relative;\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content p {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  transform: translate(-50%, -50%);\n  padding: 30px;\n  color: #fff;\n  opacity: 0;\n  transition: all 0.5s;\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content::before {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #007ca1;\n  opacity: 0;\n  transition: all 0.5s;\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content:hover::before {\n  opacity: 1;\n}\n.control4-featureV2 .control4-featureV2-top .item .item-content:hover p {\n  opacity: 1;\n}\n.control4-brands {\n  max-width: 1200px;\n  padding: 65px 30px;\n  margin: 0 auto;\n}\n.control4-brands .control4-brands-area {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  align-items: center;\n  justify-content: space-between;\n}\n.control4-brands .control4-brands-area .top h3 {\n  font-size: 36px;\n  line-height: 1.2;\n  font-weight: 300;\n  text-transform: uppercase;\n  margin: 0;\n  color: #007ca1;\n}\n.control4-brands .control4-brands-area .top h5 {\n  font-size: 20px;\n  line-height: 1.1;\n  font-weight: 300;\n  margin: 0 0 20px 0;\n  color: #222;\n  text-transform: uppercase;\n}\n.control4-brands .control4-brands-area .nav-area {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.peace-of-mind .peace-of-mind-left h3 {\n  font-size: 36px;\n  line-height: 1.2;\n  margin: 0;\n  font-weight: 300;\n  text-transform: uppercase;\n  color: #007ca1;\n}\n.peace-of-mind .peace-of-mind-left h5 {\n  font-size: 20px;\n  line-height: 1.1;\n  font-weight: 300;\n  margin: 0 0 20px 0;\n  color: #222;\n  text-transform: uppercase;\n}\n.peace-of-mind .peace-of-mind-left p {\n  margin: 10px 0;\n}\n.peace-of-mind .peace-of-mind-right h3 {\n  font-size: 36px;\n  line-height: 1.2;\n  margin: 0;\n  font-weight: 300;\n  text-transform: uppercase;\n}\n.peace-of-mind .peace-of-mind-right a {\n  font-size: 14px;\n}\n.uk-overlay-default {\n  background-color: linear-gradient(\n    0deg,\n    rgba(8, 8, 9, 0.8) 11%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n.el-slidenav svg {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.12);\n  border: 1px solid #fff;\n  color: #fff;\n  padding: 5px;\n  display: flex;\n}\n.uk-dotnav a {\n  width: 12px;\n  height: 12px;\n}\n.uk-dotnav .uk-active a {\n  background-color: #007ca1;\n}\n.uk-position-absolute.icon i {\n  background-color: #007ca1;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.golf-simulators-left h4 {\n  font-size: 26px;\n  line-height: 1.4;\n  letter-spacing: 0.25px;\n  text-align: center;\n  margin: 0;\n  margin-bottom: 20px;\n  color: #007ca1;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.golf-simulators-left i {\n  text-align: center;\n  display: inherit;\n  font-size: 35px;\n  color: #007ca1;\n  margin-bottom: 20px;\n}\n.golf-simulators-title {\n  font-size: 38px;\n  margin: 0;\n  margin-bottom: 30px;\n  font-weight: 400;\n  line-height: 1.3;\n  color: #007ca1;\n}\n.golf-simulators-left p {\n  font-style: italic;\n}\n.golf-simulators .uk-margin {\n  margin-top: 50px !important;\n}\n.golf-simulators-left .content {\n  background-color: #fafafa;\n}\n.golf-simulators ul {\n  position: inherit;\n}\n.golf-simulators ul li {\n  margin: 0;\n  padding: 0;\n}\n#page\\#0 {\n  padding-left: 30px;\n  padding-right: 0px;\n}\n.golf-simulators ul li h3 {\n  font-size: 36px;\n  font-weight: 400;\n}\n.golf-simulators ul li a {\n  font-size: 14px;\n  padding: 0;\n  margin-left: 20px;\n  border-bottom: 2px solid transparent;\n}\n.golf-simulators-video {\n  overflow: hidden;\n  position: relative;\n  padding: 70px 0;\n}\n.golf-simulators-video video {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.golf-simulators-video .video-container {\n  max-width: 1200px;\n  margin: 0px auto;\n  position: relative;\n  z-index: 99;\n}\n.golf-simulators-video .video-content {\n  width: 450px;\n  padding: 25px;\n  margin-left: auto;\n}\n.golf-simulators-video .video-content.left {\n  margin-right: auto;\n  margin-left: 0;\n}\n.golf-simulators-video .video-content h1 {\n  margin: 0;\n  padding: 40px 0 20px;\n  font-size: 44px;\n  color: #fff;\n  font-weight: 500;\n  position: relative;\n}\n.golf-simulators-video .video-content h1::before {\n  position: absolute;\n  content: \"\";\n  left: 0;\n  border-top: 3px solid #007ca1;\n  width: 54px;\n  top: 0;\n}\n.golf-simulators-video .video-content p {\n  margin: 30px 0;\n  color: #fff;\n}\n.request-quote h5 {\n  margin: 0;\n  margin-bottom: 20px;\n  color: #007ca1;\n  font-weight: 300;\n}\n.request-quote .message-icon {\n  text-align: center;\n  color: #007ca1;\n}\n.careers-team .careers-team-title {\n  font-size: 44px;\n  line-height: 1.2;\n  font-weight: 300;\n  letter-spacing: -1.5px;\n  margin: 0;\n  margin-bottom: 30px;\n  color: #007ca1;\n}\n.careers-team h3 {\n  font-size: 30px !important;\n  line-height: 1.2;\n  font-weight: 300;\n  letter-spacing: -0.75px;\n  margin-top: 40px;\n  margin-bottom: 30px;\n  color: #333;\n}\n.careers-team ul {\n  margin: 0;\n  padding: 0;\n}\n.careers-team ul li {\n  margin: 0;\n  padding: 0;\n}\n.careers-team ul li p {\n  font-size: 16px;\n  color: #007ca1;\n}\n\n.convertforms .cf-control-group {\n  padding: 9px;\n  max-width: 100%;\n  width: 100%;\n  min-width: 120px;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n.apply-now h3 {\n  font-size: 44px;\n  margin: 0;\n  margin-bottom: 40px;\n  font-weight: 300;\n  color: #007ca1;\n}\n.apply-now form label {\n  padding: 10px;\n}\n.apply-now form input,\n.apply-now form textarea {\n  margin-top: 15px;\n  border: 1px solid #444;\n}\n.apply-now form input:focus,\n.apply-now form textarea:focus {\n  outline: none;\n  border: 1px solid #444;\n}\n\n.about-us h1 {\n  font-size: 44px;\n  margin: 0;\n  margin-bottom: 40px;\n  font-weight: 300;\n}\n\n/* commercial automation  */\n.commercial-page .commercial-automantion-video {\n  height: 85vh;\n}\n.commercial-page .pointsmade {\n  text-transform: uppercase;\n}\n.commercial-page .wp-block-group__inner-container h1 {\n  margin-bottom: 20px !important;\n}\n.commercial-page .wp-block-group__inner-container .minigray {\n  margin-bottom: 30px;\n  color: #fff;\n  text-shadow: #575555 0.05em 0.05em 0.1em;\n  text-transform: uppercase;\n}\n.commercial-page .commercial-automation-ul {\n  font-size: 16px;\n  font-weight: 300;\n  color: #666;\n  list-style: none;\n}\n.commercial-page .commercial-automation-ul li {\n  margin: 0;\n  padding-left: 25px;\n  position: relative;\n  margin-bottom: 7px;\n}\n.commercial-page .commercial-automation-ul li::before {\n  content: \"\\f00c\";\n  font-family: \"FontAwesome\";\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.commercial-page .commercial-automation-bottom {\n  text-align: center;\n  padding: 80px 0;\n}\n.commercial-page .commercial-automation-bottom a {\n  font-size: 25px;\n}\n\n.commercial-page .commercial-automation-bottom h2 {\n  font-size: 36px;\n  font-family: roboto;\n  text-transform: capitalize;\n  font-weight: 300;\n  color: #007ca1;\n  margin: 30px 0 !important;\n}\n\n/* commercial-technology */\n.commercial-technology .title-inner .section-grid .grid-item-1 {\n  width: 66.67%;\n}\n.commercial-technology .title-inner .section-grid .grid-item-2 {\n  width: 33.33%;\n}\n\n.wp-block-group.homevideo.servicespages.commercial-automantion-video {\n  height: 85vh;\n}\n\n/* portfolio page  */\n\n.portfolio-page .Portfolio-navigation {\n  background-color: #fff;\n  margin: 70px 0;\n  display: flex;\n  justify-content: center;\n}\n.portfolio-page .Portfolio-navigation .Portfolio-navigation-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.portfolio-page .Portfolio-navigation .Portfolio-navigation-container a {\n  display: inline-block;\n  border: 1px solid #007ca1 !important;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-weight: 300;\n  color: #007ca1 !important;\n  font-size: 14px;\n  margin: 0px 15px;\n  text-transform: uppercase;\n  background-color: transparent;\n}\n.portfolio-page .Portfolio-navigation .Portfolio-navigation-container a:hover {\n  background-color: #007ca1 !important;\n  color: #fff !important;\n}\n\n.portfolio-page .portfolio-content {\n  background-color: #fafafa;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-bottom: 30px;\n}\n.portfolio-page .portfolio-content .connected-living-title-section {\n  margin-top: 0px;\n}\n.portfolio-page\n  .portfolio-content\n  .connected-living-title-section\n  .title-inner {\n  max-width: 600px;\n}\n.portfolio-page .portfolio-content .portfolio-content-grid {\n  max-width: 1600px;\n  padding: 0 20px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  align-items: center;\n  grid-gap: 15px;\n}\n\n.portfolio-content a {\n  color: #007ca1;\n}\n.portfolio-content a:hover {\n  color: #289abd !important;\n}\n.portfolio-page\n  .portfolio-content\n  .portfolio-content-grid\n  .portfolio-content-grid-item {\n  width: 100%;\n  height: 250px;\n}\n.portfolio-page\n  .portfolio-content\n  .portfolio-content-grid\n  .portfolio-content-grid-item\n  a {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.portfolio-page\n  .portfolio-content\n  .portfolio-content-grid\n  .portfolio-content-grid-item\n  a::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  transition: all 0.3s;\n  background-color: #007ca1;\n  z-index: 1;\n}\n.portfolio-page\n  .portfolio-content\n  .portfolio-content-grid\n  .portfolio-content-grid-item\n  a:hover::before {\n  opacity: 0.7;\n}\n.portfolio-page\n  .portfolio-content\n  .portfolio-content-grid\n  .portfolio-content-grid-item\n  img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.uk-lightbox-button {\n  color: #fff !important;\n  background-color: transparent;\n  border-radius: 50%;\n  border: 1px solid #fafafa;\n}\n\n.portfolio-page .portfolio-wrapper .minigray {\n  font-size: 16px;\n}\n.portfolio-page .portfolio-wrapper .button__primary {\n  margin-top: 0 !important;\n}\n\n/* josh ai */\n.josh-ai-page .josh-ai-navigation {\n  background-color: #fafafa;\n  margin: 0;\n  padding: 60px 0;\n}\n.josh-ai-page .josh-ai-navigation .josh-ai-navigation-grid {\n  margin: 0px auto;\n  display: flex;\n  justify-content: space-between;\n  max-width: 1400px;\n  padding: 0 20px;\n}\n\n.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container a {\n  display: inline-block;\n  border: 1px solid #007ca1;\n  padding: 8px 20px;\n  border-radius: 30px;\n  font-weight: 300;\n  color: #007ca1 !important;\n  font-size: 14px;\n  margin: 0px 15px;\n  text-transform: uppercase;\n  background-color: transparent;\n}\n.josh-ai-page .josh-ai-navigation .josh-ai-navigation-container a:hover {\n  background-color: #007ca1 !important;\n  color: #fff !important;\n}\n\n.josh-ai-page .text-32 {\n  color: #666;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.josh-ai-page .josh-ai-privacy h3 {\n  font-size: 36px;\n  font-family: roboto;\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n}\n.josh-ai-page .josh-ai-privacy h4 {\n  font-size: 36px;\n  font-family: roboto;\n  text-transform: capitalize;\n  font-weight: 300;\n  color: #007ca1;\n}\n.josh-ai-page .josh-ai-tab a {\n  font-size: 14px;\n}\n.uk-tile-secondary,\n.uk-section-secondary {\n  background-color: #007ca1 !important;\n}\n.josh-ai-page .josh-ai-bottom h5 {\n  text-transform: uppercase;\n  font-weight: 300;\n  letter-spacing: 1px;\n  color: #007ca1;\n}\n.max-width-hero {\n  max-width: 1200px !important;\n}\n\n.privacy-policy {\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 20px;\n  padding-top: 135px;\n}\n.privacy-policy h3,\nh4,\nh5,\nh6 {\n  margin-top: 0px;\n}\n.privacy-policy h6 {\n  letter-spacing: 0;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n}\n.privacy-policy a {\n  color: blue;\n  text-decoration: underline;\n}\n.hero video {\n  background-color: #007ca1;\n}\n.commercial-security .commercial-security-icon {\n  width: 120px;\n}\n.commercial-security .commercial-security-content-main {\n  background-color: rgba(31, 31, 31, 0.6);\n  justify-content: center;\n}\n.commercial-security .commercial-security-area {\n  max-width: 750px;\n  max-width: 750px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.commercial-security .commercial-security-area h1 {\n  margin-bottom: 10px;\n}\n.commercial-security .commercial-security-area h1,\n.commercial-security .commercial-security-area h6 {\n  color: #fff;\n}\n.commercial-security .commercial-security-icon .outline {\n  fill: #00000000;\n  stroke: #fff;\n}\n\n.math-question {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid #e4e4e4;\n  padding: 15px;\n}\n.math-question > label {\n  width: 140px;\n  margin: 0;\n  font-weight: 700;\n}\n.math-question > input {\n  width: 150px;\n  border-radius: 10px;\n  border: 1px solid #e4e4e4;\n  margin: 0 !important;\n}\n\n.contactarea .wpcf7-form .math-question {\n  padding-bottom: 12px;\n  padding-top: 12px;\n  border-radius: 30px;\n  margin-bottom: 10px;\n}\n.contactarea .wpcf7-form .math-question > label {\n  color: #fff;\n}\n.contactarea .wpcf7-form .math-question > input {\n  background-color: rgba(23, 25, 26, 0.85);\n  border-radius: 30px;\n  color: #fff;\n}\n\ninput[type=\"submit\"]:disabled {\n  background-color: #b4b4b4;\n  cursor: not-allowed;\n  color: white;\n}\ninput[type=\"submit\"]:disabled:hover {\n  background-color: #b4b4b4;\n  cursor: not-allowed;\n  color: white;\n}\nbutton[type=\"submit\"]:disabled {\n  background-color: #b4b4b4;\n  cursor: not-allowed;\n  color: white;\n}\nbutton[type=\"submit\"]:disabled:hover {\n  background-color: #b4b4b4;\n  cursor: not-allowed;\n  color: white;\n}\n\n.contactarea .wpcf7-submit:disabled:hover {\n  border: transparent;\n  color: #fff !important;\n}\n\n.button__primary.display-block {\n  display: block;\n}\n\n/*** Media Querry  ***/\n\n@media only screen and (min-width: 1600px) {\n  .tm-grid-expand > .a-day-life-width-expand\\@xl {\n    flex-grow: 999;\n  }\n}\n@media only screen and (max-width: 1400px) {\n  .golf-simulators ul li a {\n    padding: 5px;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  #video-background.high4kres {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    min-width: auto;\n    z-index: -100;\n    max-width: none;\n    height: auto !important;\n    transform: translate(-50%, -50%);\n    width: 100vw !important;\n  }\n  #video-background.fulltextvid {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    min-width: auto;\n    min-height: auto;\n    width: 101% !important;\n    z-index: -100;\n    max-width: none;\n    height: auto !important;\n    transform: none;\n  }\n  #video-background.customsized {\n    width: 100% !important;\n    min-width: 100%;\n  }\n  .tm-grid-expand > .a-day-life-width-expand\\@l {\n    flex-grow: 999;\n  }\n  .a-day-life-grid {\n    margin-left: -40px;\n  }\n  * + .a-day-life-grid-margin,\n  .a-day-life-grid + .a-day-life-grid,\n  .a-day-life-grid > .a-day-life-grid-margin {\n    margin-top: 40px;\n  }\n  .csh-card .csh-card-content {\n    padding: 40px 40px;\n  }\n  .our-process\n    .our-process-hero\n    .our-process-hero-content\n    .content-wrapper\n    .content-title {\n    margin-bottom: 45px;\n  }\n  .our-process video {\n    height: 700px;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .a-day-life-video-section video {\n    height: 600px;\n  }\n  .a-day-life-video-section .video-content {\n    position: inherit;\n    width: auto;\n    transform: inherit;\n    left: 0;\n  }\n  .a-day-life-video-section .video-content.right-text {\n    right: 0;\n    left: 0;\n    position: inherit;\n  }\n  .a-day-life-nav .nav-item {\n    width: 33.33%;\n    margin-top: 20px;\n  }\n  .josh-ai-page .josh-ai-hero-content {\n    display: none;\n  }\n  .josh-new-content {\n    display: block;\n  }\n  .wp-block-group.homevideo.servicespages {\n    height: inherit;\n  }\n  .wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {\n    height: inherit;\n  }\n  .servicesdualcontainer {\n    display: block;\n    padding: 0px !important;\n  }\n  .servicesimages.wp-block-column {\n    margin: 0px !important;\n    padding: 1px 2px;\n  }\n  .servicestextcontainer {\n    padding: 90px 30px 60px !important;\n    max-width: inherit;\n  }\n  .servicesimages.sidevideo.wp-block-column {\n    margin: 1px 2px !important;\n  }\n  .servicesimages.sidevideoleft.wp-block-column {\n    margin: 1px 2px !important;\n  }\n\n  .nav-toggle .toggle-inner {\n    margin-top: -30px;\n  }\n  .nav-toggle .toggle-text {\n    color: #fff !important;\n    font-weight: 300;\n    text-transform: uppercase;\n  }\n  .site-logo img {\n    max-height: 4rem;\n  }\n  .servicessubs {\n    padding: 0px;\n  }\n  .servicessubs .wp-block-group__inner-container p {\n    display: none;\n  }\n  #video-background {\n    position: relative;\n    left: inherit;\n    top: inherit;\n    min-width: inherit;\n    width: 100% !important;\n    z-index: -100;\n    max-width: none;\n    height: auto !important;\n    transform: inherit;\n    object-fit: cover;\n  }\n  .footer-widgets.column-two {\n    margin-top: 0px;\n  }\n  .servicesimages.sidevideo #video-background {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto !important;\n    z-index: 1;\n    max-width: none;\n    height: 100% !important;\n    transform: translate(-50%, -50%);\n  }\n  .footerlinks {\n    display: block;\n    overflow: hidden;\n  }\n  .footerlinks1 {\n    width: 50%;\n    float: left;\n  }\n  .footerlinks2 {\n    float: left;\n    width: 50%;\n  }\n  .footerlinks1 img {\n    max-width: 200px;\n  }\n  .wp-block-group.homevideo {\n    height: inherit;\n  }\n  .wp-block-group.homevideo > .wp-block-group__inner-container {\n    height: inherit;\n  }\n  .pagecolumns .wp-block-column {\n    flex-basis: 250px !important;\n  }\n  .pagecolumns .wp-block-column:first-child {\n    flex-basis: 100% !important;\n  }\n  .picturetime figcaption {\n    font-weight: 300;\n  }\n  .picturetime figcaption strong {\n    font-weight: 500;\n  }\n  .pickanarea {\n    flex-direction: column;\n    padding-bottom: 45px;\n  }\n  .pickanarea > .wp-block-column {\n    max-width: 100%;\n    margin-left: 0px;\n  }\n  .pickanarea > .wp-block-column > .wp-block-columns {\n    margin: 2rem 0px;\n  }\n  h2.pickareaheading {\n    padding: 45px 30px 45px;\n  }\n  .footer-widgets.column-one div:first-child {\n    width: 100%;\n  }\n  .footer-widgets.column-one {\n    align-items: stretch;\n    min-height: inherit;\n  }\n  .fullimagetop {\n    height: 65vh !important;\n  }\n  .homedualcontainer {\n    display: block;\n    overflow: hidden;\n    padding: 60px 0px 0px !important;\n  }\n  .homedual2.homelighting,\n  .homedual2.homeshow2,\n  .homedual2.homeshow3 {\n    height: 600px;\n    background-position: left center !important;\n  }\n  .iconsbox {\n    text-align: center;\n    padding: 0px !important;\n    float: left;\n    width: 50%;\n  }\n  .homedual2 {\n    overflow: hidden;\n  }\n  .homedual2.duallefttext {\n    text-align: center;\n  }\n  .hideonshow {\n    opacity: 1;\n  }\n  .duallefttext .iconsbox {\n    flex-direction: column;\n  }\n  .homedualcontainer .duallefttext p {\n    display: block;\n  }\n  .duallefttext .iconsbox .wp-block-column {\n    margin: 0px 0px 30px 0px !important;\n  }\n  .portfolio-page .portfolio-content .portfolio-content-grid {\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n  }\n  .commercial-technology .wp-block-group.homevideo.servicespages {\n    height: 70vh !important;\n  }\n  .wp-block-group.homevideo.servicespages.commercial-automantion-video {\n    height: 70vh;\n  }\n  .josh-ai-page .josh-ai-navigation .josh-ai-navigation-grid {\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n  }\n  .portfolio-page .portfolio-wrapper .career-background {\n    padding: 20px 20px !important;\n  }\n}\n@media only screen and (max-width: 1080px) {\n  .homephone {\n    display: none !important;\n  }\n  .brandscolumn .wp-block-column {\n    width: 40%;\n  }\n  .brandscolumn .wp-block-column:nth-child(3n + 1) {\n    margin-left: 32px;\n  }\n  .brandscolumn .wp-block-column:nth-child(2n + 1) {\n    margin-left: 0px;\n  }\n  .duallefttext .iconsbox {\n    display: block;\n    width: 100%;\n  }\n  .homedualcontainer .duallefttext .fas,\n  .homedualcontainer .duallefttext .far {\n    color: #d4d4d4;\n    float: left;\n    padding: 7px 0px 10px 0px;\n    overflow: hidden;\n    line-height: 1;\n    font-size: 24px;\n    border: none !important;\n    width: auto;\n    float: none;\n  }\n  .duallefttext .iconsbox .wp-block-column {\n    text-align: center;\n  }\n  .iconsbox {\n    width: 100%;\n    margin: 0px !important;\n  }\n  .homedualcontainer h2 {\n    font-size: 18px !important;\n    margin-bottom: 10px !important;\n  }\n  .homedual2 {\n    padding: 60px 30px;\n  }\n  .homedualcontainer {\n    padding: 0px !important;\n  }\n  .homedualcontainer.bottomdual {\n    padding: 0px !important;\n  }\n  .control4small.homecedialogo a {\n    left: 50%;\n    right: 50%;\n    width: 120px;\n    height: 120px;\n    transform: translate(-50%, -50%);\n  }\n  .commercial-technology .title-inner .section-grid .grid-item-1 {\n    width: 100%;\n  }\n  .commercial-technology .title-inner .section-grid .grid-item-2 {\n    width: 100%;\n  }\n}\n@media only screen and (max-width: 1000px) {\n  .commercial-page .wp-block-group__inner-container h1 {\n    display: none;\n  }\n  li.menu-item-3288 {\n    position: relative;\n    margin-top: 0px;\n  }\n  .wp-block-group.homevideo {\n    margin-top: 100px !important;\n  }\n  .control4-empty {\n    padding: 40px;\n  }\n  .serviceswhitebackground p {\n    padding: 0 20px 20px !important;\n  }\n  .control4 .control4-hero {\n    height: 75vh;\n  }\n  .control4-nav .control4-nav-area {\n    flex-direction: column;\n  }\n  .golf-simulators-video {\n    padding: 50px 0;\n  }\n  .control4 .control4-hero video {\n    height: 75vh;\n  }\n  .control4 .control4-hero .control4-content {\n    width: 100%;\n    padding: 0 30px;\n  }\n  .control4-featureV2 .control4-featureV2-top {\n    flex-direction: column;\n  }\n  .control4-featureV2 .control4-featureV2-top .item {\n    width: 100%;\n  }\n  .our-process-desc {\n    flex-wrap: wrap;\n  }\n  .our-process-desc .our-process-desc-left {\n    width: 100%;\n  }\n  .our-process-desc .our-process-desc-right {\n    width: 100%;\n  }\n  .our-process-desc .our-process-desc-left .card {\n    padding: 20px;\n  }\n  .our-process-desc .our-process-desc-right .card-item {\n    padding: 30px;\n  }\n  .blog-wrapper {\n    flex-wrap: wrap;\n  }\n  .blog-wrapper .blog-content {\n    width: 100%;\n  }\n  .blog-wrapper .blog-sidebar {\n    width: 100%;\n  }\n  .blog-details .blog-wrapper {\n    flex-wrap: wrap;\n  }\n  .blog-details .blog-wrapper .area {\n    width: 100%;\n  }\n  .blog-details .blog-wrapper .related-post {\n    width: 100%;\n  }\n  .commercial-technology .title-inner .section-grid .grid-item-1 {\n    width: 100%;\n  }\n  .commercial-technology .title-inner .section-grid .grid-item-2 {\n    width: 100%;\n  }\n  .footer-middle .footer-middle-area {\n    grid-template-columns: 1fr 1fr;\n    justify-content: center;\n  }\n  .footer-middle {\n    margin-top: 40px;\n  }\n  .footer-bottom {\n    margin-top: 30px;\n  }\n  .footer-bottom .section-inner {\n    flex-wrap: wrap;\n  }\n  .footer-bottom .section-inner .right-footer {\n    margin: 0 auto;\n  }\n  .footer-bottom .section-inner .middle-footer {\n    text-align: center;\n  }\n  .footer-bottom .section-inner .left-footer {\n    margin: 0 auto;\n  }\n  .home-standard .home-standard-area .content {\n    width: 100%;\n  }\n  .home-standard .home-standard-area .content .bottom {\n    margin-top: 30px;\n  }\n  .golf-simulators-video {\n    padding: 50px 0;\n  }\n  .golf-simulators-video .video-content {\n    width: 100%;\n    padding: 30px;\n  }\n  .request-quote img {\n    margin: 0 auto;\n  }\n\n  .portfolio-page .portfolio-content .portfolio-content-grid {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n@media only screen and (max-width: 960px) {\n  .josh-ai-big-feature {\n    margin-top: 400px;\n  }\n  .josh-ai-big-image img {\n    width: 400px;\n    height: 400px;\n  }\n  .indoor-living-about .indoor-living-about-box {\n    width: 100%;\n  }\n  .indoor-living-about .indoor-living-feature {\n    width: 100%;\n  }\n  .title-inner .section-grid .grid-item-1 {\n    width: 100%;\n    margin-bottom: 40px;\n  }\n  .title-inner .section-grid .grid-item-2,\n  .title-inner .section-grid .grid-item-3 {\n    width: 50%;\n  }\n  .csca .csca-content-area {\n    padding: 0 30px 30px 30px;\n  }\n  .extra-padding {\n    padding: 35px 0;\n  }\n  .commercial-security-wrapper {\n    height: 100vh;\n    background-position: right;\n    background-size: cover;\n  }\n}\n@media only screen and (min-width: 960px) {\n  .tm-grid-expand > .a-day-life-width-expand\\@m {\n    flex-grow: 999;\n  }\n  .uk-h1,\n  h1 {\n    font-size: 44px;\n  }\n  .uk-h2,\n  h2 {\n    font-size: 38px;\n  }\n}\n@media only screen and (min-width: 900px) {\n  .a-day-life-section {\n    padding-top: 70px;\n    padding-bottom: 70px;\n  }\n  .a-day-life-container {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n  .uk-section-xlarge {\n    padding-top: 210px;\n    padding-bottom: 210px;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .footer-bottom {\n    margin-top: 0px;\n  }\n  .footerlinks {\n    padding-bottom: 0;\n  }\n  .footer-middle {\n    display: none;\n  }\n  .footer-bottom .section-inner {\n    flex-direction: column;\n  }\n  .footer-bottom .section-inner .left-footer .license-number {\n    text-align: center;\n  }\n}\n@media only screen and (max-width: 728px) {\n  .homedual2.homelighting,\n  .homedual2.homeshow2,\n  .homedual2.homeshow3 {\n    height: 300px;\n    background-size: cover;\n  }\n  .wp-block-group.homevideo.servicespages {\n    height: inherit !important;\n  }\n  .wp-block-group.homevideo.servicespages > .wp-block-group__inner-container {\n    height: inherit !important;\n  }\n  .homeintrotop h1 {\n    font-size: 30px;\n    font-weight: 300;\n  }\n  .pagewhitebackground h2 {\n    font-size: 24px;\n  }\n  .pagecolumns .wp-block-column:first-child {\n    border-right: none;\n    padding-right: 0px;\n    margin-right: 0px;\n  }\n  .pagewhitebackground {\n    padding: 45px 30px 30px !important;\n  }\n  .servicestextcontainer {\n    padding: 45px 30px 45px !important;\n  }\n  .homeintrotop.centerintro {\n    padding: 45px 15px 0px;\n  }\n  .serviceswhitebackground {\n    padding: 45px 30px 45px !important;\n  }\n  .servicesdualcontainer h2 {\n    font-size: 24px;\n  }\n  .footerlinks1 {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n  .footerlinks2 {\n    width: 100%;\n    padding-right: 30px;\n    margin-top: 30px;\n    padding-top: 30px;\n    border-top: 1px solid #2c2f30;\n  }\n  .footerlinks1 i {\n    max-width: 150px;\n    margin: 0px auto;\n  }\n  .contactarea {\n    display: block;\n  }\n  .pickanarea > .wp-block-column > .wp-block-columns .wp-block-column {\n    flex-basis: 50% !important;\n  }\n  .pickanarea > .wp-block-column {\n    margin-bottom: 0px;\n  }\n  .pickanarea > .wp-block-column > .wp-block-columns {\n    margin: 0px;\n  }\n  .picturetime .wp-block-column {\n    flex-basis: 50% !important;\n    padding: 0px 10px;\n    margin-bottom: 0px !important;\n  }\n  .contactareabox {\n    padding: 40px 20px;\n  }\n  .contactareabox2 h3 {\n    font-size: 24px;\n  }\n  .start-your-project .pagecolumns .wp-block-column:first-child {\n    flex-basis: 100% !important;\n    border: none !important;\n  }\n\n  .fullimagetop {\n    height: 400px !important;\n  }\n  .halfimagetop {\n    height: 400px;\n  }\n  .brandscolumn .wp-block-column {\n    width: 100% !important;\n    margin: 0px 0px 32px 0px !important;\n  }\n  .brandscolumn {\n    display: block;\n  }\n  .wp-block-group.homevideo.servicespages.commercial-automantion-video {\n    height: 40vh !important;\n  }\n\n  .commercial-technology .wp-block-group.homevideo.servicespages {\n    height: 40vh !important;\n  }\n\n  .portfolio-page .portfolio-content .portfolio-content-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media only screen and (min-width: 700px) {\n  .josh-ai-page .josh-ai-bottom h5 {\n    margin: 0;\n  }\n}\n@media only screen and (min-width: 640px) {\n  .a-day-life-container {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .tm-grid-expand > .a-day-life-width-expand\\@s {\n    flex-grow: 999;\n  }\n}\n@media only screen and (max-width: 640px) {\n  .a-day-life-video-section video {\n    height: 400px;\n  }\n  .title-inner .section-grid .grid-item-1,\n  .title-inner .section-grid .grid-item-2 {\n    width: 100%;\n    margin-bottom: 40px;\n    padding: 0 25px;\n  }\n  .title-inner .section-grid .grid-item-3 {\n    width: 100%;\n    padding: 0 25px;\n  }\n  .grid-item-3 .icon-grid i {\n    font-size: 50px;\n  }\n  .csca video,\n  .csca .image {\n    height: 260px;\n  }\n  .csca .csca-content {\n    background-color: #fff;\n  }\n  .csca .csca-icon {\n    width: 150px;\n  }\n  .csca .csca-icon .outline {\n    fill: #00000000;\n    stroke: #007ca1;\n  }\n  .csca .csca-content h1 {\n    color: #333;\n  }\n  .csca .csca-content h6 {\n    color: #333;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .our-process video {\n    height: 550px;\n  }\n  .our-process\n    .our-process-hero\n    .our-process-hero-content\n    .content-wrapper\n    .content-title {\n    margin-bottom: 35px;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .control4small.homecedialogo a {\n    display: none;\n  }\n  .nav-drawer {\n    width: 80% !important;\n  }\n  .control4 .control4-hero {\n    height: 450px;\n  }\n  .control4 .control4-hero video {\n    height: 450px;\n  }\n  .blog-content-bottom {\n    grid-template-columns: 1fr;\n  }\n  .home-standard {\n    background-image: none !important;\n  }\n  .home-standard .home-standard-area {\n    padding: 0;\n  }\n  .home-standard .home-standard-area .content .image {\n    display: block;\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n  }\n  .home-standard::before {\n    position: inherit;\n  }\n  .home-standard .home-standard-area .content .top {\n    padding: 30px;\n  }\n  .home-standard .home-standard-area .content .bottom {\n    padding: 0 30px;\n  }\n  .home-standard .home-standard-area .content .bottom h4 {\n    color: #000;\n  }\n  .home-standard .home-standard-area .content .bottom h6 {\n    color: #000;\n  }\n  .home-standard .home-standard-area .content .bottom a,\n  .home-standard .home-standard-area .content .bottom a:hover {\n    background-color: #000;\n  }\n}\n@media only screen and (max-width: 550px) {\n  .site-logo img {\n    width: 140px;\n  }\n  #video-background.fulltextvid {\n    height: auto !important;\n    width: 100% !important;\n  }\n  .fullimagetop {\n    height: 300px !important;\n  }\n  .halfimagetop {\n    height: 300px;\n  }\n  .csca .csca-icon {\n    width: 100px;\n  }\n}\n@media only screen and (max-width: 500px) {\n  .portfolio-page .portfolio-content .portfolio-content-grid {\n    grid-template-columns: 1fr;\n  }\n  .footerlinks3 .review .mySwiper {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
